import {
  listRules as moderationRulesList,
  listActivities as moderationActivityList,
  listFlaggedMessages as moderationFlaggedMessagesList,
  listReviewedMessages as moderationReviewedMessagesList,
  banSenderOfFlaggedMessage as moderationBanSenderOfFlaggedMessage,
  reviewFlaggedMessage as moderationReviewFlaggedMessage,
  blockFlaggedMessage as moderationBlockFlaggedMessage,
  approveFlaggedMessage as moderationApproveOnlyFlaggedMessage,
  getRule as getModerationRule,
  listRuleRevisions as moderationRuleRevisionsList,
  deleteRule as moderationRuleDelete,
  updateRule as moderationRuleUpdate,
  listKeywords as moderationKeywordsList,
  deleteKeyword as moderationKeywordDelete,
  addKeyword as moderationKeywordAdd,
  updateKeyword as moderationKeywordUpdate,
  getKeyword as moderationKeywordGet,
  listConfiguration as moderationConfigurationList,
  addRule as moderationRuleAdd,
  updateBlockedMessageStatus as moderationUpdateBlockedMessageStatus,
  getGlobalSettings as moderationGetGlobalSettings,
  updateGlobalSettings as moderationUpdateGlobalSettings,
  addCustomCategory,
  getCustomCategories,
  deleteCustomCategory,
  updateCustomCategory,
  getFlaggedUsersOfMessage,
} from 'services/moderation'
import { all, takeEvery, put, call, takeLatest, delay } from 'redux-saga/effects'
import { withCallback, putWait } from 'redux-saga-callback'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { message } from 'antd'
import {
  list,
  get,
  add,
  del,
  update,
  settingsGet,
  settingsUpdate,
  settingsThreadAndConversationGet,
  settingsThreadAndConversationMap,
  updateSettings,
} from 'services/apps'
import {
  list as apikeysList,
  listByScope as apikeysListByScope,
  add as apikeyAdd,
  get as apikeyGet,
  update as apikeyUpdate,
  search as apikeysSearch,
  del as apikeyDelete,
} from 'services/apikeys'
import {
  list as usersList,
  count as usersCount,
  add as userAdd,
  get as userGet,
  update as userUpdate,
  del as userDelete,
  search as usersSearch,
  inactiveSearch as usersInactiveSearch,
  groupList as userGroupList,
  friendList as userFriendList,
  updateFriends as userUpdateFriends,
  userSearch as userFriendSearch,
  groupSearch as userGroupSearch,
  removeFriends as userRemoveFriends,
  authTokenList as userAuthTokenList,
  authTokenDel as userAuthTokenDelete,
  authTokenAdd as userAuthTokenAdd,
  authTokenSearch as userAuthTokensSearch,
  kickFromGroup as kickUserFromGroup,
  banFromGroup as banUserFromGroup,
  addToGroup as addUserToGroup,
  updateScopeInGroup as changeScopeInGroup,
  deactivate as userDeactivate,
  activate as userActivate,
  getMultiple as getMultipleUsers,
  aiAgentUserList as usersAIAgentList,
} from 'services/users'
import {
  list as rolesList,
  add as roleAdd,
  get as roleGet,
  update as roleUpdate,
  del as roleDelete,
  search as rolesSearch,
  listAllPermssions as rolesPermissionsList,
  listPermssionRestrictions as listRoleRestrictions,
  addPermssionRestrictions as addRoleRestriction,
  delPermssionRestrictions as delRoleRestriction,
  listRolePermissionsV2,
  getRolePermissionsV2Values,
  updateRolePermissionsV2,
  resetRolePermissionsV2,
} from 'services/roles'
import {
  list as groupsList,
  add as groupAdd,
  get as groupGet,
  update as groupUpdate,
  del as groupDelete,
  search as groupsSearch,
  searchMembers as groupMemberSearch,
  searchBanMembers as groupBannedMemberSearch,
  members as groupGetMembers,
  getBanMembers as groupGetBannedMembers,
  banMember as groupBanMember,
  kickMember as groupKickMember,
  unbanMember as groupUnbanMember,
  addMembers as addMembersToGroup,
  listGroupScopePermissions,
  getGroupScopePermissionsValues,
  updateGroupScopePermissions,
  resetGroupScopePermission,
} from 'services/groups'
import {
  list as aiAgentsList,
  update as aiAgentUpdate,
  remove as aiAgentRemove,
} from 'services/aiAgents'
import {
  list as aiToolsList,
  getEditForm as aiToolGetEditForm,
  remove as aiToolRemove,
} from 'services/aiTools'

import {
  list as aiAgentsBuilderList,
  get as aiAgentBuilderGet,
  add as aiAgentBuilderAdd,
  update as aiAgentBuilderUpdate,
  remove as aiAgentBuilderRemove,
  searchTools,
  getEnabledItems,
} from 'services/aiAgentsBuilder'
import getAvailableModels from 'services/aiAgentAvailableModels'
import {
  getCredits as aiAgentGetCredits,
  getCreditsSettings as aiAgentGetCreditsSettings,
  saveCreditsSettings as aiAgentSaveCreditsSettings,
  buyCredits as aiAgentBuyCredits,
  getPricing as aiAgentGetPricing,
  getAgenticPlans as aiAgentGetPlans,
  getPendingInvoices as aiAgentGetPendingInvoices,
  retryPayment as aiAgentRetryPayment,
} from 'services/aiAgentCredits'
import {
  list as aiToolsBuilderList,
  getEditForm as aiToolBuilderGetEditForm,
  add as aiToolsBuilderAdd,
  remove as aiToolBuilderRemove,
  getActionWithinTools as aiToolsBuilderGetActions,
  createCustomApiTool as aiToolsBuilderCreateCustomApiTool,
  updateCustomApiTool as aiToolsBuilderUpdateCustomApiTool,
  deleteCustomApiTool as aiToolsBuilderDeleteCustomApiTool,
  listCustomApiTools as aiToolsBuilderListCustomApiTools,
  addApiTool as aiToolsBuilderAddApiTool,
  removeApiTool as aiToolsBuilderRemoveApiTool,
} from 'services/aiToolsBuilder'
import {
  list as aiSystemToolsList,
  add as aiSystemToolsAdd,
  remove as aiSystemToolsRemove,
} from 'services/aiSystemToolsBuilder'
import {
  list as knowledgeBaseList,
  deleteFile as knowledgeBaseDeleteFile,
  getDetails as knowledgeBaseGetDetails,
  sync as knowledgeBaseSync,
  initiateUpload as knowledgeBaseInitiateUpload,
  createTextKnowledgeBaseItem as knowledgeBaseCreateTextItem,
  updateTextKnowledgeBaseItem as knowledgeBaseUpdateTextItem,
  createIndividualLink as knowledgeBaseCreateIndividualLink,
  scrapeWebsite as knowledgeBaseScrapeWebsite,
  processDiscoveredUrls as knowledgeBaseProcessDiscoveredUrls,
  getKnowledgeBaseItem as knowledgeBaseGetItem,
  addSourceToAgent as knowledgeBaseAddSourceToAgent,
  removeSourceFromAgent as knowledgeBaseRemoveSourceFromAgent,
  syncDiscoveredUrls as knowledgeBaseSyncDiscoveredUrls,
} from 'services/knowledgeBase'
import {
  createMcpServer,
  updateMcpServer,
  deleteMcpServer,
  listMcpServers,
  addMcpServer,
  removeMcpServer,
} from 'services/aiAgentsmcpServer'
import {
  list as frontendActionsList,
  create as frontendActionsCreate,
  update as frontendActionsUpdate,
  remove as frontendActionsRemove,
  toggle as frontendActionsToggle,
} from 'services/frontendActions'

// Import builder sagas
import {
  list as extensionsList,
  search as extensionsSearch,
  changeExtensionStatus as extensionChangeStatus,
  removeExtension,
} from 'services/extensions'
import {
  list as webhooksList,
  get as webhookGet,
  add as webhookAdd,
  update as webhookUpdate,
  del as webhookDelete,
  getTriggersByID as webhookTriggersGet,
  addTriggers,
  delTriggers,
} from 'services/webhooks'
import {
  list as newWebhooksList,
  get as newWebhookGet,
  add as newWebhookAdd,
  update as newWebhookUpdate,
  del as newWebhookDelete,
  getTriggersByID as newWebhookTriggersGet,
  newAddTriggers,
  newDelTriggers,
} from 'services/webhooksNew'
import { list as triggersList, listNew as newTriggersList } from 'services/triggers'
import { subscribe, unsubscribe, stripeCall1, stripeCall2 } from 'services/subscriptions'
import { currentAccount, manualOutreach, updateProfile } from 'services/user'
import {
  collaborators as appCollaboratorsList,
  invite as collaboratorAdd,
  remove as collaboratorRemove,
  changeRole as collaboratorChangeRole,
  leave as collaboratorLeave,
  // transferOwnership commented out for now — transfer ownership is handled via manual outreach
  // transferOwnership as collaboratorTransferOwnership,
  search as collaboratorsSearch,
} from 'services/teams'
import {
  getAppMessages as messageLogs,
  searchAppMessages as searchMessageLogs,
  deleteAppMessageLog as msgLogDelete,
  getModerationMessages as modMessageLogs,
  approveModMessageLogs as modMessageLogsApprove,
  rejectModMessageLogs as modMessageLogsReject,
  getGroupMessages as groupMessageLogs,
  deleteGroupMessageLog as groupMsgLogDelete,
  exportAppMessages as exportMessageLogs,
  getAppMessageByID as messageGet,
  getMessageCategories,
} from 'services/messages'
import {
  list as chatWidgetListService,
  add as chatWidgetAdd,
  update as chatWidgetUpdate,
} from 'services/chatWidgets'
import {
  getByType as getMetricsByType,
  getInsightsData,
  getBillingCycleUsage as getBillingCycleUsageMetrics,
  get as getMetrics,
  requestBillingUsage as requestMultiTenantBillingUsage,
} from 'services/metrics'
import {
  get as callLogs,
  downloadRecording as downloadCallRecording,
  getByID as getCallDetail,
} from 'services/callLogs'
import {
  get as callLogsLegacy,
  downloadRecording as downloadCallRecordingLegacy,
  getParticipants as getCallSessionParticipants,
  getByID as getCallDetailLegacy,
} from 'services/callLogsLegacy'

import {
  add as builderAdd,
  list as builderList,
  get as builderGet,
  update as builderUpdate,
  reset as builderReset,
} from 'services/builders'
import { getNotificationLogs } from 'services/notificationsLogs'
import { fetchDynamicData } from 'services/dynamicForm'

import _ from 'lodash'
import Cookies from 'js-cookie'
import numberToWords from 'number-to-words'
import {
  checkIfCustomPlan,
  checkIfCustomOldPlan,
  checkIfLegacyNonCustomPlan,
  checkIfPhase2ActivePlan,
  checkIfOldPlan,
  getPlanName,
  isAppAdmin,
  isAppOwner,
  isAppModerator,
  getAppMetricHost,
  getMetricDayTimestamp,
  getMetricMonthTimestamp,
  getMetricYearTimestamp,
  getMetricHoursTimestamp,
  getMetricMinutesTimestamp,
  getTimestampOfMonth,
  isAuthErrorCode,
  getMetricMonthFromTimestamp,
  checkIfAnalyticsIsSupported,
  checkIfTrialOrExpired,
  checkIfPhase3ActivePlan,
  checkIfFeatureRestricted,
  getAppHost,
  getTrialLeftInDays,
  getTimestampAsFullHumanDateOrdinal,
  getPhase4PlansCostMapFromPaidPlans,
  checkIfNonCustomActivePlan,
  checkBillingType,
  getMetricMonthFromMonthNo,
  getAppCallsHost,
  checkIfFreeEmailDomain,
  isAppDeveloper,
  objectToParams,
  canListInvoices,
  checkIfAiAgentActivePlan,
} from 'helpers'
import customLanguageTexts from 'language'
import actions from './actions'
import constants from '../../constants'

// Removed custom delay helper; using redux-saga/effects delay

/* APPS */

export function* LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      appLoadingInProgress: true,
    },
  })
  let current = 1

  const { appsListPageNo: currentPageState } = reduxStore.getState().apps
  current = currentPageState
  if (payload.currentPage) current = payload.currentPage
  const searchText = reduxStore.getState().apps.appSearchText
  const roleFilterList = payload.appRolesFilter ? payload.appRolesFilter : ''
  const planFilter = reduxStore.getState().apps.appPlanFilter
  const success = yield call(list, current, searchText, roleFilterList, planFilter)
  if (success && success.data) {
    let totalAppCount = success.data.length
    if (success.meta && success.meta.pagination.total && success.meta.pagination) {
      totalAppCount = success.meta.pagination.total
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        data: success.data,
        appsListTotal: totalAppCount,
        appsListPageNo: current,
        active: payload.firstAppData ? payload.firstAppData : [],
        loading: false,
        appLoadingInProgress: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        data: [],
        appsListTotal: 0,
        active: [],
        appsListPageNo: 1,
        loading: false,
        appLoadingInProgress: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      yield put({
        type: 'user/LOGOUT',
      })
    }
  }
}

/* APP SEARCH TEXT */

export function* ENTER_APP_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        appSearchText: '',
        appsListPageNo: 1,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        appSearchText: searchText,
        appsListPageNo: 1,
        loading: true,
      },
    })

    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_APP',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* CLEAR_APP_SEARCH */

// Restores the full list the app switcher reads; leaves `active` and `loading`
// alone because it runs while an app page is loading.
export function* CLEAR_APP_SEARCH() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      appSearchText: '',
      appsListPageNo: 1,
    },
  })

  const success = yield call(list, 1, '')

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        data: success.data,
        appsListTotal: success.meta?.pagination?.total || success.data.length,
      },
    })
  }
}

/* SEARCH_APP */

export function* SEARCH_APP() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const searchText = reduxStore.getState().apps.appSearchText

  const success = yield call(list, 1, searchText)

  if (success && success.data) {
    let totalAppCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalAppCount = success.meta.pagination.total
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        data: success.data,
        appsListTotal: totalAppCount,
        active: [],
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        data: [],
        appsListTotal: 0,
        active: [],
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    }
  }
}

export function* REMOVE_ACTIVE_APP() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      active: [],
      modMessageLogs: [],
      modMessageLogsLoadMoreId: 0,
      modMessageLogsLoading: false,
      stats: [],
      messageLogs: [],
      messageLogsLoadMoreId: 0,
      messageLogsPollingId: 0,
      messageLogsLoading: false,
      chatWidgetsList: [],
      chatWidgetsCombinedList: [],
      chatWidgetAppUrl: false,
      chatWidgetActive: [],
      apikeysList: [],
      apikeysAuthList: [],
      apikeysRestList: [],
      apikeysActive: [],
      apikeySearchText: '',
      apikeyQuickStart: 'API_KEY',
      callLogs: [],
      callLogsLoadMoreId: 0,
      callLogsPollingId: 0,
      callLogsLoading: false,
    },
  })
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

/* APPS */

export function* ADD({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  let region = _.trim(payload.region)
  let version = _.trim(payload.version)
  const { metadata } = payload

  let success = []
  if (payload.region === 'hipaa-us') {
    const post = {
      intent: constants.ManualOutreachIntents['app-create-request-us-hipaa-compliant'],
    }

    success = yield call(manualOutreach, post)
    if (success && success.data) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'appHipaaUSCreated',
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })

      yield put(push(`/apps`))
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_APP_CREATION_FAILED_MAX_LIMIT') {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'appCreationFailed',
          },
        })
      } else if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      } else if (success.error.code !== undefined) {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'appCreationFailedException',
          },
        })
      }
    }
  } else {
    if (region !== 'us' && region !== 'eu' && region !== 'in') region = 'us'
    if (version === undefined) version = '3'

    const post = {
      name: payload.name,
      region,
      version,
      metadata,
    }

    success = yield call(add, post)

    if (success && success.data) {
      const loggedInUserInfo = reduxStore.getState().user
      if (
        loggedInUserInfo.id &&
        loggedInUserInfo.createdAt &&
        loggedInUserInfo.createdAt < constants.featureDeprecatedTimestamps.legacy_widgets
      ) {
        // activate chat -widget extension
        yield call(extensionChangeStatus, 'widget', success.data, 'all')
      }

      // update ga_id and utm
      if (Cookies.get('_ga') || Cookies.get('utm')) {
        let userGaId = ''
        if (Cookies.get('_ga')) {
          userGaId = Cookies.get('_ga')
        }
        let userUtm = {}
        if (Cookies.get('utm')) {
          userUtm = JSON.parse(Cookies.get('utm'))
        }
        let userUtmLast = {}
        if (Cookies.get('utm_last')) {
          userUtmLast = JSON.parse(Cookies.get('utm_last'))
        }
        const gaValuesForUsermeta = {
          meta: { ga_id: userGaId, utm: userUtm, utm_last: userUtmLast },
        }
        const userUpdateMeta = yield call(updateProfile, gaValuesForUsermeta)
        if (userUpdateMeta && userUpdateMeta.data !== undefined) {
          yield put({
            type: 'user/LOAD_CURRENT_ACCOUNT',
            data: userUpdateMeta.data,
          })
        }
      }

      yield put({
        type: 'apps/ENTER_APP_TEXT',
        payload: {
          searchText: '',
          clearText: true,
        },
      })
      yield put({
        type: 'apps/LIST',
        payload: { currentPage: 1 },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: success.data,
          appCreated: success.data,
          loading: false,
        },
      })

      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'congratulations',
          // showModalConfetti: appSearchText === '' && allApps.length === 0,
        },
      })
      yield put(push(`/app/${success.data.id}/overview`))
      localStorage.setItem('cc_lastOpenedApp', success.data.id)
    } else {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'appCreationFailed',
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        yield put(push(`/login`))
      } else if (success.error.code === 'ERR_APP_CREATION_FAILED_MAX_LIMIT') {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'appCreationFailed',
          },
        })
      } else if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      } else if (success.error.code !== undefined) {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'appCreationFailedException',
          },
        })
      }
      yield put(push(`/apps`))
    }
  }
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
  return success
}

/* APPS */

export function* ADD_APP_ON_ONBOARDING({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  let region = _.trim(payload.region)
  let version = _.trim(payload.version)
  const { metadata } = payload

  let success = []

  if (region !== 'us' && region !== 'eu' && region !== 'in') region = 'us'
  if (version === undefined) version = '3'

  const post = {
    name: payload.name,
    region,
    version,
    metadata,
  }
  yield delay(2000)
  // stop showing the loader & redirect to the next screen according to the conditions below
  const loggedInUserInfo = reduxStore.getState().user

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      firstAppCreationInProgress: true,
    },
  })

  if (
    checkIfFreeEmailDomain(loggedInUserInfo.email) ||
    localStorage.getItem('ccPreviewBuilderId')
  ) {
    yield put(push(`/apps`))
  } else {
    yield put({
      type: 'user/UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN',
    })
    yield put(push('/schedule-your-kick-off-call'))
  }

  success = yield call(add, post)

  if (success && success.data) {
    if (
      loggedInUserInfo.id &&
      loggedInUserInfo.createdAt &&
      loggedInUserInfo.createdAt < constants.featureDeprecatedTimestamps.legacy_widgets
    ) {
      // activate chat -widget extension
      yield call(extensionChangeStatus, 'widget', success.data, 'all')
    }

    // update ga_id and utm
    // if (Cookies.get('_ga') || Cookies.get('utm')) {
    //   let userGaId = ''
    //   if (Cookies.get('_ga')) {
    //     userGaId = Cookies.get('_ga')
    //   }
    //   let userUtm = {}
    //   if (Cookies.get('utm')) {
    //     userUtm = JSON.parse(Cookies.get('utm'))
    //   }
    //   let userUtmLast = {}
    //   if (Cookies.get('utm_last')) {
    //     userUtmLast = JSON.parse(Cookies.get('utm_last'))
    //   }
    //   const gaValuesForUsermeta = {
    //     meta: { ga_id: userGaId, utm: userUtm, utm_last: userUtmLast },
    //   }
    //   const userUpdateMeta = yield call(updateProfile, gaValuesForUsermeta)
    //   if (userUpdateMeta && userUpdateMeta.data !== undefined) {
    //     yield put({
    //       type: 'user/LOAD_CURRENT_ACCOUNT',
    //       data: userUpdateMeta.data,
    //     })
    //   }
    // }

    yield put({
      type: 'apps/ENTER_APP_TEXT',
      payload: {
        searchText: '',
        clearText: true,
      },
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: success.data,
        appCreated: success.data,
        firstAppID: success.data.id,
      },
    })

    yield put({
      type: 'apps/LIST',
      payload: { currentPage: 1, firstAppData: success.data },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: 'congratulations',
        // showModalConfetti: appSearchText === '' && allApps.length === 0,
      },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        firstAppCreationInProgress: false,
      },
    })

    localStorage.setItem('cc_lastOpenedApp', success.data.id)
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        showModalConfetti: true,
      },
    })
  } else {
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: 'appCreationFailed',
      },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        firstAppCreationInProgress: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      yield put(push(`/login`))
    } else if (success.error.code === 'ERR_APP_CREATION_FAILED_MAX_LIMIT') {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'appCreationFailed',
        },
      })
    } else if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.code !== undefined) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'appCreationFailedException',
        },
      })
    }
  }

  return success
}

export function* UPDATE_ACTIVE_APP({
  payload: {
    id = 0,
    otherAction = '',
    keyID = '',
    callSource = '',
    fetchAllData = true,
    callSourceRedirectURL = '',
    keyID2 = '',
  },
}) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      appLoadingInProgress: true,
    },
  })
  const { openLastVisitedApp } = reduxStore.getState().user

  const loggedInUserInfo = reduxStore.getState().user
  const currentAccountResponse = yield call(currentAccount, loggedInUserInfo.id)
  if (!(currentAccountResponse && currentAccountResponse.data)) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        appLoadingInProgress: false,
      },
    })
    yield put(push(`/login`))
    return false
  }
  let allCallsProcessed = false
  const appPagePaths = [
    '/app/:appID/quick-start',
    '/app/:appID/credentials',
    '/app/:appID/users',
    '/app/:appID/roles',
    '/app/:appID/groups',
    '/app/:appID/groups/:keyID/edit',
    '/app/:appID/agents',
    '/app/:appID/webhooks-legacy',
    '/app/:appID/webhooks',
    '/app/:appID/extensions',
    '/app/:appID/general',
    '/app/:appID/analytics',
    '/app/:appID/ai',
    '/app/:appID/ai-bots',
    '/app/:appID/ai-features',
    '/app/:appID/ai-instructions',
    '/app/:appID/plans-billing',
    '/app/:appID/overview',
    '/app/:appID/messages',
    '/app/:appID/chats',
    '/app/:appID/chat-features',
    '/app/:appID/chat-settings',
    '/app/:appID/widgets',
    '/app/:appID/in-flight-message-moderation',
    '/app/:appID/group-moderation',
    '/app/:appID/moderation',
    '/app/:appID/moderation/legacy',
    // '/app/:appID/team',
    '/app/:appID/members',
    '/app/:appID/calls',
    '/app/:appID/calls-legacy',
    '/app/:appID/builder/:builderId',
    '/app/:appID/integrate',
    '/app/:appID/ai-agents',
    '/app/:appID/integrate/apis',
    '/app/:appID/notifications',
    '/app/:appID/notifications-legacy',
    '/app/:appID/integrate/sdks',
    '/app/:appID/integrate/ui-kits',
    '/app/:appID/plans-billing',
    '/app/:appID/notifications-logs',
    '/app/:appID/calling-get-started',
    '/app/:appID/ai-agent/get-started',
    '/app/:appID/byo-agent/get-started',
    '/app/:appID/third-party-ai-agents',
    '/app/:appID/third-party-ai-agents/add',
    '/app/:appID/ai-actions',
    '/app/:appID/ai-actions/add',
    '/app/:appID/ai-tools',
    '/app/:appID/ai-tools/add',
    '/app/:appID/messaging-get-started',
    '/app/:appID/ai-agents/:agentUid/tool',
    '/app/:appID/ai-agents/:agentUid/tool/custom-api-tool',
    '/app/:appID/custom-tabs',
    '/app/:appID/conversation-explorer',
  ]
  const checkIfAppPath = _.indexOf(appPagePaths, reduxStore.getState().menu.globalRouteMatch.path)
  if (id === 0) {
    if (checkIfAppPath >= 0) {
      id = reduxStore.getState().menu.globalRouteMatch.params.appID
    }
  }

  if (id !== 0) {
    // Switching apps: clear per-app slices so pages don't show stale data.
    const previousActive = reduxStore.getState().apps.active
    if (previousActive?.id && String(previousActive.id) !== String(id)) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          extensionsAllList: [],
          extensionsInstalledList: [],
          usersActiveCount: 0,
          usersInactiveCount: 0,
          usersTotalCount: 0,
        },
      })
      yield put({
        type: 'ai/SET_STATE',
        payload: { aiList: [], settingsActive: [] },
      })
    }
    let appData = { data: [] }
    let appSettings = { data: [] }
    appData = yield call(get, id)

    if (appData && appData.data) {
      // appData.data.plan = 'meteoroid-(10-19345)'
      if (appData.data.scheduledToDeleteAt && appData.data.state === 'inactive') {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'sheduledTodelete',
          },
        })
      } else if (appData.data.scheduledToDeleteAt === undefined) {
        localStorage.setItem('cc_lastOpenedApp', appData.data.id)
        appSettings = yield call(settingsGet, appData.data.id, appData.data)

        if (isAppOwner(appData.data) || isAppAdmin(appData.data))
          if (callSource === 'appCard' && !isAppModerator(appData.data)) {
            yield put({
              type: 'apps/SET_STATE',
              payload: {
                active: appData.data,
              },
            })
            yield put({
              type: 'apps/GET_METRICS',
              payload: { data: appData.data, appSettings: appSettings.data },
            })
            yield put({
              type: 'apps/API_KEYS_LIST',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })
            yield put({
              type: 'apps/GET_USAGE_AND_OVERAGES',
              payload: { data: appData.data, appSettings: appSettings.data },
            })
            yield put({
              type: 'apps/EXTENSIONS_LIST',
              data: appData.data,
            })
          }

        if (callSource === 'appCard') {
          yield put({
            type: 'apps/GET_MESSAGE_SEARCH_LOGS',
            data: appData.data,
          })
          if (isAppOwner(appData.data)) {
            yield put({
              type: 'plans/GET_PLANS',
            })
          }
        }
        if (fetchAllData && checkIfAppPath >= 0) {
          yield put({
            type: 'apps/SET_STATE',
            payload: {
              active: appData.data,
              appSettings: appSettings.data,
            },
          })
          yield put({
            type: 'apps/TEAM_COLLABORATOR_LIST',
            payload: { currentPage: 1, data: appData.data },
          })

          if (!isAppModerator(appData.data)) {
            yield put({
              type: 'apps/API_KEYS_LIST',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })
          }

          yield put({
            type: 'apps/GET_METRICS',
            payload: { data: appData.data, appSettings: appSettings.data },
          })
          yield put({
            type: 'apps/GET_APP_SETTINGS',
            data: appData.data,
          })
          yield put({
            type: 'apps/GET_APP_MESSAGE_SETTINGS',
            data: appData.data,
          })
          yield put({
            type: 'apps/GET_USAGE_AND_OVERAGES',
            payload: { data: appData.data, appSettings: appSettings.data },
          })

          if (
            callSource !== 'appCard' &&
            otherAction !== 'GET_MESSAGE_LOGS' &&
            otherAction !== 'GET_MOD_MESSAGE_LOGS' &&
            otherAction !== 'CHAT_WIDGETS_LIST'
          ) {
            yield put({
              type: 'apps/USERS_LIST',
              payload: {
                currentPage: 1,
                data: appData.data,
                appSettings: appSettings.data,
              },
            })

            yield put({
              type: 'apps/AI_AGENT_USER_LIST',
              payload: {
                currentPage: 1,
                data: appData.data,
                appSettings: appSettings.data,
              },
            })

            yield put({
              type: 'apps/INACTIVE_USERS_LIST',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })

            if (!isAppModerator(appData.data)) {
              yield put({
                type: 'apps/EXTENSIONS_LIST',
                data: appData.data,
              })
            }

            yield put({
              type: 'apps/ROLES_LIST',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })

            yield put({
              type: 'apps/GROUPS_LIST',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })
            yield put({
              type: 'apps/GROUPS_LIST_FOR_MODERATION',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })

            if (!isAppModerator(appData.data) && appData.data.region !== 'legacy') {
              // Bots are fetched by the Agents page (redux/customBots); fetch-all doesn't load them.
              yield put({
                type: 'apps/WEBHOOKS_LIST',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
              yield put({
                type: 'apps/TRIGGERS_LIST',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
              yield put({
                type: 'apps/WEBHOOKS_LIST_NEW',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
              yield put({
                type: 'apps/TRIGGERS_LIST_NEW',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
              yield put({
                type: 'apps/ROLES_PERMISSIONS_LIST',
                payload: { data: appData.data, appSettings: appSettings.data },
              })
            }
            if (!isAppDeveloper(appData.data) && appData.data.region !== 'legacy') {
              yield put({
                type: 'apps/MODERATION_LIST_DROPPED_MESSAGES',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
              yield put({
                type: 'apps/MODERATION_LIST_RULES',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })

              yield put({
                type: 'apps/MODERATION_LIST_KEYWORDS',
                payload: {
                  currentPage: 1,
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
              yield put({
                type: 'apps/MODERATION_LIST_CONFIGURATION',
                payload: {
                  data: appData.data,
                  appSettings: appSettings.data,
                },
              })
            }
          }

          if (otherAction !== '' && keyID !== '') {
            yield put({
              type: 'apps/SET_STATE',
              payload: {
                active: appData.data,
                // stats: appStatsData.data !== undefined ? appStatsData.data : {},
              },
            })
            if (otherAction === 'GET_MOD_MESSAGE_LOGS' || otherAction === 'CHAT_WIDGETS_LIST') {
              yield put({
                type: 'apps/EXTENSIONS_LIST',
                data: appData.data,
              })
            }

            if (otherAction === 'GET_GROUP_MESSAGE_LOGS') {
              yield put({
                type: 'apps/GET_GROUP_FOR_MODERATION',
                payload: {
                  id: keyID,
                },
              })
            }

            if (otherAction === 'GET_BILLING_HISTORY' && canListInvoices(appData.data)) {
              yield put({
                type: 'billingHistory/GET_BILLING_HISTORY',
                payload: {
                  active: appData.data,
                },
              })
            }
            allCallsProcessed = yield putWait({
              type: `apps/${otherAction}`,
              payload: {
                id: keyID,
                data: appData.data,
                appSettings: appSettings.data,
                currentPage: 1,
                id2: keyID2,
              },
            })
          } else {
            yield put({
              type: 'apps/SET_STATE',
              payload: {},
            })
          }
        } else {
          if (callSource === 'appCard' && isAppModerator(appData.data)) {
            yield put({
              type: 'apps/USERS_LIST',
              payload: {
                currentPage: 1,
                data: appData.data,
                appSettings: appSettings.data,
              },
            })
          } else {
            yield put({
              type: 'apps/API_KEYS_LIST',
              payload: { currentPage: 1, data: appData.data, appSettings: appSettings.data },
            })
          }
          yield put({
            type: 'apps/TEAM_COLLABORATOR_LIST',
            payload: { currentPage: 1, data: appData.data },
          })
          yield put({
            type: 'apps/GET_APP_SETTINGS',
            data: appData.data,
          })
          yield put({
            type: 'apps/GET_APP_MESSAGE_SETTINGS',
            data: appData.data,
          })
          // Include appSettings in store so page components using fetchAllData: false
          // can resolve the correct API host when dispatching their page-specific actions.
          yield put({
            type: 'apps/SET_STATE',
            payload: {
              active: appData.data,
              appSettings: appSettings.data,
              loading: false,
              appLoadingInProgress: false,
            },
          })
          if (callSource === 'appCard' && callSourceRedirectURL !== '') {
            yield put({
              type: 'apps/GET_USAGE_AND_OVERAGES',
              payload: { data: appData.data, appSettings: appSettings.data },
              redirectToIntegrate: true,
              callSourceRedirectURL,
            })
          }

          if (
            callSource === 'appCard' &&
            appData.data.plan !== undefined &&
            appData.data.plan === 'free' &&
            isAppOwner(appData.data)
          ) {
            yield put({
              type: 'settings/SET_STATE',
              payload: {
                visibleModalID: 'appExpired',
              },
            })
          }
        }
      } else {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            active: appData.data,
            loading: false,
            appLoadingInProgress: false,
          },
        })
        if (callSource === 'appCard') {
          yield put(push(`/app/${appData.data.id}/settings`))
        }
      }
    } else {
      if (
        appData.error !== undefined &&
        appData.error.code !== undefined &&
        isAuthErrorCode(appData.error.code)
      ) {
        if (appData.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (appData && appData.error) {
        localStorage.removeItem('cc_lastOpenedApp')
        if (!openLastVisitedApp) {
          yield put({
            type: 'apps/INITIATE_NOTIFICATION',
            payload: { type: 'error', message: appData.errDescription },
          })
          yield put({
            type: 'apps/SET_STATE',
            payload: {
              openLastVisitedApp: false,
              loading: false,
              appLoadingInProgress: false,
            },
          })
        } else {
          yield put({
            type: 'apps/SET_STATE',
            payload: {
              loading: false,
              appLoadingInProgress: false,
            },
          })
        }
      }
      yield put(push(`/apps`))
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: [],
        stats: [],
        teamCollaboratorSearchText: '',
        teamCollaboratorsList: [],
        teamCollaboratorsListTotal: 0,
        loading: false,
        appLoadingInProgress: false,
      },
    })
  }
  return allCallsProcessed
}

export function* GET() {
  yield put({
    type: 'apps/GET',
    payload: {
      loading: true,
      // appLoadingInProgress: true,
    },
  })
}

export function* EDIT({ id, payload, createAppFlow }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { name, metadata, noRedirect, noRedirectSuccessMsg } = payload

  const filtered = { name, metadata }
  let activeApp = reduxStore.getState().apps.active
  if (activeApp.id === undefined) {
    activeApp = reduxStore.getState().apps.appCreated
  }

  if (isAppAdmin(activeApp) || isAppOwner(activeApp) || createAppFlow) {
    const success = yield call(update, id, filtered, activeApp)
    if (success && success.data) {
      const allApps = reduxStore.getState().apps.data
      const appIndex = _.findIndex(allApps, function fn(a) {
        return a.id === activeApp.id
      })
      const appData = yield call(get, id)
      if (appIndex >= 0) {
        allApps[appIndex] = appData.data
      }
      if (noRedirect) {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
            active: appData.data,
          },
        })
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: noRedirectSuccessMsg },
        })
      } else {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
            active: appData.data,
            messageLogs: [],
            callLogs: [],
          },
        })

        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: 'App settings updated successfully' },
        })
      }
    } else if (success && success.error) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.errDescription },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Error Updating the App' },
        })
      }
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Access Denied - Not Authorized' },
    })
    if (isAppModerator(activeApp)) {
      yield put(push(`/app/${activeApp.id}/users`))
    } else yield put(push(`/app/${activeApp.id}/overview`))
  }
  return activeApp
}

export function* DELETE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const { id } = payload

  const success = yield call(del, id, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/ENTER_APP_TEXT',
      payload: {
        searchText: '',
        clearText: true,
      },
    })
    yield put({
      type: 'apps/LIST',
      payload: { currentPage: 1 },
    })

    yield put(push(`/apps`))

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message: 'App scheduled to be deleted after 30 days',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else if (
      (success.error.code !== undefined && success.error.code === 'ERR_BAD_REQUEST') ||
      success.error.code === 'ERR_APP_ARCHIVED'
    )
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Something went wrong' },
      })
    }
  }
}

/* API KEYS */

export function* API_KEYS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areApikeysLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const success = yield call(apikeysList, payload.data, getAppHost(payload.appSettings), 1)

  if (success && success.data) {
    let totalApikeyCount = success.data.length
    let totalApikeyAuthCount = reduxStore.getState().apps.apikeysListAuthTotal
    let totalApikeyRestCount = reduxStore.getState().apps.apikeysListRestTotal
    let apikeyAuthList = reduxStore.getState().apps.apikeysAuthList
    let apikeyRestList = reduxStore.getState().apps.apikeysRestList
    const apikeysAuthPagination = reduxStore.getState().apps.apikeysAuthListPagination
    const apikeysRestPagination = reduxStore.getState().apps.apikeysRestListPagination

    let pageNoAuth = payload.currentPage
    if (pageNoAuth === undefined && apikeysAuthPagination.current_page !== undefined)
      pageNoAuth = apikeysAuthPagination.current_page + 1

    let pageNoRest = payload.currentPage
    if (pageNoRest === undefined && apikeysRestPagination.current_page !== undefined)
      pageNoRest = apikeysRestPagination.current_page + 1

    if (payload.keyScope !== undefined && payload.keyScope === 'authKey') {
      pageNoAuth = payload.currentPage
      pageNoRest = apikeysRestPagination.current_page
    } else if (payload.keyScope !== undefined && payload.keyScope === 'restKey') {
      pageNoRest = payload.currentPage
      pageNoAuth = apikeysAuthPagination.current_page
    }

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalApikeyCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
    }

    let qsKey = 'API_KEY'
    let successRestType = []
    let successAuthType = []

    let apikeysAuthListPagination = apikeysAuthPagination
    let apikeysRestListPagination = apikeysRestPagination

    if (success.data.length > 0) {
      if (payload.scope && (payload.scope === 'restKey' || payload.scope === 'authKey')) {
        if (payload.scope === 'restKey') {
          successRestType = yield call(
            apikeysListByScope,
            payload.data,
            getAppHost(payload.appSettings),
            pageNoRest,
            'fullAccess',
          )
        } else {
          successAuthType = yield call(
            apikeysListByScope,
            payload.data,
            getAppHost(payload.appSettings),
            pageNoAuth,
            'authOnly',
          )
        }
      } else {
        successAuthType = yield call(
          apikeysListByScope,
          payload.data,
          getAppHost(payload.appSettings),
          pageNoAuth,
          'authOnly',
        )

        successRestType = yield call(
          apikeysListByScope,
          payload.data,
          getAppHost(payload.appSettings),
          pageNoRest,
          'fullAccess',
        )
      }

      if (successAuthType && successAuthType.data) {
        apikeyAuthList = successAuthType.data

        totalApikeyAuthCount = successAuthType.data.length

        if (
          successAuthType.meta &&
          successAuthType.meta.pagination &&
          successAuthType.meta.pagination.total_pages
        ) {
          totalApikeyAuthCount =
            successAuthType.meta.pagination.total_pages * successAuthType.meta.pagination.per_page
          apikeysAuthListPagination = successAuthType.meta.pagination
        }

        let qsKeyIndex = _.findLastIndex(success.data, function fn(ak) {
          return _.toLower(_.trim(ak.name)) === 'auth key' && ak.scope === 'authOnly'
        })
        if (qsKeyIndex < 0) {
          qsKeyIndex = _.findLastIndex(success.data, function fn(ak) {
            return ak.scope === 'authOnly'
          })
          if (qsKeyIndex < 0) {
            qsKey = 'API_KEY'
          } else {
            qsKey = success.data[qsKeyIndex].apiKey
          }
        }
      }

      if (successRestType && successRestType.data) {
        apikeyRestList = successRestType.data
        totalApikeyRestCount = successRestType.data.length

        if (
          successRestType.meta &&
          successRestType.meta.pagination &&
          successRestType.meta.pagination.total_pages
        ) {
          totalApikeyRestCount =
            successRestType.meta.pagination.total_pages * successRestType.meta.pagination.per_page
          apikeysRestListPagination = successRestType.meta.pagination
        }
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        appSettings: payload.appSettings,
        apikeysList: success.data,
        apikeysListTotal: totalApikeyCount,
        apikeysAuthList: apikeyAuthList,
        apikeysListAuthTotal: totalApikeyAuthCount,
        apikeysRestList: apikeyRestList,
        apikeysListRestTotal: totalApikeyRestCount,
        apikeysRestListPagination,
        apikeysAuthListPagination,
        apikeyQuickStart: qsKey,
        areApikeysLoading: false,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        appSettings: payload.appSettings,
        apikeysListTotal: 0,
        apikeysList: [],
        apikeysAuthList: [],
        apikeysListAuthTotal: 0,
        apikeysRestList: [],
        apikeysListRestTotal: 0,
        apikeysRestListPagination: {},
        apikeysAuthListPagination: {},
        apikeyQuickStart: 'API_KEY',
        loading: false,
        areApikeysLoading: false,
      },
    })
  }
}

/* APIKEY GET */

export function* GET_APIKEY({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(apikeyGet, id, activeApp, getAppHost(appSettings))
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        apikeysActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${activeApp.id}/credentials`))
  }
}

/* API KEY ADD */

export function* ADD_APIKEY({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const success = yield call(apikeyAdd, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/API_KEYS_LIST',
      payload: {
        currentPage: 1,
        data: activeApp,
        appSettings,
        keyScope: payload.scope === 'authOnly' ? 'authKey' : 'restKey',
      },
    })
    if (!payload.hideNotification) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message: payload.scope === 'authOnly' ? 'Auth Key created.' : 'REST API Key created.',
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      if (!payload.hideNotification) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      }
    }
  }
}

/* API KEY SEARCH TEXT */
export function* ENTER_APIKEY_TEXT({ payload }) {
  const { searchText } = payload
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      apikeySearchText: searchText,
      loading: true,
    },
  })
  if (searchText.length === 0 || searchText.length >= 2) {
    yield put({
      type: 'apps/SEARCH_APIKEY',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

/* SEARCH_APIKEY */

export function* SEARCH_APIKEY() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const searchText = reduxStore.getState().apps.apikeySearchText

  const success = yield call(apikeysSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        apikeysList: success.data,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        loading: false,
      },
    })
  }
}

/* API KEY UPDATE */

export function* UPDATE_APIKEY({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const success = yield call(apikeyUpdate, id, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/API_KEYS_LIST',
      payload: { currentPage: 1, data: activeApp, appSettings },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'API Key saved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}
/* API KEY DELETE */

export function* DELETE_APIKEY({ payload }) {
  const { id, refresh, keyScope } = payload

  const activeApp = reduxStore.getState().apps.active
  const {
    appSettings,
    apikeysAuthListPagination,
    apikeysRestListPagination,
  } = reduxStore.getState().apps
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(apikeyDelete, id, activeApp, getAppHost(appSettings))
  let apiKeysListPageNo = 1
  if (keyScope === 'authKey') {
    apiKeysListPageNo =
      apikeysAuthListPagination !== undefined && apikeysAuthListPagination.count > 1
        ? apikeysAuthListPagination.current_page
        : 1
  } else if (keyScope === 'restKey') {
    apiKeysListPageNo =
      apikeysRestListPagination !== undefined && apikeysRestListPagination.count > 1
        ? apikeysRestListPagination.current_page
        : 1
  }

  if (success && success.data) {
    yield put({
      type: 'apps/API_KEYS_LIST',
      payload: { currentPage: apiKeysListPageNo, data: activeApp, appSettings, keyScope },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `API Key deleted` },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/credentials`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* USERS */

export function* USERS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areUsersLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const filters = payload.filters || {}
  const hasFilters = Object.values(filters).some(v => (Array.isArray(v) ? v.length > 0 : !!v))
  const searchText = hasFilters ? '' : reduxStore.getState().apps.userSearchText
  const usersPagination = reduxStore.getState().apps.usersListPagination

  let pageNo = payload.currentPage
  if (hasFilters && pageNo === undefined) {
    pageNo = 1
  } else if (pageNo === undefined && usersPagination.current_page !== undefined) {
    pageNo = usersPagination.current_page + 1
  }

  // Transform createdAt array into createdAtFrom/createdAtTo for the service
  const serviceFilters = { ...filters }
  if (serviceFilters.createdAt && serviceFilters.createdAt.length === 2) {
    const [fromDate, toDate] = serviceFilters.createdAt
    serviceFilters.createdAtFrom = Math.floor(new Date(`${fromDate}T00:00:00`).getTime() / 1000)
    serviceFilters.createdAtTo = Math.floor(new Date(`${toDate}T23:59:59`).getTime() / 1000)
  }
  delete serviceFilters.createdAt

  const success = yield call(
    usersList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
    0,
    serviceFilters,
  )

  if (success && success.data) {
    let totalUserCount = success.data.length
    let usersListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      usersListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        usersList: success.data,
        usersListTotal: totalUserCount,
        usersListPagination,
        loading: false,
        areUsersLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        usersList: [],
        usersListTotal: 0,
        usersListPagination: [],
        loading: false,
        areUsersLoading: false,
      },
    })
  }
}

/* USERS */

// Sums the per-status counts returned by the `count=1` users endpoint.
// `data` is an array of { status, count } for the unfiltered/multi-status case,
// but collapses to a single { status, count } object when a `status` filter is
// applied — handle both. Anything else (error object, missing data) -> 0.
function sumStatusCounts(response) {
  if (!response || !response.data) return 0
  const groups = Array.isArray(response.data) ? response.data : [response.data]
  return groups.reduce((total, item) => total + (Number(item && item.count) || 0), 0)
}

export function* USERS_COUNT({ payload = {} }) {
  const data = payload.data || reduxStore.getState().apps.active
  const appSettings = payload.appSettings || reduxStore.getState().apps.appSettings

  // Counts need a resolved, non-legacy app: on hard refresh `apps.active` is
  // still {} (the URL would become /apps/undefined/...), and the legacy region
  // has no chat-api counts endpoint. Callers refetch once the app resolves.
  if (!data?.id || data.region === 'legacy') return

  const host = getAppHost(appSettings)

  yield put({
    type: 'apps/SET_STATE',
    payload: { areUserCountsLoading: true },
  })

  try {
    const [activeRes, inactiveRes] = yield all([
      call(usersCount, data, host, 0),
      call(usersCount, data, host, 1),
    ])

    const usersActiveCount = sumStatusCounts(activeRes)
    const usersInactiveCount = sumStatusCounts(inactiveRes)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        usersActiveCount,
        usersInactiveCount,
        usersTotalCount: usersActiveCount + usersInactiveCount,
        areUserCountsLoading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areUserCountsLoading: false },
    })
  }
}

export function* INACTIVE_USERS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const filters = payload.filters || {}
  const hasFilters = Object.values(filters).some(v => (Array.isArray(v) ? v.length > 0 : !!v))
  const searchText = hasFilters ? '' : reduxStore.getState().apps.userInactiveSearchText
  const usersInactivePagination = reduxStore.getState().apps.usersListInactivePagination

  let pageNo = payload.currentPage
  if (hasFilters && pageNo === undefined) {
    pageNo = 1
  } else if (pageNo === undefined && usersInactivePagination.current_page !== undefined) {
    pageNo = usersInactivePagination.current_page + 1
  }

  // Transform createdAt array into createdAtFrom/createdAtTo for the service
  const serviceFilters = { ...filters }
  if (serviceFilters.createdAt && serviceFilters.createdAt.length === 2) {
    const [fromDate, toDate] = serviceFilters.createdAt
    serviceFilters.createdAtFrom = Math.floor(new Date(`${fromDate}T00:00:00`).getTime() / 1000)
    serviceFilters.createdAtTo = Math.floor(new Date(`${toDate}T23:59:59`).getTime() / 1000)
  }
  delete serviceFilters.createdAt

  const success = yield call(
    usersList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
    1,
    serviceFilters,
  )
  let totalUserCount = 0
  if (success && success.data) {
    totalUserCount = success.data.length
    let usersListInactivePagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      usersListInactivePagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        usersInactiveList: success.data,
        usersListInactiveTotal: totalUserCount,
        usersListInactivePagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        usersInactiveList: success.data,
        usersListInactiveTotal: totalUserCount,
        usersListInactivePagination: [],
        loading: false,
      },
    })
  }
}

/* USER GET */

export function* GET_USER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uAuthTokensListPagination } = reduxStore.getState().apps
  const success = yield call(userGet, id, activeApp, getAppHost(appSettings))
  const authTokensRes = yield call(userAuthTokenList, id, activeApp, getAppHost(appSettings))
  const groupsRes = yield call(userGroupList, id, activeApp, getAppHost(appSettings), 1)
  const friendsRes = yield call(userFriendList, id, activeApp, getAppHost(appSettings))
  if (success && success.data) {
    let totalUserGroupCount = groupsRes.data.length
    if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
      totalUserGroupCount =
        groupsRes.meta.pagination.total_pages * groupsRes.meta.pagination.per_page
    }
    let totalUserFriendCount = friendsRes.data.length
    if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
      totalUserFriendCount =
        friendsRes.meta.pagination.total_pages * friendsRes.meta.pagination.per_page
    }
    let userNonFriendsList = reduxStore.getState().apps.usersList

    if (userNonFriendsList.length > 0) {
      userNonFriendsList = _.filter(userNonFriendsList, function fn(unf) {
        return unf.uid !== id
      })
    }

    let totalUAuthTokenCount = authTokensRes.data.length
    let uAuthTokensPagination = uAuthTokensListPagination
    if (
      authTokensRes.meta &&
      authTokensRes.meta.pagination &&
      authTokensRes.meta.pagination.total_pages
    ) {
      totalUAuthTokenCount =
        authTokensRes.meta.pagination.total_pages * authTokensRes.meta.pagination.per_page
      uAuthTokensPagination = authTokensRes.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        usersActive: success.data,
        uAuthTokensList: authTokensRes.data,
        uAuthTokensListTotal: totalUAuthTokenCount,
        uAuthTokensListPagination: uAuthTokensPagination,
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        uFriendsList: friendsRes.data,
        uFriendsListTotal: totalUserFriendCount,
        uFriendsListPagination: friendsRes.meta.pagination,
        userNonGroupsList: reduxStore.getState().apps.groupsList,
        userNonFriendsList,
        groupSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${activeApp.id}/users`))
  }
}

/* USER ADD */

export function* ADD_USER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const filtered = {}
  _.filter(payload, function fn(n, k) {
    if (payload[k] && _.trim(payload[k]) !== '') {
      filtered[k] = n
    }
  })

  const success = yield call(userAdd, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/USERS_LIST',
      payload: {
        currentPage: 1,
        filters: {},
        data: activeApp,
        appSettings,
      },
    })

    yield put({ type: 'apps/USERS_COUNT' })

    yield put(push(`/app/${activeApp.id}/users`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'User added' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* USER SEARCH TEXT */

export function* ENTER_USER_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userSearchText: searchText,
        loading: true,
      },
    })

    if (searchText.length === 0) {
      yield put({
        type: 'apps/USERS_LIST',
        payload: {
          currentPage: 1,
        },
      })
    } else if (searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_USER',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_USER */

export function* SEARCH_USER() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.userSearchText

  const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let totalUserCount = success.data.length
    let usersListPagination = {}
    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalUserCount = success.meta.pagination.total
    }
    if (success.meta && success.meta.pagination) {
      usersListPagination = success.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        usersList: success.data,
        usersListTotal: totalUserCount,
        usersListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        usersListTotal: 0,
        usersListPagination: {},
        loading: false,
      },
    })
  }
}
/* INACTIVE USER SEARCH TEXT */

export function* ENTER_INACTIVE_USER_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userInactiveSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userInactiveSearchText: searchText,
        loading: true,
      },
    })

    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_INACTIVE_USER',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_INACTIVE_USER */

export function* SEARCH_INACTIVE_USER() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.userInactiveSearchText

  const success = yield call(usersInactiveSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let totalUserCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        usersInactiveList: success.data,
        usersListInactiveTotal: totalUserCount,
        usersListInactivePagination: success.meta.pagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        usersListInactiveTotal: 0,
        usersListInactivePagination: {},
        loading: false,
      },
    })
  }
}

/* USER UPDATE */

export function* UPDATE_USER({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const filtered = {}
  const unset = []

  _.filter(payload, function fn(n, k) {
    if (payload[k] && _.trim(payload[k]) !== '') {
      filtered[k] = n
    } else if (k === 'tags') {
      filtered.tags = []
    } else unset.push(k)
  })

  filtered.unset = unset

  const success = yield call(userUpdate, id, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/USERS_LIST',
      payload: { currentPage: 1, data: activeApp, appSettings },
    })

    yield put(push(`/app/${activeApp.id}/users`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'User saved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}
/* USER DELETE */

export function* DELETE_USER({ payload }) {
  const { id, refresh, filters } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, usersListPagination } = reduxStore.getState().apps
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(userDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const userListPageNo =
      usersListPagination !== undefined && usersListPagination.count > 1
        ? usersListPagination.current_page
        : 1
    yield put({
      type: 'apps/USERS_LIST',
      payload: {
        currentPage: userListPageNo,
        filters: filters || {},
        data: activeApp,
        appSettings,
      },
    })
    yield put({ type: 'apps/USERS_COUNT' })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'User Deleted' },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/users`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

// /* DEACTIVATE_USER */

export function* DEACTIVATE_USER({ payload }) {
  const { id, refresh, filters } = payload

  const activeApp = reduxStore.getState().apps.active
  const {
    appSettings,
    usersListPagination,
    usersListInactivePagination,
  } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(userDeactivate, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userSearchText: '',
        userInactiveSearchText: '',
      },
    })
    const userListPageNo =
      usersListPagination !== undefined && usersListPagination.count > 1
        ? usersListPagination.current_page
        : 1
    const userInactiveListPageNo =
      usersListInactivePagination !== undefined && usersListInactivePagination.count < 10
        ? usersListInactivePagination.current_page
        : 1
    yield put({
      type: 'apps/USERS_LIST',
      payload: { currentPage: userListPageNo, filters: filters || {} },
    })
    yield put({
      type: 'apps/INACTIVE_USERS_LIST',
      payload: { currentPage: userInactiveListPageNo },
    })
    yield put({ type: 'apps/USERS_COUNT' })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'User deactivated' },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/users`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

// /* ACTIVATE_USER */

export function* ACTIVATE_USER({ payload }) {
  const { id, refresh, filters } = payload

  const activeApp = reduxStore.getState().apps.active
  const {
    appSettings,
    usersListPagination,
    usersListInactivePagination,
  } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(userActivate, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userSearchText: '',
        userInactiveSearchText: '',
      },
    })
    const userListPageNo =
      usersListPagination !== undefined && usersListPagination.count < 10
        ? usersListPagination.current_page
        : 1

    const userInactiveListPageNo =
      usersListInactivePagination !== undefined && usersListInactivePagination.count > 1
        ? usersListInactivePagination.current_page
        : 1
    yield put({
      type: 'apps/USERS_LIST',
      payload: {
        currentPage: userListPageNo,
      },
    })
    yield put({
      type: 'apps/INACTIVE_USERS_LIST',
      payload: { currentPage: userInactiveListPageNo, filters: filters || {} },
    })
    yield put({ type: 'apps/USERS_COUNT' })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'User activated' },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/users`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* USER AUTH TOKENS */

export function* USER_AUTH_TOKENS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const uAuthTokensPagination = reduxStore.getState().apps.uAuthTokensListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && uAuthTokensPagination.current_page !== undefined)
    pageNo = uAuthTokensPagination.current_page + 1

  const success = yield call(
    userAuthTokenList,
    reduxStore.getState().apps.usersActive.uid,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
  )

  if (success && success.data) {
    let totalUAuthTokenCount = success.data.length
    let uAuthTokensListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUAuthTokenCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      uAuthTokensListPagination = success.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        uAuthTokensList: success.data,
        uAuthTokensListTotal: totalUAuthTokenCount,
        uAuthTokensListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uAuthTokensList: [],
        uAuthTokensListTotal: 0,
        uAuthTokensListPagination: {},
        loading: false,
      },
    })
  }
}

/* USER AUTH TOKEN ADD */

export function* ADD_USER_AUTH_TOKEN({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uAuthTokensListPagination } = reduxStore.getState().apps

  const { uid } = payload

  const success = yield call(userAuthTokenAdd, uid, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const uAuthTokenListPageNo =
      uAuthTokensListPagination !== undefined &&
      uAuthTokensListPagination.count === uAuthTokensListPagination.per_page
        ? uAuthTokensListPagination.current_page + 1
        : uAuthTokensListPagination.current_page

    yield put({
      type: 'apps/USER_AUTH_TOKENS_LIST',
      payload: { currentPage: uAuthTokenListPageNo, data: activeApp },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Auth Token created' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* USER AUTH TOKEN DELETE */

export function* DELETE_USER_AUTH_TOKEN({ payload }) {
  const { authToken, uid, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uAuthTokensListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(
    userAuthTokenDelete,
    authToken,
    uid,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data) {
    const uAuthTokenListPageNo =
      uAuthTokensListPagination !== undefined && uAuthTokensListPagination.count > 1
        ? uAuthTokensListPagination.current_page
        : 1
    yield put({
      type: 'apps/USER_AUTH_TOKENS_LIST',
      payload: { currentPage: uAuthTokenListPageNo, data: activeApp },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Auth Token deleted' },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/users/user/${uid}`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* AUTH TOKEN SEARCH */

export function* ENTER_UAUTHTOKEN_TEXT({ payload }) {
  const { searchText } = payload
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      uAuthTokenSearchText: searchText,
      loading: true,
    },
  })
  if (searchText.length === 0 || searchText.length >= 2) {
    yield put({
      type: 'apps/SEARCH_UAUTHTOKEN',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

/* SEARCH_UAUTHTOKEN */

export function* SEARCH_UAUTHTOKEN() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const activeUser = reduxStore.getState().apps.usersActive

  const searchText = reduxStore.getState().apps.uAuthTokenSearchText

  const success = yield call(
    userAuthTokensSearch,
    activeUser.uid,
    activeApp,
    getAppHost(appSettings),
    searchText,
  )

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        uAuthTokensList: success.data,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        loading: false,
      },
    })
  }
}

/* USER GROUPS */

export function* USER_GROUPS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areGroupsLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const searchText = reduxStore.getState().apps.groupSearchText
  const groupsPagination = reduxStore.getState().apps.groupsListPagination
  const filters = payload.filters || {}

  let pageNo = payload.currentPage
  if (pageNo === undefined && groupsPagination.current_page !== undefined)
    pageNo = groupsPagination.current_page + 1

  const success = yield call(
    groupsList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
    filters,
  )

  if (success && success.data) {
    let totalGroupCount = success.data.length
    let groupsListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      groupsListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        groupsList: success.data,
        groupsListTotal: totalGroupCount,
        groupsListPagination,
        groupsFilters: filters,
        loading: false,
        areGroupsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsList: [],
        groupsListTotal: 0,
        groupsListPagination: [],
        loading: false,
        areGroupsLoading: false,
      },
    })
  }
}

/* USER USER_FRIENDS_LIST */

export function* USER_FRIENDS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.userFriendSearchText
  const uFriendsPagination = reduxStore.getState().apps.uFriendsListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && uFriendsPagination.current_page !== undefined)
    pageNo = uFriendsPagination.current_page + 1

  const success = yield call(
    userFriendList,
    reduxStore.getState().apps.usersActive.uid,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )
  if (success && success.data) {
    let totalUserFriendCount = success.data.length
    let uFriendsListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserFriendCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      uFriendsListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        uFriendsList: success.data,
        uFriendsListTotal: totalUserFriendCount,
        uFriendsListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uFriendsList: [],
        uFriendsListTotal: 0,
        uFriendsListPagination: [],
        loading: false,
      },
    })
  }
}

/* User friend SEARCH TEXT */
export function* ENTER_USER_FRIEND_LIST_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userFriendSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userFriendSearchText: searchText,
        loading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_USER_FRIEND_LIST',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_USER_FRIEND_LIST */

export function* SEARCH_USER_FRIEND_LIST() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.userFriendSearchText
  const success = yield call(
    userFriendSearch,
    reduxStore.getState().apps.usersActive.uid,
    activeApp,
    getAppHost(appSettings),
    searchText,
  )
  if (success && success.data) {
    let userFriendsListTotal = success.data.length

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      userFriendsListTotal = success.meta.pagination.total_pages * success.meta.pagination.per_page
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        uFriendsList: success.data,
        uFriendsListTotal: userFriendsListTotal,
        uFriendsListPagination: success.meta.pagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        uFriendsListTotal: 0,
        uFriendsListPagination: {},
        loading: false,
      },
    })
  }
}

/* GROUP FRIEND SEARCH TEXT */
export function* ENTER_USER_GROUP_LIST_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userGroupSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        userGroupSearchText: searchText,
        loading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_GROUP_FRIEND_LIST',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_USER_FRIEND_LIST */

export function* SEARCH_GROUP_FRIEND_LIST() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.userGroupSearchText
  const success = yield call(
    userGroupSearch,
    reduxStore.getState().apps.usersActive.uid,
    activeApp,
    getAppHost(appSettings),
    searchText,
  )

  if (success && success.data) {
    let totalUserGroupCount = success.data.length

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserGroupCount = success.meta.pagination.total_pages * 10
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        uGroupsList: success.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: success.meta.pagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        uGroupsList: [],
        uGroupsListTotal: 0,
        uGroupsListPagination: {},
        loading: false,
      },
    })
  }
}

/* USER UPDATE FRIENDS */

export function* UPDATE_USER_FRIENDS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const { uid, values } = payload
  const { uFriendsList } = reduxStore.getState().apps

  const success = yield call(userUpdateFriends, uid, values, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    let unfriendUIDs = []
    _.forEach(uFriendsList, function fn1(f) {
      const checkIndex = _.findIndex(values.accepted, function fn2(a) {
        return a === f.uid
      })
      if (checkIndex < 0) unfriendUIDs = _.concat(unfriendUIDs, f.uid)
    })

    if (unfriendUIDs.length) {
      yield call(userRemoveFriends, uid, unfriendUIDs, activeApp, getAppHost(appSettings))
    }

    const friendsRes = yield call(userFriendList, uid, activeApp, getAppHost(appSettings))

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uFriendsList: friendsRes.data,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Friends updated!' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* ADD_FRIEND_TO_USER */

export function* ADD_FRIEND_TO_USER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uFriendsListPagination } = reduxStore.getState().apps

  const { uid } = reduxStore.getState().apps.usersActive
  const { addFriendUID } = payload

  const success = yield call(
    userUpdateFriends,
    uid,
    addFriendUID,
    activeApp,
    getAppHost(appSettings),
  )
  if (
    success &&
    success.data &&
    success.data.accepted !== undefined &&
    success.data.accepted[addFriendUID.accepted] !== undefined &&
    success.data.accepted[addFriendUID.accepted].success
  ) {
    const friendsListPageNo =
      uFriendsListPagination !== undefined ? uFriendsListPagination.current_page : 1
    const friendsRes = yield call(
      userFriendList,
      uid,
      activeApp,
      getAppHost(appSettings),
      friendsListPageNo,
    )
    let totalUserFriendCount = friendsRes.data.length
    if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
      totalUserFriendCount =
        friendsRes.meta.pagination.total_pages * friendsRes.meta.pagination.per_page
    }

    yield put({
      type: 'apps/SEARCH_USER_FRIEND',
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uFriendsList: friendsRes.data,
        uFriendsListTotal: totalUserFriendCount,
        uFriendsListPagination: friendsRes.meta.pagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Friend added to this user' },
    })
  } else {
    const friendsRes = yield call(userFriendList, uid, activeApp, getAppHost(appSettings))
    let totalUserFriendCount = friendsRes.data.length
    if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
      totalUserFriendCount = friendsRes.meta.pagination.total_pages * 10
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        friendUserSearchText: '',
      },
    })
    yield put({
      type: 'apps/SEARCH_USER_FRIEND',
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uFriendsList: friendsRes.data,
        uFriendsListTotal: totalUserFriendCount,
        uFriendsListPagination: friendsRes.meta.pagination,
        loading: false,
      },
    })
    if (
      success &&
      success.data &&
      success.data.accepted !== undefined &&
      success.data.accepted[addFriendUID.accepted] !== undefined &&
      !success.data.accepted[addFriendUID.accepted].success &&
      success.data.accepted[addFriendUID.accepted].message !== undefined
    ) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.data.accepted[addFriendUID.accepted].message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* KICK FROM GROUPS */

export function* KICK_USER_FROM_GROUP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uGroupsListPagination } = reduxStore.getState().apps

  const { uid } = reduxStore.getState().apps.usersActive
  const { kickGUID } = payload

  const success = yield call(kickUserFromGroup, uid, kickGUID, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const groupsListPageNo =
      uGroupsListPagination !== undefined && uGroupsListPagination.count > 1
        ? uGroupsListPagination.current_page
        : 1

    const groupsRes = yield call(
      userGroupList,
      uid,
      activeApp,
      getAppHost(appSettings),
      groupsListPageNo,
    )
    let totalUserGroupCount = 0
    if (groupsRes.data.length) {
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `User removed from group` },
    })
  } else {
    const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
    let totalUserGroupCount = 0
    if (groupsRes.data.length) {
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount =
          groupsRes.meta.pagination.total_pages * groupsRes.meta.pagination.per_page
      }
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        loading: false,
      },
    })
    if (success.error.message !== undefined) {
      if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Owner cannot be kicked' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      }
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* BAN_USER_FROM_GROUP FROM GROUPS */

export function* BAN_USER_FROM_GROUP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const { uid, name } = reduxStore.getState().apps.usersActive
  const { guid } = payload

  const success = yield call(banUserFromGroup, uid, guid, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
    let totalUserGroupCount = 0
    if (groupsRes.data.length) {
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `${name} banned from group` },
    })
  } else {
    const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
    let totalUserGroupCount = 0
    if (groupsRes.data.length) {
      if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
        totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
      }
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        loading: false,
      },
    })
    if (success.error.message !== undefined) {
      if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Owner cannot be banned' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Error while banning member' },
        })
      }
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
  }
  return success
}

/* ADD TO GROUPS */

export function* ADD_USER_TO_GROUP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uGroupsListPagination } = reduxStore.getState().apps

  const { uid, name } = reduxStore.getState().apps.usersActive
  const { addGUID } = payload

  const success = yield call(addUserToGroup, uid, addGUID, activeApp, getAppHost(appSettings))
  if (
    success &&
    success.data &&
    success.data.participants !== undefined &&
    success.data.participants[uid] !== undefined &&
    success.data.participants[uid].success
  ) {
    const groupsListPageNo =
      uGroupsListPagination !== undefined ? uGroupsListPagination.current_page : 1
    const groupsRes = yield call(
      userGroupList,
      uid,
      activeApp,
      getAppHost(appSettings),
      groupsListPageNo,
    )
    let totalUserGroupCount = groupsRes.data.length
    if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
      totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
    }

    yield put({
      type: 'apps/SEARCH_USER_GROUP',
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `${name} added to group` },
    })
  } else if (
    success &&
    success.data &&
    success.data.participants !== undefined &&
    success.data.participants[uid] !== undefined &&
    !success.data.participants[uid].success
  ) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Already a Member' },
    })
  } else {
    const groupsRes = yield call(userGroupList, uid, activeApp, getAppHost(appSettings))
    let totalUserGroupCount = groupsRes.data.length
    if (groupsRes.meta && groupsRes.meta.pagination && groupsRes.meta.pagination.total_pages) {
      totalUserGroupCount = groupsRes.meta.pagination.total_pages * 10
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupUserSearchText: '',
      },
    })
    yield put({
      type: 'apps/SEARCH_USER_GROUP',
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uGroupsList: groupsRes.data,
        uGroupsListTotal: totalUserGroupCount,
        uGroupsListPagination: groupsRes.meta.pagination,
        loading: false,
      },
    })

    if (success.error.message !== undefined) {
      if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'GROUP ACTION NOT ALLOWED' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      }
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* ROLES */

export function* ROLES_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areRolesLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const searchText = reduxStore.getState().apps.roleSearchText
  const rolesPagination = reduxStore.getState().apps.rolesListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && rolesPagination.current_page !== undefined)
    pageNo = rolesPagination.current_page + 1

  const success = yield call(
    rolesList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  if (success && success.data) {
    let totalRoleCount = success.data.length
    let rolesListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalRoleCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      rolesListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        rolesList: success.data,
        rolesListTotal: totalRoleCount,
        rolesListPagination,
        loading: false,
        areRolesLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesList: [],
        rolesListTotal: 0,
        rolesListPagination: [],
        loading: false,
        areRolesLoading: false,
      },
    })
  }
}

/* ROLE GET */

export function* GET_ROLE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(roleGet, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${activeApp.id}/roles`))
  }
}

/* ROLE ADD */

export function* ADD_ROLE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const filtered = {}
  _.filter(payload, function fn(n, k) {
    if (payload[k] && _.trim(payload[k]) !== '') {
      filtered[k] = n
    }
  })
  const success = yield call(roleAdd, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/ROLES_LIST',
      payload: { currentPage: 1, data: activeApp, appSettings },
    })

    yield put(push(`/app/${activeApp.id}/roles`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Role Added' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'Error', message: 'Unknown Error' },
      })
    }
  }
}

/* ROLE SEARCH TEXT */
export function* ENTER_ROLE_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        roleSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        roleSearchText: searchText,
        loading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_ROLE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_ROLE */

export function* SEARCH_ROLE() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.roleSearchText

  const success = yield call(rolesSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let totalRoleCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalRoleCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        rolesList: success.data,
        rolesListTotal: totalRoleCount,
        rolesListPagination: success.meta.pagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        rolesListTotal: 0,
        rolesListPagination: {},
        loading: false,
      },
    })
  }
}

/* ROLE UPDATE */

export function* UPDATE_ROLE({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const filtered = {}
  const unset = []
  _.filter(payload, function fn(n, k) {
    if (payload[k] && _.trim(payload[k]) !== '') {
      filtered[k] = n
    } else {
      unset.push(k)
    }
  })
  filtered.unset = unset
  const success = yield call(roleUpdate, id, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/ROLES_LIST',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/roles`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Role Saved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
  }
}
/* ROLE DELETE */

export function* DELETE_ROLE({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, rolesListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(roleDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const roleListPageNo =
      rolesListPagination !== undefined && rolesListPagination.count > 1
        ? rolesListPagination.current_page
        : 1
    yield put({
      type: 'apps/ROLES_LIST',
      payload: { currentPage: roleListPageNo, data: activeApp, appSettings },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Role deleted' },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/roles`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.code === 'ERR_ROLE_DELETE_DENIED') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Deleting Role denied' },
      })
    }
  }
}

/* GROUPS */

export function* GROUPS_LIST_FOR_MODERATION({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const searchText = reduxStore.getState().apps.groupModerationSearchText
  const success = yield call(
    groupsList,
    payload.data,
    getAppHost(payload.appSettings),
    payload.currentPage,
    searchText,
  )

  if (success && success.data) {
    let totalGroupCount = success.data.length

    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalGroupCount = success.meta.pagination.total
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        groupsModerationList: success.data,
        groupsModerationListTotal: totalGroupCount,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsModerationList: [],
        groupsModerationListTotal: 0,
        loading: false,
      },
    })
  }
}

/* GROUPS */

export function* GROUPS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areGroupsLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const searchText = reduxStore.getState().apps.groupSearchText
  const groupsPagination = reduxStore.getState().apps.groupsListPagination
  const filters = payload.filters || {}

  let pageNo = payload.currentPage
  if (pageNo === undefined && groupsPagination.current_page !== undefined)
    pageNo = groupsPagination.current_page + 1

  // Transform filters for the service
  const serviceFilters = { ...filters }

  // Transform createdAt array into createdAtFrom/createdAtTo
  if (serviceFilters.createdAt && serviceFilters.createdAt.length === 2) {
    const [fromDate, toDate] = serviceFilters.createdAt
    serviceFilters.createdAtFrom = Math.floor(new Date(`${fromDate}T00:00:00`).getTime() / 1000)
    serviceFilters.createdAtTo = Math.floor(new Date(`${toDate}T23:59:59`).getTime() / 1000)
  }
  delete serviceFilters.createdAt

  // Transform guids array
  if (serviceFilters.guids && Array.isArray(serviceFilters.guids)) {
    if (serviceFilters.guids.length === 1) {
      const [guid] = serviceFilters.guids
      serviceFilters.guid = guid
      delete serviceFilters.guids
    }
  }

  // Transform type array to single value
  if (serviceFilters.type && Array.isArray(serviceFilters.type) && serviceFilters.type.length > 0) {
    const [typeValue] = serviceFilters.type
    serviceFilters.type = typeValue
  }

  // Transform membersCount from ['operator:value'] to { operator, value }
  if (
    serviceFilters.membersCount &&
    Array.isArray(serviceFilters.membersCount) &&
    serviceFilters.membersCount.length > 0
  ) {
    const [entry] = serviceFilters.membersCount
    const [operator, value] = entry.split(':')
    serviceFilters.membersCount = {
      operator,
      value: parseInt(value, 10),
    }
  }

  const success = yield call(
    groupsList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
    serviceFilters,
  )

  if (success && success.data) {
    let totalGroupCount = success.data.length
    let groupsListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      groupsListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        groupsList: success.data,
        groupsListTotal: totalGroupCount,
        groupsListPagination,
        groupsFilters: filters,
        loading: false,
        areGroupsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsList: [],
        groupsListTotal: 0,
        groupsListPagination: [],
        loading: false,
        areGroupsLoading: false,
      },
    })
  }
}
/* GROUP ADD */

export function* ADD_GROUP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const filtered = {}
  _.filter(payload, function fn(n, k) {
    if (payload[k] && _.trim(payload[k]) !== '') {
      filtered[k] = n
    }
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupAdd, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/GROUPS_LIST',
      payload: { currentPage: 1, filters: {}, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/groups`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message: 'Group added',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

/* GROUP GET */

export function* GET_GROUP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupGet, id, activeApp, getAppHost(appSettings))
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${activeApp.id}/groups`))
  }
}

/* GROUP GET MEMBERS */

export function* GET_GROUP_MEMBERS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { id } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const searchText = reduxStore.getState().apps.groupMemberSearchText
  const groupMemberPagination = reduxStore.getState().apps.groupMembersListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && groupMemberPagination.current_page !== undefined)
    pageNo = groupMemberPagination.current_page + 1

  const success = yield call(
    groupGetMembers,
    id,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  // The search text changed while this request was in flight; a newer
  // GET_GROUP_MEMBERS/SEARCH_GROUP_MEMBER owns the list now.
  if (reduxStore.getState().apps.groupMemberSearchText !== searchText) return

  if (success && success.data) {
    let totalGroupMemberCount = success.data.length
    let groupMembersListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupMemberCount = success.meta.pagination.per_page * success.meta.pagination.total_pages
      groupMembersListPagination = success.meta.pagination
    }
    const groupData = yield call(groupGet, id, payload.data, getAppHost(payload.appSettings))

    if (reduxStore.getState().apps.groupMemberSearchText !== searchText) return

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsActive: groupData.data,
        groupMembersList: success.data,
        groupMembersListTotal: totalGroupMemberCount,
        groupMembersListPagination,
        loading: false,
      },
    })
  } else {
    // Null-safe: a failed request may have no `error` shape at all — the
    // loading:false reset below must still run or the spinner never clears.
    if (success?.error?.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success?.error?.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
    yield put(push(`/app/${payload.data.id}/groups`))
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        groupMembersList: [],
        groupMembersListTotal: 0,
        groupMembersListPagination: [],
      },
    })
  }
}

export function* ENTER_GROUP_MEMBER_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupMemberSearchText: '',
        loading: false,
      },
    })
    const { guid } = reduxStore.getState().apps.groupsActive

    yield put({
      type: 'apps/GET_GROUP_MEMBERS',
      payload: {
        id: guid,
        currentPage: 1,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupMemberSearchText: searchText,
        loading: true,
      },
    })
    // Debounce: the watcher uses takeLatest, so a newer keystroke cancels this
    // saga during the delay — only the final text in a burst fires a request.
    yield delay(300)
    // Trigger the search for any input length, including a single character.
    yield put({
      type: 'apps/SEARCH_GROUP_MEMBER',
      payload: {
        loading: false,
      },
    })
  }
}

/* GROUP_SEARCH */

export function* SEARCH_GROUP_MEMBER() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const activeGroup = reduxStore.getState().apps.groupsActive

  const searchText = reduxStore.getState().apps.groupMemberSearchText

  const pageNo = 1

  const success = yield call(
    groupMemberSearch,
    activeGroup.guid,
    searchText,
    activeApp,
    getAppHost(appSettings),
    pageNo,
  )

  // The search text changed while this request was in flight; a newer
  // GET_GROUP_MEMBERS/SEARCH_GROUP_MEMBER owns the list now.
  if (reduxStore.getState().apps.groupMemberSearchText !== searchText) return

  if (success && success.data) {
    let totalGroupMemberCount = success.data.length
    let groupMembersListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupMemberCount = success.meta.pagination.per_page * success.meta.pagination.total_pages
      groupMembersListPagination = success.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsActive: activeGroup,
        groupMembersList: success.data,
        groupMembersListTotal: totalGroupMemberCount,
        groupMembersListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsActive: activeGroup,
        groupMembersList: [],
        groupMembersListTotal: 0,
        groupMembersListPagination: [],
        loading: false,
      },
    })
  }
}

/* GROUP GET BANNED MEMBERS */

export function* GET_BANNED_GROUP_MEMBERS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const searchText = reduxStore.getState().apps.groupBannedMemberSearchText
  const groupBannedMemberPagination = reduxStore.getState().apps.groupBannedMembersListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && groupBannedMemberPagination.current_page !== undefined)
    pageNo = groupBannedMemberPagination.current_page + 1

  const success = yield call(
    groupGetBannedMembers,
    id,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  if (success && success.data) {
    let totalGroupBannedMemberCount = success.data.length

    let groupBannedMembersListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupBannedMemberCount =
        success.meta.pagination.per_page * success.meta.pagination.total_pages
      groupBannedMembersListPagination = success.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupBannedMembersList: success.data,
        groupBannedMembersListTotal: totalGroupBannedMemberCount,
        groupBannedMembersListPagination,
        loading: false,
      },
    })
  } else {
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
    // yield put(push(`/app/${payload.data.id}/groups/members`))
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        groupBannedMembersListTotal: 0,
        groupBannedMembersListPagination: [],
      },
    })
  }
}

export function* ENTER_BANNED_GROUP_MEMBER_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupBannedMemberSearchText: '',
        loading: false,
      },
    })
    const { guid } = reduxStore.getState().apps.groupsActive
    yield put({
      type: 'apps/GET_BANNED_GROUP_MEMBERS',
      payload: {
        id: guid,
        currentPage: 1,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupBannedMemberSearchText: searchText,
        loading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_BANNED_GROUP_MEMBER',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* GROUP_SEARCH */

export function* SEARCH_BANNED_GROUP_MEMBER() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const activeGroup = reduxStore.getState().apps.groupsActive

  const searchText = reduxStore.getState().apps.groupBannedMemberSearchText

  const success = yield call(
    groupBannedMemberSearch,
    activeGroup.guid,
    searchText,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data) {
    let totalGroupBannedMemberCount = success.data.length

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupBannedMemberCount =
        success.meta.pagination.per_page * success.meta.pagination.total_pages
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsActive: activeGroup,
        groupBannedMembersList: success.data,
        groupBannedMembersListTotal: totalGroupBannedMemberCount,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsActive: activeGroup,
        groupBannedMembersList: [],
        groupBannedMembersListTotal: 0,
        loading: false,
      },
    })
  }
}

/* BAN GROUP MEMBER */

export function* BAN_GROUP_MEMBER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { uid, guid } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupBanMember, uid, guid, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const groupMemberPagination = reduxStore.getState().apps.groupMembersListPagination
    const groupMembersListPrev = reduxStore.getState().apps.groupMembersList
    const currentPageItemCount = groupMembersListPrev.length
    const pageNo =
      groupMemberPagination.current_page !== undefined && currentPageItemCount !== 1
        ? groupMemberPagination.current_page
        : 1
    const pageNoForBannedGroupMembers = 1

    const memberSuccess = yield call(
      groupGetMembers,
      guid,
      activeApp,
      getAppHost(appSettings),
      pageNo,
    )

    const bannedMemberSuccess = yield call(
      groupGetBannedMembers,
      guid,
      activeApp,
      getAppHost(appSettings),
      pageNoForBannedGroupMembers,
    )
    const groupData = yield call(groupGet, guid, activeApp, getAppHost(appSettings))
    let totalGroupMemberCount = memberSuccess.data.length
    let totalBannedGroupMemberCount = bannedMemberSuccess.data.length

    let groupMembersListPagination = []
    let groupBannedMembersListPagination = []

    if (
      memberSuccess.meta &&
      memberSuccess.meta.pagination &&
      memberSuccess.meta.pagination.total_pages
    ) {
      totalGroupMemberCount =
        memberSuccess.meta.pagination.per_page * memberSuccess.meta.pagination.total_pages
      groupMembersListPagination = memberSuccess.meta.pagination
    }

    if (
      bannedMemberSuccess.meta &&
      bannedMemberSuccess.meta.pagination &&
      bannedMemberSuccess.meta.pagination.total_pages
    ) {
      totalBannedGroupMemberCount =
        bannedMemberSuccess.meta.pagination.per_page *
        bannedMemberSuccess.meta.pagination.total_pages
      groupBannedMembersListPagination = bannedMemberSuccess.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsActive: groupData.data,
        groupMembersList: memberSuccess.data,
        groupBannedMembersList: bannedMemberSuccess.data,
        groupMembersListTotal: totalGroupMemberCount,
        groupBannedMembersListTotal: totalBannedGroupMemberCount,
        groupMembersListPagination,
        groupBannedMembersListPagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      // payload: { type: 'success', message: success.data.message },
      payload: { type: 'success', message: 'User has been banned' },
    })
  } else {
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'User cannnot be banned' },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown error' },
      })
      yield put(push(`/app/${activeApp.id}/groups`))
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    return false
  }
}

/* UNBAN GROUP MEMBER */

export function* UNBAN_GROUP_MEMBER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { uid, guid } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupUnbanMember, uid, guid, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const groupBannedMemberPagination = reduxStore.getState().apps.groupBannedMembersListPagination
    const pageNoForGroupMembers = 1

    const memberSuccess = yield call(
      groupGetMembers,
      guid,
      activeApp,
      getAppHost(appSettings),
      pageNoForGroupMembers,
    )
    const groupBannedMembersListPrev = reduxStore.getState().apps.groupBannedMembersList

    const currentPageItemCount = groupBannedMembersListPrev.length
    const pageNo =
      groupBannedMemberPagination.current_page !== undefined && currentPageItemCount !== 1
        ? groupBannedMemberPagination.current_page
        : 1

    const bannedMemberSuccess = yield call(
      groupGetBannedMembers,
      guid,
      activeApp,
      getAppHost(appSettings),
      pageNo,
    )
    const groupData = yield call(groupGet, guid, activeApp, getAppHost(appSettings))
    let totalGroupMemberCount = memberSuccess.data.length
    let totalBannedGroupMemberCount = bannedMemberSuccess.data.length
    let groupMembersListPagination = []
    let groupBannedMembersListPagination = []
    if (
      memberSuccess.meta &&
      memberSuccess.meta.pagination &&
      memberSuccess.meta.pagination.total_pages
    ) {
      totalGroupMemberCount =
        memberSuccess.meta.pagination.per_page * memberSuccess.meta.pagination.total_pages
      groupMembersListPagination = memberSuccess.meta.pagination
    }
    if (
      bannedMemberSuccess.meta &&
      bannedMemberSuccess.meta.pagination &&
      bannedMemberSuccess.meta.pagination.total_pages
    ) {
      totalBannedGroupMemberCount =
        bannedMemberSuccess.meta.pagination.per_page *
        bannedMemberSuccess.meta.pagination.total_pages
      groupBannedMembersListPagination = bannedMemberSuccess.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsActive: groupData.data,
        groupMembersList: memberSuccess.data,
        groupBannedMembersList: bannedMemberSuccess.data,
        groupMembersListTotal: totalGroupMemberCount,
        groupBannedMembersListTotal: totalBannedGroupMemberCount,
        groupMembersListPagination,
        groupBannedMembersListPagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      // payload: { type: 'success', message: success.data.message },
      payload: { type: 'success', message: 'User has been unbanned' },
    })
  } else {
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'User could not be unbanned' },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Unknown Error' },
      })

      yield put(push(`/app/${activeApp.id}/groups/${guid}`))
    }

    return false
  }
}

/* KICK_GROUP_MEMBER */

export function* KICK_GROUP_MEMBER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { uid, guid } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupKickMember, uid, guid, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const groupMemberPagination = reduxStore.getState().apps.groupMembersListPagination
    const groupMembersListPrev = reduxStore.getState().apps.groupMembersList

    const currentPageItemCount = groupMembersListPrev.length
    const pageNo =
      groupMemberPagination.current_page !== undefined && currentPageItemCount !== 1
        ? groupMemberPagination.current_page
        : 1
    const memberSuccess = yield call(
      groupGetMembers,
      guid,
      activeApp,
      getAppHost(appSettings),
      pageNo,
    )
    const groupData = yield call(groupGet, guid, activeApp, getAppHost(appSettings))
    let totalGroupMemberCount = memberSuccess.data.length
    let groupMembersListPagination = []
    if (
      memberSuccess.meta &&
      memberSuccess.meta.pagination &&
      memberSuccess.meta.pagination.total_pages
    ) {
      totalGroupMemberCount =
        memberSuccess.meta.pagination.per_page * memberSuccess.meta.pagination.total_pages
      groupMembersListPagination = memberSuccess.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsActive: groupData.data,
        groupMembersList: memberSuccess.data,
        groupMembersListTotal: totalGroupMemberCount,
        groupMembersListPagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      // payload: { type: 'success', message: success.data.message },
      payload: { type: 'success', message: 'User has been removed' },
    })
  } else {
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        // payload: { type: 'error', message: 'Error Kicking Member' },
        payload: { type: 'error', message: 'User could not be removed' },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
      yield put(push(`/app/${activeApp.id}/groups/${guid}`))
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    return false
  }
}

/* GROUP UPDATE */

export function* UPDATE_GROUP({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const filtered = {}
  const unset = []
  _.filter(payload, function fn(n, k) {
    if (payload[k] && _.trim(payload[k]) !== '') {
      filtered[k] = n
    } else {
      unset.push(k)
    }
  })
  filtered.unset = unset
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupUpdate, id, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/GROUPS_LIST',
      payload: { currentPage: 1, data: activeApp },
    })
    yield put(push(`/app/${activeApp.id}/groups`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Group saved` },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Uknown Error' },
      })
    }
  }
}

/* GROUP DELETE */

export function* DELETE_GROUP({ payload }) {
  const { id, refresh, filters } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, groupsListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(groupDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const groupListPageNo =
      groupsListPagination !== undefined && groupsListPagination.count > 1
        ? groupsListPagination.current_page
        : 1
    yield put({
      type: 'apps/GROUPS_LIST',
      payload: { currentPage: groupListPageNo, filters: filters || {}, data: activeApp },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Group deleted` },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/groups`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

export function* ENTER_USER_GROUP_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupUserSearchText: '',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupUserSearchText: searchText,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_USER_GROUP',
      })
    }
  }
}

/* GROUP_USER_SEARCH */

export function* SEARCH_USER_GROUP() {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.groupUserSearchText

  const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        userNonGroupsList: success.data,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        userNonGroupsList: [],
      },
    })
  }
}

export function* ENTER_GROUP_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupSearchText: searchText,
        loading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_GROUP',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

export function* ENTER_GROUP_TEXT_FOR_MODERATION({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupModerationSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupModerationSearchText: searchText,
        loading: true,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_GROUP_FOR_MODERATION',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

export function* GET_GROUP_FOR_MODERATION({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(groupGet, id, activeApp, getAppHost(appSettings))
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupsModerationActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${activeApp.id}/group-moderation`))
  }
}

/* GROUP_SEARCH */

export function* SEARCH_GROUP() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.groupSearchText

  const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let totalGroupCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsList: success.data,
        groupsListTotal: totalGroupCount,
        groupsListPagination: success.meta.pagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsListTotal: 0,
        groupsListPagination: {},
        loading: false,
      },
    })
  }
}

/* GROUP_SEARCH */

export function* SEARCH_GROUP_FOR_MODERATION() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.groupModerationSearchText

  const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let totalGroupCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalGroupCount = success.meta.pagination.total
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsModerationList: success.data,
        groupsModerationListTotal: totalGroupCount,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        groupsModerationListTotal: 0,
        loading: false,
      },
    })
  }
}
/* TRIGGERS */

export function* TRIGGERS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const success = yield call(
    triggersList,
    payload.data,
    getAppHost(payload.appSettings),
    payload.currentPage,
  )

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        triggersList: success.data,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        triggersList: [],
        loading: false,
      },
    })
  }
}

export function* TRIGGERS_LIST_NEW({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const success = yield call(
    newTriggersList,
    payload.data,
    getAppHost(payload.appSettings),
    payload.currentPage,
  )

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        newTriggersList: success.data,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        newTriggersList: [],
        loading: false,
      },
    })
  }
}

/* WEBHOOKS */

export function* WEBHOOKS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areWebhooksLegacyLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.roleSearchText

  const webhooksPagination = reduxStore.getState().apps.webhooksListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && webhooksPagination.current_page !== undefined)
    pageNo = webhooksPagination.current_page + 1

  const success = yield call(
    webhooksList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  if (success && success.data) {
    let totalWebhookCount = success.data.length
    let webhooksListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalWebhookCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      webhooksListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        webhooksList: success.data,
        webhooksListTotal: totalWebhookCount,
        webhooksListPagination,
        loading: false,
        areWebhooksLegacyLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        webhooksList: [],
        webhooksListTotal: 0,
        webhooksListPagination: [],
        loading: false,
        areWebhooksLegacyLoading: false,
      },
    })
  }
}
export function* WEBHOOKS_LIST_NEW({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areWebhooksLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.roleSearchText

  const newWebhooksPagination = reduxStore.getState().apps.newWebhooksListPagination
  let pageNo = payload.currentPage
  if (pageNo === undefined && newWebhooksPagination.current_page !== undefined)
    pageNo = newWebhooksPagination.current_page + 1

  const success = yield call(
    newWebhooksList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )
  if (success && success.data) {
    let totalWebhookCount = success.data.length
    let newWebhooksListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalWebhookCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      newWebhooksListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        newWebhooksList: success.data,
        newWebhooksListTotal: totalWebhookCount,
        newWebhooksListPagination,
        loading: false,
        areWebhooksLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        newWebhooksList: [],
        newWebhooksListTotal: 0,
        newWebhooksListPagination: [],
        loading: false,
        areWebhooksLoading: false,
      },
    })
  }
}

/* WEBHOOKS GET */

export function* GET_WEBHOOK({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const success = yield call(webhookGet, id, payload.data, getAppHost(payload.appSettings))
  if (success && success.data) {
    const triggersSuccess = yield call(
      webhookTriggersGet,
      id,
      payload.data,
      getAppHost(payload.appSettings),
    )

    const responseData = success.data
    responseData.triggers = triggersSuccess.data

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        webhooksActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${payload.data.id}/webhooks-legacy`))
  }
}

export function* GET_WEBHOOK_NEW({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const success = yield call(newWebhookGet, id, payload.data, getAppHost(payload.appSettings))
  if (success && success.data) {
    const triggersSuccess = yield call(
      newWebhookTriggersGet,
      id,
      payload.data,
      getAppHost(payload.appSettings),
    )

    const responseData = success.data
    responseData.triggers = triggersSuccess.data

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        newWebhooksActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${payload.data.id}/webhooks`))
  }
}

/* WEBHOOK ADD */

export function* ADD_WEBHOOK({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  payload.name = payload.id
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(webhookAdd, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    if (payload.triggers && payload.triggers.length)
      yield call(addTriggers, payload.id, payload.triggers, activeApp, getAppHost(appSettings))

    yield put({
      type: 'apps/WEBHOOKS_LIST',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/webhooks-legacy`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Webhook added' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Plan restriction - Feature not available' },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

export function* ADD_WEBHOOK_NEW({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  payload.name = payload.id
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(newWebhookAdd, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    if (payload.triggers && payload.triggers.length)
      yield call(newAddTriggers, payload.id, payload.triggers, activeApp, getAppHost(appSettings))

    yield put({
      type: 'apps/WEBHOOKS_LIST_NEW',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/webhooks`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Webhook added' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

/* WEBHOOK UPDATE */

export function* UPDATE_WEBHOOK({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, webhooksActive } = reduxStore.getState().apps

  const filtered = {}
  const unset = []
  _.filter(payload, function fn(n, k) {
    if (k === 'useBasicAuth' || k === 'enabled' || (payload[k] && _.trim(payload[k]) !== '')) {
      filtered[k] = n
    } else {
      unset.push(k)
    }
  })

  filtered.unset = unset
  delete filtered.triggers
  const success = yield call(webhookUpdate, id, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const currentTriggers = []
    _.forEach(webhooksActive.triggers, function fn(ct) {
      currentTriggers.push(ct.id)
    })

    if (currentTriggers.length) {
      const removedTriggers = _.difference(currentTriggers, payload.triggers)

      if (removedTriggers.length) {
        yield call(delTriggers, payload.id, removedTriggers, activeApp, getAppHost(appSettings))
      }
    }

    if (_.uniq(payload.triggers) && _.uniq(payload.triggers).length) {
      let addTriggersCheck = false
      if (!webhooksActive.triggers.length) {
        addTriggersCheck = true
      } else {
        const checkIfNewTriggersSelected = _.xor(currentTriggers, _.uniq(payload.triggers))
        if (checkIfNewTriggersSelected.length) {
          addTriggersCheck = true
        }
      }
      if (addTriggersCheck) {
        const triggersToAdd = _.uniq(payload.triggers)
        yield call(addTriggers, payload.id, triggersToAdd, activeApp, getAppHost(appSettings))
      }
    }

    yield put({
      type: 'apps/GET_WEBHOOK',
      payload: {
        id: payload.id,
      },
    })

    yield put({
      type: 'apps/WEBHOOKS_LIST',
      payload: { currentPage: 1, data: activeApp },
    })
    // DO NOT DELETE
    // yield put(push(`/app/${activeApp.id}/webhooks-legacy/${payload.id}/edit`))

    yield put(push(`/app/${activeApp.id}/webhooks-legacy`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Webhook saved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Plan restriction - Feature not available' },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Uknown Error' },
      })
    }
  }

  return success
}

export function* UPDATE_WEBHOOK_NEW({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, newWebhooksActive } = reduxStore.getState().apps

  const filtered = {}
  const unset = []
  _.filter(payload, function fn(n, k) {
    if (
      k === 'useBasicAuth' ||
      k === 'enabled' ||
      k === 'retryOnFailure' ||
      (payload[k] && _.trim(payload[k]) !== '')
    ) {
      filtered[k] = n
    } else {
      unset.push(k)
    }
  })

  filtered.unset = unset
  delete filtered.triggers
  const success = yield call(newWebhookUpdate, id, filtered, activeApp, getAppHost(appSettings))
  if (success && success.data) {
    const currentTriggers = []
    _.forEach(newWebhooksActive.triggers, function fn(ct) {
      currentTriggers.push(ct.id)
    })

    if (currentTriggers.length) {
      const removedTriggers = _.difference(currentTriggers, payload.triggers)

      if (removedTriggers.length) {
        yield call(newDelTriggers, payload.id, removedTriggers, activeApp, getAppHost(appSettings))
      }
    }

    if (_.uniq(payload.triggers) && _.uniq(payload.triggers).length) {
      let addTriggersCheck = false
      if (!newWebhooksActive.triggers.length) {
        addTriggersCheck = true
      } else {
        const checkIfNewTriggersSelected = _.xor(currentTriggers, _.uniq(payload.triggers))
        if (checkIfNewTriggersSelected.length) {
          addTriggersCheck = true
        }
      }
      if (addTriggersCheck) {
        const triggersToAdd = _.uniq(payload.triggers)
        yield call(newAddTriggers, payload.id, triggersToAdd, activeApp, getAppHost(appSettings))
      }
    }

    yield put({
      type: 'apps/GET_WEBHOOK_NEW',
      payload: {
        id: payload.id,
      },
    })

    yield put({
      type: 'apps/WEBHOOKS_LIST_NEW',
      payload: { currentPage: 1, data: activeApp },
    })
    // DO NOT DELETE
    // yield put(push(`/app/${activeApp.id}/webhooks/${payload.id}/edit`))

    yield put(push(`/app/${activeApp.id}/webhooks`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Webhook saved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
  }

  return success
}
/* WEBHOOK DELETE */

export function* DELETE_WEBHOOK({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, webhooksListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(webhookDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const webhookListPageNo =
      webhooksListPagination !== undefined && webhooksListPagination.count > 1
        ? webhooksListPagination.current_page
        : 1
    yield put({
      type: 'apps/WEBHOOKS_LIST',
      payload: { currentPage: webhookListPageNo, data: activeApp },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Webhook deleted` },
    })

    if (refresh) yield put(push(`/app/${activeApp.id}/webhooks-legacy`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}
export function* DELETE_WEBHOOK_NEW({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, newWebhooksListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(newWebhookDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const webhookListPageNo =
      newWebhooksListPagination !== undefined && newWebhooksListPagination.count > 1
        ? newWebhooksListPagination.current_page
        : 1
    yield put({
      type: 'apps/WEBHOOKS_LIST_NEW',
      payload: { currentPage: webhookListPageNo, data: activeApp },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Webhook deleted` },
    })

    if (refresh) yield put(push(`/app/${activeApp.id}/webhooks`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* CHANGE_WEBHOOK_STATUS */

export function* CHANGE_WEBHOOK_STATUS({ payload }) {
  const { id, status } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const allWebhooks = reduxStore.getState().apps.webhooksList

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const data = { enabled: !status }

  const success = yield call(webhookUpdate, id, data, activeApp, getAppHost(appSettings))

  let successMessage

  if (success && success.data) {
    _.forEach(allWebhooks, function fn(c, k) {
      if (c.id === id) {
        if (allWebhooks[k].enabled) {
          successMessage = 'disabled'
        } else {
          successMessage = 'enabled'
        }

        allWebhooks[k].enabled = !allWebhooks[k].enabled
      }
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        webhooksList: allWebhooks,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Webhook ${successMessage}` },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

export function* CHANGE_WEBHOOK_STATUS_NEW({ payload }) {
  const { id, status } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const allWebhooks = reduxStore.getState().apps.newWebhooksList

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const data = { enabled: !status }

  const success = yield call(newWebhookUpdate, id, data, activeApp, getAppHost(appSettings))

  let successMessage

  if (success && success.data) {
    _.forEach(allWebhooks, function fn(c, k) {
      if (c.id === id) {
        if (allWebhooks[k].enabled) {
          successMessage = 'disabled'
        } else {
          successMessage = 'enabled'
        }

        allWebhooks[k].enabled = !allWebhooks[k].enabled
      }
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        newWebhooksList: allWebhooks,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Webhook ${successMessage}` },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}
/* EXTENSIONS */

export function* EXTENSIONS_LIST(activeApp = []) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areExtensionsLoading: true,
    },
  })
  if (!activeApp.data) activeApp.data = reduxStore.getState().apps.active
  const allExtensions = yield call(extensionsList, activeApp.data)

  if (allExtensions && allExtensions.data) {
    const installedExtensions = yield call(extensionsList, activeApp.data, 'installed')

    let installedExtensionsList = []
    let installedExtensionsIDs = []
    if (installedExtensions && installedExtensions.data) {
      _.forEach(installedExtensions.data, function dc(v, k) {
        installedExtensions.data[k].price =
          constants.extensions[installedExtensions.data[k].id] !== undefined
            ? constants.extensions[installedExtensions.data[k].id].cost
            : 0
        installedExtensionsIDs = _.concat(installedExtensionsIDs, v.id)
        installedExtensions.data[k].installed = true
      })
      installedExtensionsList = installedExtensions.data
    }

    if (!_.isEmpty(allExtensions.data)) {
      if (activeApp.data.region === 'legacy') {
        _.remove(allExtensions.data, function fn(v, k) {
          return (
            constants.extensions[allExtensions.data[k].id] === undefined ||
            constants.extensions[allExtensions.data[k].id].v1 === undefined
          )
        })
      }
      _.forEach(allExtensions.data, function dc(v, k) {
        allExtensions.data[k].price =
          constants.extensions[allExtensions.data[k].id] !== undefined
            ? constants.extensions[allExtensions.data[k].id].cost
            : 0
        const checkIndex = _.findIndex(installedExtensionsIDs, function fn2(a) {
          return a === v.id
        })
        if (checkIndex >= 0) allExtensions.data[k].installed = true
        else allExtensions.data[k].installed = false
      })
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp.data,
        extensionsAllList: allExtensions.data,
        extensionsInstalledList: installedExtensionsList,
        loading: false,
        areExtensionsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        extensionsAllList: [],
        extensionsInstalledList: [],
        loading: false,
        areExtensionsLoading: false,
      },
    })
    if (
      allExtensions.error !== undefined &&
      allExtensions.error.code !== undefined &&
      isAuthErrorCode(allExtensions.error.code)
    ) {
      if (allExtensions.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    }
  }
}

/* EXTENSION SEARCH */

export function* ENTER_EXTENSION_TEXT({ payload }) {
  const { searchText, type } = payload
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      extensionSearchText: searchText,
      extensionsTypeActive: type,
      loading: true,
    },
  })
  if (searchText.length === 0 || searchText.length >= 2) {
    yield put({
      type: 'apps/SEARCH_EXTENSION',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

/* SEARCH_EXTENSION */

export function* SEARCH_EXTENSION() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const searchText = reduxStore.getState().apps.extensionSearchText

  const searchExtensionType = reduxStore.getState().apps.extensionsTypeActive

  const success = yield call(extensionsSearch, activeApp, searchText, searchExtensionType)

  if (success && success.data) {
    if (searchExtensionType === 'installed') {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: activeApp,
          extensionsInstalledList: success.data,
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: activeApp,
          extensionsAllList: success.data,
          loading: false,
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        loading: false,
      },
    })
  }
}

/* EXTENSION CHANGE STATUS */

export function* CHANGE_EXTENSION_STATUS({ payload }) {
  const { id, type } = payload

  const activeApp = reduxStore.getState().apps.active

  const allExtensions = reduxStore.getState().apps.extensionsAllList

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let skipPhase2ActivePlanChecks = false
  if (checkIfCustomPlan(activeApp.plan)) {
    if (!(id === 'widget' && type !== 'installed')) {
      if (type === 'installed') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'info', message: 'Please click on disable button on extension list' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'info', message: 'Please Contact CometChat Support team' },
        })
        const intent = _.join(
          [constants.ManualOutreachIntents['add-higher-plan-extension'], activeApp.id, id],
          ' / ',
        )
        const post = { intent }
        yield call(manualOutreach, post)
      }
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      return false
    }
  }

  if (checkIfPhase2ActivePlan(activeApp.plan) || checkIfPhase3ActivePlan(activeApp.plan)) {
    if (type === 'installed') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'info', message: 'Please click on disable button on extension list' },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      return false
    }
    if (checkIfPhase2ActivePlan(activeApp.plan)) {
      const planIndex = _.findIndex(constants.phase2PlansIDList, function fn(pl) {
        return pl === activeApp.plan
      })
      const planGroup0Indexes = [0, 1, 2, 3, 4]
      const planGroup1Indexes = [5, 6, 7, 8, 9]
      const planGroup2Indexes = [10, 11, 12, 13, 14]
      const planGroup3Indexes = [15, 16, 17, 18, 19]

      let planGroupIndex = -1
      if (_.includes(planGroup0Indexes, planIndex)) planGroupIndex = 0
      else if (_.includes(planGroup1Indexes, planIndex)) planGroupIndex = 1
      else if (_.includes(planGroup2Indexes, planIndex)) planGroupIndex = 2
      else if (_.includes(planGroup3Indexes, planIndex)) planGroupIndex = 3

      if (planGroupIndex >= 0) {
        if (_.includes(constants.plans[planGroupIndex].extensionIds, id)) {
          skipPhase2ActivePlanChecks = true
        }
      }
    }

    if (checkIfPhase3ActivePlan(activeApp.plan)) {
      if (constants.phase3PlanFreeIDCategories.appDeveloper === activeApp.plan) {
        skipPhase2ActivePlanChecks = true
      } else {
        const planIndex = _.findIndex(constants.phase3PlansIDList, function fn(pl) {
          return pl === activeApp.plan
        })
        const planGroup0Indexes = [0, 1, 2, 3, 4]
        const planGroup1Indexes = [5, 6, 7, 8, 9]
        const planGroup2Indexes = [10, 11, 12, 13, 14]
        const planGroup4Indexes = [15, 16, 17, 18, 19, 20]

        let planGroupIndex = -1
        if (_.includes(planGroup0Indexes, planIndex)) planGroupIndex = 0
        else if (_.includes(planGroup1Indexes, planIndex)) planGroupIndex = 1
        else if (_.includes(planGroup2Indexes, planIndex)) planGroupIndex = 2
        else if (_.includes(planGroup4Indexes, planIndex)) planGroupIndex = 4

        if (planGroupIndex >= 0) {
          if (_.includes(constants.plansV3[planGroupIndex].extensionIds, id)) {
            skipPhase2ActivePlanChecks = true
          }
        }
      }
    }

    if (!skipPhase2ActivePlanChecks) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      let planRestrictionTitle = 'Please upgrade plan'
      // let planRestrictionMsg = customLanguageTexts.PHASE_2_PLAN_EXTENSION_ADD_RESTRICTION
      if (id === 'broadcast') {
        planRestrictionTitle = 'Contact us'
        // planRestrictionMsg = customLanguageTexts.PHASE_2_NEBULA_PLAN_EXTENSION_ADD_RESTRICTION
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'info', message: planRestrictionTitle },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: planRestrictionTitle },
        })
      }

      // send manual intent
      const intent = _.join(
        [constants.ManualOutreachIntents['add-higher-plan-extension'], activeApp.id, id],
        ' / ',
      )
      const post = { intent }
      yield call(manualOutreach, post)

      return false
    }
  }

  if (checkIfLegacyNonCustomPlan(activeApp.plan) || checkIfOldPlan(activeApp.plan)) {
    if (type !== 'installed') {
      if (constants.extensions[id] !== undefined && !constants.extensions[id].legacyPlans) {
        const planRestrictionTitle = 'Please upgrade plan'
        // const planRestrictionMsg = customLanguageTexts.LEGACY_PLAN_NEW_EXTENSION_ADD_RESTRICTION
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: planRestrictionTitle },
        })
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
          },
        })
        return false
      }
    }
  }

  let success

  if (type === 'installed') {
    success = yield call(removeExtension, id, activeApp)
  } else {
    success = yield call(extensionChangeStatus, id, activeApp, type)
  }

  if (success && success.data) {
    _.forEach(allExtensions, function fn(c, k) {
      if (c.id === id) {
        allExtensions[k].installed = !allExtensions[k].installed
      }
    })

    const installedExtensions = yield call(extensionsList, activeApp, 'installed')
    let installedExtensionsList = []
    if (installedExtensions && installedExtensions.data) {
      _.forEach(installedExtensions.data, function dc(v, k) {
        installedExtensions.data[k].price =
          constants.extensions[installedExtensions.data[k].id].cost
        installedExtensions.data[k].installed = true
      })
      installedExtensionsList = installedExtensions.data
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        extensionsAllList: allExtensions,
        extensionsInstalledList: installedExtensionsList,
        loading: false,
      },
    })

    if (type === 'installed') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Extension has been removed successfully' },
      })
      // extension has been removed
    } else if (success.data.enabled !== undefined) {
      // extension has been enabled
      if (activeApp.region === 'legacy') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: 'Extension installed successfully!' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'success',
            message: _.replace(success.data.enabled[id].message, '-', ' '),
          },
        })
      }
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Extension status changed successfully!' },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* EXTENSION ENABLE DISABLE */

export function* ENABLE_DISABLE_EXTENSION({ payload }) {
  const { id, callback } = payload

  const activeApp = reduxStore.getState().apps.active

  const installedExtensions = reduxStore.getState().apps.extensionsInstalledList

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  let status = 0

  _.forEach(installedExtensions, function fn(c, k) {
    if (c.id === id) {
      status = installedExtensions[k].enabled ? installedExtensions[k].enabled : 0
    }
  })

  let data = 'enabled'
  if (!status) {
    data = 'disabled'
  }

  const success = yield call(extensionChangeStatus, id, activeApp, data)

  let successMessage

  if (success && success.data) {
    if (status) {
      successMessage = 'disabled'
    } else {
      successMessage = 'enabled'
    }
    const installedExtensions2 = yield call(extensionsList, activeApp, 'installed')
    let extensionName = 'Extension '
    const extensionIndex = _.findIndex(installedExtensions2.data, function fn(c) {
      return c.id === id
    })
    if (extensionIndex >= 0) {
      extensionName = installedExtensions2.data[extensionIndex].name
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        extensionsInstalledList: installedExtensions2.data,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `${extensionName} has been ${successMessage}.` },
    })

    // Call callback if provided
    if (callback) {
      callback({ success: true, data: success.data })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }

    // Call callback with error if provided
    if (callback) {
      callback({ success: false, error: success.error })
    }
  }
}

/* SUBSCRIBE_TO_PLAN */

export function* SUBSCRIBE_TO_PLAN({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const success = yield call(subscribe, payload, activeApp)
  if (success && success.data) {
    if (success.data.link !== undefined) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          subscribePlanOngoingData: payload,
          subscribePlanOngoingLink: success.data.link,
        },
      })
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionOngoing',
        },
      })
    } else {
      const appData = yield call(get, activeApp.id)
      const allApps = reduxStore.getState().apps.data
      const loggedInUser = reduxStore.getState().user
      if (!_.isEmpty(allApps)) {
        const appIndex = _.findIndex(allApps, function fn(a) {
          return a.id === activeApp.id
        })
        if (appIndex >= 0) {
          allApps[appIndex] = appData.data
        }
      }

      const currentAccountResponse = yield call(currentAccount, loggedInUser.id)
      if (currentAccountResponse && currentAccountResponse.data) {
        currentAccountResponse.data.authorized = true
        currentAccountResponse.data.loading = false
        currentAccountResponse.data.showOnboarding = false
        yield put({
          type: 'user/SET_STATE',
          payload: currentAccountResponse.data,
        })
      }
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: appData.data,
          data: allApps,
          loading: false,
        },
      })

      yield put(push(`/app/${activeApp.id}/plans-billing`))
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionSuccess',
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })

    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    yield put(push(`/app/${activeApp.id}/plans-billing`))
    if (
      (success.error.code !== undefined && success.error.code === 'ERR_BAD_REQUEST') ||
      success.error.code === 'ERR_SUBSCRIBE_FAILED' ||
      success.error.code === 'ERR_PAYMENT_COLLECTION_FAILED'
    ) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message || 'Subscription failed. Please check your payment method.' },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* UNSUBSCRIBE_TO_PLAN */

export function* UNSUBSCRIBE_TO_PLAN({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      visibleModalID: 'appUnsubscribeInProgress',
    },
  })
  const activeApp = reduxStore.getState().apps.active
  const customerData = reduxStore.getState().user
  let planAmount = 0
  if (constants.nonCustomPlansCostList[activeApp.plan] !== undefined) {
    planAmount = constants.nonCustomPlansCostList[activeApp.plan]
  }
  const userDataObj = {
    user: {
      id: customerData.id,
      name: customerData.name,
      email: customerData.email,
      amount: planAmount,
      plan_id: activeApp.plan,
      plan_name: getPlanName(activeApp),
    },
  }

  const userDataObjString = JSON.stringify(userDataObj)

  const success = yield call(unsubscribe, payload, activeApp, userDataObjString)

  if (success && success.data !== undefined && success.data.success) {
    // yield delay(4)
    const appData = yield call(get, activeApp.id)
    const allApps = reduxStore.getState().apps.data
    if (!_.isEmpty(allApps)) {
      const appIndex = _.findIndex(allApps, function fn(a) {
        return a.id === activeApp.id
      })
      if (appIndex >= 0) {
        allApps[appIndex] = appData.data
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: appData.data,
        data: allApps,
        loading: false,
      },
    })

    yield put(push(`/app/${activeApp.id}/plans-billing`))
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    if (
      checkIfNonCustomActivePlan(appData.data.parameters) &&
      appData.data.cancelsAt !== undefined &&
      appData.data.cancelsAt
    ) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionCancelledEndOfTerm',
        },
      })
    } else if (checkIfTrialOrExpired(appData.data.plan)) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'You have been Unsubscribed successfully' },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'You have been Unsubscribed successfully' },
      })
    }
    yield put(push(`/app/${activeApp.id}/plans-billing`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.code === 'ERR_UNSUBSCRIBE_FAILED') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: `Unsubscribing failed ${success.error.message}` },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* UNSUBSCRIBE_TO_PLAN_ENDPOINT */

export function* UNSUBSCRIBE_TO_PLAN_ENDPOINT() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      visibleModalID: 'appUnsubscribeInProgress',
    },
  })
  const customerData = reduxStore.getState().user
  const activeApp = reduxStore.getState().apps.active

  if (activeApp.parent !== undefined && activeApp.parent && activeApp.parent.length > 0) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Visit your primary app to modify your plan' },
    })
    yield put(push(`/app/${activeApp.id}/plans-billing`))

    return false
  }
  // AI Agents plan ids are not in nonCustomPlansIDList but are valid — skip the guard for them.
  const isAiAgentPlan = checkIfAiAgentActivePlan(activeApp.plan)

  let checkIfPlanIdExists = -1
  if (!isAiAgentPlan) {
    checkIfPlanIdExists = _.findIndex(constants.nonCustomPlansIDList, function fn(pl) {
      return pl === activeApp.plan
    })
  }

  if (!isAiAgentPlan && checkIfPlanIdExists < 0) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Unsubscribing failed ` },
    })
    yield put(push(`/app/${success.data.id}/overview`))
    return false
  }

  let checkIfPlanUnsubscribeRestricted = -1
  checkIfPlanUnsubscribeRestricted = _.findIndex(
    constants.activePlansUnsubscribeRestricted,
    function fn(pl) {
      return pl === activeApp.plan
    },
  )
  if (checkIfPlanUnsubscribeRestricted >= 0) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Unsubscribing failed ' },
    })

    yield put(push(`/app/${success.data.id}/overview`))
    return false
  }

  let planAmount = 0

  // current plan or legacy meteoroid / asteroid plan for which unsubscribe is available.
  if (constants.nonCustomPlansCostList[activeApp.plan] !== undefined) {
    planAmount = constants.nonCustomPlansCostList[activeApp.plan]
  }
  const userDataObj = {
    user: {
      id: customerData.id,
      name: customerData.name,
      email: customerData.email,
      amount: planAmount,
      plan_id: activeApp.plan,
      plan_name: getPlanName(activeApp),
    },
  }
  const userDataObjString = JSON.stringify(userDataObj)
  const success = yield call(unsubscribe, activeApp, userDataObjString)
  if (success && success.data !== undefined && success.data.success) {
    yield delay(2)
    const appData = yield call(get, activeApp.id)
    const allApps = reduxStore.getState().apps.data
    if (!_.isEmpty(allApps)) {
      const appIndex = _.findIndex(allApps, function fn(a) {
        return a.id === activeApp.id
      })
      if (appIndex >= 0) {
        allApps[appIndex] = appData.data
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: appData.data,
        data: allApps,
        loading: false,
      },
    })

    if (
      checkIfNonCustomActivePlan(appData.data.parameters) &&
      appData.data.cancelsAt !== undefined &&
      appData.data.cancelsAt
    ) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionCancelledEndOfTerm',
        },
      })
    } else if (checkIfTrialOrExpired(appData.data.plan)) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: '',
        },
      })
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'you have been Unsubscribed' },
      })
    } else {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: '',
        },
      })
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'you have been Unsubscribed' },
      })
    }

    yield put(push(`/app/${activeApp.id}/plans-billing`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else {
      if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      } else if (success.error.code === 'ERR_UNSUBSCRIBE_FAILED') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Unsubscribing failed' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Some error occurred' },
        })
      }
      yield put(push(`/app/${activeApp.id}/plans-billing`))
    }
  }
  return success
}

/* SUBSCRIBE_MODAL_PROCEED */

export function* SUBSCRIBE_MODAL_PROCEED() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { plan: selectedPlan } = reduxStore.getState().apps.subscribePlanOngoingData
  const extensionsInstalledList = reduxStore.getState().apps.extensionsInstalled
  const extensionIds = []
  if (!_.isEmpty(extensionsInstalledList)) {
    _.forEach(extensionsInstalledList, function fn(ex) {
      extensionIds.push(ex.id)
    })
  }

  const payload = { plan: selectedPlan, extensionIds }

  const success = yield call(subscribe, payload, activeApp)

  if (success && success.data) {
    if (success.data.link !== undefined) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          subscribePlanOngoingData: payload,
          subscribePlanOngoingLink: success.data.link,
        },
      })
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionOngoing',
        },
      })
    } else {
      const appData = yield call(get, activeApp.id)

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: appData.data,
          loading: false,
        },
      })
      yield put(push(`/app/${activeApp.id}/plans-billing`))
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionSuccess',
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: [],
        subscribePlanOngoingLink: '',
      },
    })
    yield put({
      type: 'settings/SET_STATE',
      payload: {
        visibleModalID: '',
      },
    })
    yield put(push(`/app/${activeApp.id}/plans-billing`))
    if (
      (success.error.code !== undefined && success.error.code === 'ERR_BAD_REQUEST') ||
      success.error.code === 'ERR_SUBSCRIBE_FAILED'
    ) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Error Subscribing' },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* APP SETTINGS GET */

export function* GET_APP_SETTINGS(activeApp = []) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(settingsGet, activeApp.data.id, activeApp.data)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        appSettings: success.data,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        appSettings: [],
        loading: false,
      },
    })
  }
}

/* APP SETTINGS GET */

export function* GET_APP_MESSAGE_SETTINGS(activeApp = []) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(settingsThreadAndConversationGet, activeApp.data.id)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        appMessageSettings: success.data,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        appMessageSettings: [],
        loading: false,
      },
    })
  }
}

/* CHANGE_FRIENDS_SETTINGS_FOR_V1_APPS */

export function* SAVE_APP_SETTINGS({ payload }) {
  const { id, data } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(settingsUpdate, id, data, activeApp, getAppHost(appSettings))

  let successMessageParam

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (data.settings.contactList === 'friends') {
      successMessageParam = ' enabled'
    } else {
      successMessageParam = ' disabled'
    }
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Friends' setting ${successMessageParam} successfully` },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* CHANGE_SAVE_APP_MESSAGE_SETTINGS */

export function* SAVE_APP_MESSAGE_SETTINGS({
  payload,
  id,
  successMsg = 'Configurations updated successfully',
}) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(settingsThreadAndConversationMap, id, payload)
  if (success && success.data) {
    const appData = yield call(settingsThreadAndConversationGet, id)
    if (appData && appData.data) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          appMessageSettings: appData.data,
          loading: false,
        },
      })
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message: successMsg,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.code && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Error updating configurations. Please contact us if error persists',
        },
      })
  }
}

/* STRIPE_CHECKOUT_1 */

export function* STRIPE_CHECKOUT_1({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { subscribePlanAppData } = reduxStore.getState().apps
  const { subscribePlanOngoingData } = reduxStore.getState().apps
  const { subscribeDowngradeAtEOT } = reduxStore.getState().apps
  if (
    subscribePlanOngoingData.plan === 'undefined' ||
    subscribePlanOngoingData.plan === '' ||
    (subscribePlanOngoingData.plan !== '' && checkIfCustomOldPlan(subscribePlanAppData.plan))
  ) {
    if (checkIfCustomOldPlan(subscribePlanAppData.plan))
      message.error(customLanguageTexts.CUSTOM_PLAN_UNSUBSCRIBE_MODAL_MSG)
    else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Something went wrong, please try again' },
      })
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))

    return false
  }
  const payloadData = payload
  payloadData.plan = subscribePlanOngoingData.plan ? subscribePlanOngoingData.plan : ''
  payloadData.extensionIds =
    subscribePlanOngoingData.extensionIds !== undefined && subscribePlanOngoingData.extensionIds
      ? subscribePlanOngoingData.extensionIds
      : []
  const singleEventPlans = [
    'single-25-(2021-01)',
    'single-100-(2021-01)',
    'single-1k-(2021-03)',
    'single-2500-(2021-03)',
    'single-5k-(2021-03)',
    'single-10k-(2021-03)',
  ]
  if (_.includes(singleEventPlans, payloadData.plan)) {
    payloadData.onTermEndDowngradeToFree = subscribeDowngradeAtEOT
  }
  const success = yield call(stripeCall1, payloadData, subscribePlanAppData)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else if (success.error.code !== undefined && success.error.code === 'ERR_PAYMENT_FAILED') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Payment Failed' },
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    // yield put(push(`/app/${subscribePlanAppData.id}/plans-billing/checkout`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribeDowngradeAtEOT: false,
        subscribePlanOngoingData: [],
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    }
  }

  return success
}

/* STRIPE_CHECKOUT_2 */

export function* STRIPE_CHECKOUT_2({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { subscribePlanOngoingData } = reduxStore.getState().apps
  const { subscribePlanAppData } = reduxStore.getState().apps
  const { subscribeDowngradeAtEOT } = reduxStore.getState().apps
  const { paidPlans } = reduxStore.getState().plans
  const phase4PlansCostMap = getPhase4PlansCostMapFromPaidPlans(paidPlans)
  const customerData = reduxStore.getState().user
  if (subscribePlanOngoingData.plan === 'undefined' || subscribePlanOngoingData.plan === '') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Something went wrong, please try again' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribePlanOngoingData: [],
        subscribeTotalCharge: 0,
        subscribeDowngradeAtEOT: false,
      },
    })
    yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    return false
  }
  const payloadData = payload

  payloadData.plan = subscribePlanOngoingData.plan ? subscribePlanOngoingData.plan : ''
  payloadData.extensionIds =
    subscribePlanOngoingData.extensionIds !== undefined &&
    subscribePlanOngoingData.extensionIds.length
      ? subscribePlanOngoingData.extensionIds
      : []

  const singleEventPlans = [
    'single-25-(2021-01)',
    'single-100-(2021-01)',
    'single-1k-(2021-03)',
    'single-2500-(2021-03)',
    'single-5k-(2021-03)',
    'single-10k-(2021-03)',
  ]
  if (_.includes(singleEventPlans, payloadData.plan)) {
    payloadData.onTermEndDowngradeToFree = subscribeDowngradeAtEOT
  }

  if (subscribePlanOngoingData.isAnnual) {
    payloadData.isAnnual = true
  }

  let planAmount = 0
  if (subscribePlanOngoingData.totalAmount !== undefined) {
    planAmount = subscribePlanOngoingData.totalAmount
  } else if (constants.nonCustomPlansCostList[subscribePlanOngoingData.plan] !== undefined) {
    planAmount = constants.nonCustomPlansCostList[subscribePlanOngoingData.plan]
  }
  const userDataObj = {
    user: {
      id: customerData.id,
      name: customerData.name,
      email: customerData.email,
      amount: planAmount,
      plan_id: subscribePlanOngoingData.plan,
      plan_name: subscribePlanOngoingData.name ?? getPlanName(subscribePlanOngoingData.plan, true),
    },
  }
  const userDataObjString = JSON.stringify(userDataObj)
  const success = yield call(stripeCall2, payloadData, subscribePlanAppData, userDataObjString) // subscribeTotalCharge
  if (success && success.data) {
    if (success.data.link !== undefined && success.data.link) {
      yield put({
        type: 'user/LOAD_CURRENT_ACCOUNT',
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          subscribePlanAppData: [],
          subscribePlanOngoingData: [],
          subscribeTotalCharge: 0,
          subscribeDowngradeAtEOT: false,
        },
      })

      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Payment failed - Your card details are not present' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    } else {
      yield delay(5000)
      const appData = yield call(get, subscribePlanAppData.id)
      const allApps = yield call(list)
      let appsListTotal = 0
      if (allApps.data) {
        appsListTotal = allApps.data.length
        if (allApps.meta !== undefined && allApps.meta.pagination !== undefined) {
          appsListTotal = allApps.meta.pagination.total
        }
      }
      const loggedInUser = reduxStore.getState().user

      const currentAccountResponse = yield call(currentAccount, loggedInUser.id)
      if (currentAccountResponse && currentAccountResponse.data) {
        currentAccountResponse.data.authorized = true
        currentAccountResponse.data.loading = false
        currentAccountResponse.data.showOnboarding = false
        yield put({
          type: 'user/SET_STATE',
          payload: currentAccountResponse.data,
        })
      }
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: appData.data,
          data: allApps.data,
          appSearchText: '',
          appsListPageNo: 1,
          appsListTotal,
          subscribePlanAppData: [],
          subscribePlanOngoingData: [],
          subscribeTotalCharge: 0,
          subscribeDowngradeAtEOT: false,
          loading: false,
        },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/overview`))
      if (
        checkIfNonCustomActivePlan(appData.data.parameters) &&
        appData.data.metadata.planDowngradedTo !== undefined &&
        appData.data.metadata.planDowngradedTo
      ) {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'subscriptionDowngradedEndOfTerm',
          },
        })
      } else if (
        !phase4PlansCostMap.has(subscribePlanOngoingData.plan) &&
        constants.nonCustomPlansCostList[subscribePlanOngoingData.plan] <
          (phase4PlansCostMap.get(subscribePlanAppData.plan) ??
            constants.nonCustomPlansCostList[subscribePlanAppData.plan])
      ) {
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'subscriptionSuccessDowngrade',
          },
        })
      } else {
        yield put({
          type: 'user/UPDATE_2FA_ACCOUNT_STATUS',
          payload: { disableMFA: false, hideNotification: true },
        })
        yield put({
          type: 'settings/SET_STATE',
          payload: {
            visibleModalID: 'subscriptionSuccess',
          },
        })
      }
    }
  } else if (success.error.code !== undefined && success.error.code === 'ERR_PAYMENT_FAILED') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Payment failed' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribePlanOngoingData: [],
        subscribeTotalCharge: 0,
        subscribeDowngradeAtEOT: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    }
  }

  return success
}

/* RESUBSCRIBE */

export function* RESUBSCRIBE() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { paidPlans } = reduxStore.getState().plans
  const phase4PlansCostMap = getPhase4PlansCostMapFromPaidPlans(paidPlans)
  const subscribePlanAppData = reduxStore.getState().apps.active
  const selectedPlan = subscribePlanAppData.plan
  const { extensionsInstalledList } = reduxStore.getState().apps
  const extensionIds = []
  if (!_.isEmpty(extensionsInstalledList)) {
    _.forEach(extensionsInstalledList, function fn(ex) {
      extensionIds.push(ex.id)
    })
  }

  const subscribePlanOngoingData = { plan: selectedPlan, extensionIds }

  if (subscribePlanOngoingData.plan === 'undefined' || subscribePlanOngoingData.plan === '') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Something went wrong, please try again' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribePlanOngoingData: [],
        subscribeDowngradeAtEOT: false,
      },
    })
    yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    return false
  }
  const customerData = reduxStore.getState().user
  let planAmount = 0
  if (phase4PlansCostMap.has(subscribePlanOngoingData.plan)) {
    planAmount = phase4PlansCostMap.get(subscribePlanOngoingData.plan)
  } else if (constants.nonCustomPlansCostList[subscribePlanOngoingData.plan] !== undefined) {
    planAmount = constants.nonCustomPlansCostList[subscribePlanOngoingData.plan]
  }
  const userDataObj = {
    user: {
      id: customerData.id,
      name: customerData.name,
      email: customerData.email,
      amount: planAmount,
      plan_id: subscribePlanOngoingData.plan,
      plan_name: getPlanName(subscribePlanOngoingData.plan, true),
    },
  }
  const userDataObjString = JSON.stringify(userDataObj)
  const success = yield call(
    stripeCall2,
    subscribePlanOngoingData,
    subscribePlanAppData,
    userDataObjString,
  )
  if (success && success.data) {
    if (success.data.link !== undefined && success.data.link) {
      yield put({
        type: 'user/LOAD_CURRENT_ACCOUNT',
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          subscribePlanAppData: [],
          subscribePlanOngoingData: [],
          subscribeDowngradeAtEOT: false,
        },
      })
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Payment failed - Your card details are not present' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    } else {
      const appData = yield call(get, subscribePlanAppData.id)
      const allApps = reduxStore.getState().apps.data
      const loggedInUser = reduxStore.getState().user
      if (!_.isEmpty(allApps)) {
        const appIndex = _.findIndex(allApps, function fn(a) {
          return a.id === subscribePlanAppData.id
        })
        if (appIndex >= 0) {
          allApps[appIndex] = appData.data
        }
      }

      const currentAccountResponse = yield call(currentAccount, loggedInUser.id)
      if (currentAccountResponse && currentAccountResponse.data) {
        currentAccountResponse.data.authorized = true
        currentAccountResponse.data.loading = false
        currentAccountResponse.data.showOnboarding = false
        yield put({
          type: 'user/SET_STATE',
          payload: currentAccountResponse.data,
        })
      }
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: appData.data,
          data: allApps,
          subscribePlanAppData: [],
          subscribeDowngradeAtEOT: false,
          subscribePlanOngoingData: [],
        },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/overview`))
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionSuccess',
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  } else if (success.error.code !== undefined && success.error.code === 'ERR_PAYMENT_FAILED') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Payment failed' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribeDowngradeAtEOT: false,
        subscribePlanOngoingData: [],
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    }
  }

  return success
}

/* STRIPE_GOTO_CHECKOUT */

export function* STRIPE_GOTO_CHECKOUT({ payload, totalCharge }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const activeApp = reduxStore.getState().apps.active
  const { subscribeDowngradeAtEOT } = reduxStore.getState().apps
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
      subscribeDowngradeAtEOT,
      subscribePlanAppData: activeApp,
      subscribePlanOngoingData: payload,
      subscribeTotalCharge: totalCharge,
    },
  })
}

/* RESUBSCRIBE */

export function* CANCEL_DOWNGRADE_EOT() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { paidPlans } = reduxStore.getState().plans
  const phase4PlansCostMap = getPhase4PlansCostMapFromPaidPlans(paidPlans)
  const subscribePlanAppData = reduxStore.getState().apps.active
  const selectedPlan = subscribePlanAppData.plan
  const { extensionsInstalledList } = reduxStore.getState().apps
  const extensionIds = []
  if (!_.isEmpty(extensionsInstalledList)) {
    _.forEach(extensionsInstalledList, function fn(ex) {
      extensionIds.push(ex.id)
    })
  }

  const subscribePlanOngoingData = { plan: selectedPlan, extensionIds }

  if (subscribePlanOngoingData.plan === 'undefined' || subscribePlanOngoingData.plan === '') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Something went wrong, please try again' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribePlanOngoingData: [],
        subscribeDowngradeAtEOT: false,
      },
    })
    yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    return false
  }
  const customerData = reduxStore.getState().user
  let planAmount = 0
  if (phase4PlansCostMap.has(subscribePlanOngoingData.plan)) {
    planAmount = phase4PlansCostMap.get(subscribePlanOngoingData.plan)
  } else if (constants.nonCustomPlansCostList[subscribePlanOngoingData.plan] !== undefined) {
    planAmount = constants.nonCustomPlansCostList[subscribePlanOngoingData.plan]
  }
  const userDataObj = {
    user: {
      id: customerData.id,
      name: customerData.name,
      email: customerData.email,
      amount: planAmount,
      plan_id: subscribePlanOngoingData.plan,
      plan_name: getPlanName(subscribePlanOngoingData.plan, true),
    },
  }
  const userDataObjString = JSON.stringify(userDataObj)
  const success = yield call(
    stripeCall2,
    subscribePlanOngoingData,
    subscribePlanAppData,
    userDataObjString,
  )
  if (success && success.data) {
    if (success.data.link !== undefined && success.data.link) {
      yield put({
        type: 'user/LOAD_CURRENT_ACCOUNT',
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          subscribePlanAppData: [],
          subscribePlanOngoingData: [],
          subscribeDowngradeAtEOT: false,
        },
      })

      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Payment failed' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    } else {
      const appData = yield call(get, subscribePlanAppData.id)
      const allApps = reduxStore.getState().apps.data
      const loggedInUser = reduxStore.getState().user
      if (!_.isEmpty(allApps)) {
        const appIndex = _.findIndex(allApps, function fn(a) {
          return a.id === subscribePlanAppData.id
        })
        if (appIndex >= 0) {
          allApps[appIndex] = appData.data
        }
      }

      const currentAccountResponse = yield call(currentAccount, loggedInUser.id)
      if (currentAccountResponse && currentAccountResponse.data) {
        currentAccountResponse.data.authorized = true
        currentAccountResponse.data.loading = false
        currentAccountResponse.data.showOnboarding = false
        yield put({
          type: 'user/SET_STATE',
          payload: currentAccountResponse.data,
        })
      }
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: appData.data,
          data: allApps,
          subscribePlanAppData: [],
          subscribePlanOngoingData: [],
          subscribeDowngradeAtEOT: false,
        },
      })
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'subscriptionDowngradeEOTCancelled',
        },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/overview`))

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  } else if (success.error.code !== undefined && success.error.code === 'ERR_PAYMENT_FAILED') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Payment failed' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanAppData: [],
        subscribePlanOngoingData: [],
        subscribeDowngradeAtEOT: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
      yield put(push(`/app/${subscribePlanAppData.id}/plans-billing`))
    }
  }

  return success
}

/* CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT */

export function* CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT() {
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.plan !== undefined) {
    if (checkIfCustomPlan(activeApp.plan)) {
      const intent = _.join(
        [constants.ManualOutreachIntents['change-custom-plan'], activeApp.id],
        ' / ',
      )
      const post = { intent }

      const success = yield call(manualOutreach, post)
      return success
    }
  }
}

export function* CALL_SLACK_SUPPORT_MANUAL_INTENT() {
  const activeApp = reduxStore.getState().apps.active
  if (activeApp && activeApp.id) {
    const intent = _.join(
      [constants.ManualOutreachIntents['slack-connect-request'], activeApp.id],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message:
          'Slack Support request submitted. Our engineers will reach out on your Slack channel soon.',
      },
    })
    return success
  }
}

export function* CALL_AGENTIC_PRICING_CONTACT_US({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  if (activeApp && activeApp.id) {
    const { planName, billingPeriod, isPayAsYouGo } = payload
    let billingLabel
    if (isPayAsYouGo) {
      billingLabel = 'Pay-as-you-go'
    } else if (billingPeriod === 'annual') {
      billingLabel = 'Annual'
    } else {
      billingLabel = 'Monthly'
    }
    const intent = _.join(
      [
        constants.ManualOutreachIntents['contact-us-agentic-pricing'],
        activeApp.id,
        `${planName} (${billingLabel})`,
      ],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)

    // Show thank you modal on success
    yield put({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: 'agenticPricingThankYou',
      },
    })

    return success
  }
}

/* CHECK_IF_CUSTOM_OR_OLD_PLAN */

export function* CHECK_IF_CUSTOM_PLAN({ payload }) {
  console.log('CHECK', payload)
  const { activeApp } = payload
  console.log('CHECK_IF_CUSTOM_PLAN 1', activeApp)
  if (!_.isEmpty(activeApp) && activeApp.plan !== undefined) {
    console.log('CHECK_IF_CUSTOM_PLAN 2')
    if (checkIfCustomOldPlan(activeApp.plan) || checkIfLegacyNonCustomPlan(activeApp.plan)) {
      console.log('CHECK_IF_CUSTOM_PLAN 3')
      const { redirect } = payload
      if (redirect) yield put(push(`/app/${activeApp.id}/plans-billing`))
    }
  }
}

/* CHANGE_MEMBER_SCOPE */

export function* CHANGE_MEMBER_SCOPE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const { guid: addGUID } = reduxStore.getState().apps.groupsActive

  const { uid, scope } = payload

  const success = yield call(
    changeScopeInGroup,
    uid,
    addGUID,
    scope,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data) {
    yield put({
      type: 'apps/GET_GROUP_MEMBERS',
      payload: {
        id: addGUID,
        currentPage: 1,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Member is now a ${scope}` },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.message !== undefined) {
      if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Group action now allowed' },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      }
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* GROUPS */

export function* GET_MESSAGE_LOGS({ payload }) {
  if (reduxStore.getState().apps.messageLogsLoading) return
  if (payload.type !== 'next') {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        messageLogsLoading: true,
      },
    })
  }

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let msgId = 0

  let loadMoreId = reduxStore.getState().apps.messageLogsLoadMoreId
  let pollingId = reduxStore.getState().apps.messageLogsPollingId

  if (payload.type === 'next') {
    msgId = pollingId
  } else if (payload.type === 'previous') {
    msgId = loadMoreId
  } else payload.type = 'current'

  const filters = payload.filters || {}

  const success = yield call(
    messageLogs,
    payload.data,
    getAppHost(payload.appSettings),
    payload.type,
    msgId,
    filters,
  )
  const { messageLogs: currentMsgLogs } = reduxStore.getState().apps

  if (success && success.data) {
    let filteredMessages
    if (filters.categories) {
      filteredMessages = _.filter(success.data, function fn(m) {
        return m.type !== 'extension_human-moderation'
      })
    } else {
      filteredMessages = _.filter(success.data, function fn(m) {
        return (
          m.category === 'message' ||
          m.category === 'agentic' ||
          (m.category === 'custom' && m.type !== 'extension_human-moderation')
        )
      })
    }

    filteredMessages = _.reverse(filteredMessages)
    let newMsgLogs = filteredMessages

    if (payload.type === 'previous') {
      newMsgLogs = currentMsgLogs
      newMsgLogs = _.concat(newMsgLogs, filteredMessages)
      const totalMessagesLengthNow = newMsgLogs.length
      const maxMessageLengthOnDom = 100
      if (totalMessagesLengthNow > maxMessageLengthOnDom) {
        newMsgLogs = _.takeRight(newMsgLogs, maxMessageLengthOnDom)
      }
    } else if (payload.type === 'next') {
      if (filteredMessages.length > 0) {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: true,
            messageLogsLoading: true,
          },
        })
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: 'Fetching new chats' },
        })
        newMsgLogs = _.concat(newMsgLogs, currentMsgLogs)

        const totalMessagesLengthNow = newMsgLogs.length
        const maxMessageLengthOnDom = 100
        if (totalMessagesLengthNow > maxMessageLengthOnDom) {
          newMsgLogs = _.take(newMsgLogs, maxMessageLengthOnDom)
        }
      } else {
        newMsgLogs = currentMsgLogs
      }
    }

    const len = newMsgLogs.length

    if (len > 0) {
      const updatedMessageLogs1 = newMsgLogs
      const pulled1 = _.last(updatedMessageLogs1)

      loadMoreId = pulled1.id

      const updatedMessageLogs2 = newMsgLogs
      const pulled2 = _.first(updatedMessageLogs2)

      pollingId = pulled2.id

      if (
        (payload.type === 'previous' || payload.type === 'current') &&
        success.data.length === 0
      ) {
        loadMoreId = 0
      }
    } else {
      loadMoreId = 0
      pollingId = 0
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        messageLogs: newMsgLogs,
        loading: false,
        messageLogsLoading: false,
        messageLogsLoadMoreId: loadMoreId,
        messageLogsPollingId: pollingId,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        messageLogs: [],
        loading: false,
        messageLogsLoading: false,
        messageLogsLoadMoreId: 0,
        messageLogsPollingId: 0,
      },
    })
  }
}

export function* GET_MESSAGE_CATEGORIES({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      messageCategoriesLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(getMessageCategories, payload.data, getAppHost(payload.appSettings))

    if (success && success.data) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          messageCategories: success.data,
          messageCategoriesLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          messageCategories: [],
          messageCategoriesLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        messageCategories: [],
        messageCategoriesLoading: false,
      },
    })
  }
}

/* GROUPS */

export function* GET_GROUP_MESSAGE_LOGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      groupMessageLogsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(
    groupMessageLogs,
    payload.data,
    payload.id,
    getAppHost(reduxStore.getState().apps.appSettings),
  )

  if (success && success.data) {
    const filteredMessages = _.filter(success.data, function fn(m) {
      return (
        m.category === 'message' ||
        (m.category === 'custom' && m.type !== 'extension_human-moderation')
      )
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        groupMessageLogs: filteredMessages,
        loading: false,
        groupMessageLogsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupMessageLogs: [],
        loading: false,
        groupMessageLogsLoading: false,
      },
    })
  }
}

export function* GET_MOD_MESSAGE_LOGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: payload.action === 'refresh_load',
      modMessageLogsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let msgId = 0
  if (!payload.action) payload.action = 'show_oldest'
  let loadMoreId = reduxStore.getState().apps.modMessageLogsLoadMoreId

  msgId = loadMoreId
  const { modMessageLogs: currentMsgLogs } = reduxStore.getState().apps

  if (payload.action === 'first_load' || payload.action === 'refresh_load') msgId = 0
  else if (payload.action === 'show_recent' && currentMsgLogs.length > 40) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
      },
    })
  }
  const success = yield call(modMessageLogs, payload.data, getAppHost(payload.appSettings), msgId)

  if (success && success.data) {
    const filteredMessages = _.filter(success.data, function fn(m) {
      return (
        m.category === 'custom' &&
        m.type === 'extension_human-moderation' &&
        m.data.customData !== undefined
      )
    })
    let newModMsgLogs = filteredMessages

    if (filteredMessages.length > 0) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: true,
          modMessageLogsLoading: true,
        },
      })
      if (payload.action !== 'first_load' && payload.action !== 'refresh_load') {
        newModMsgLogs = _.concat(currentMsgLogs, newModMsgLogs)
        newModMsgLogs = _.uniqBy(newModMsgLogs, function fn(e) {
          return e.id
        })
      }

      const totalMessagesLengthNow = newModMsgLogs.length
      const maxMessageLengthOnDom = 100
      if (totalMessagesLengthNow > maxMessageLengthOnDom) {
        if (payload.action === 'show_recent') {
          newModMsgLogs = _.takeRight(newModMsgLogs, maxMessageLengthOnDom)
          yield put({
            type: 'apps/INITIATE_NOTIFICATION',
            payload: { type: 'success', message: 'Fetching new chats' },
          })
        } else newModMsgLogs = _.take(newModMsgLogs, maxMessageLengthOnDom)
      }
    } else if (payload.action === 'refresh_load' && filteredMessages.length === 0) {
      newModMsgLogs = []
    } else {
      newModMsgLogs = currentMsgLogs
    }

    const len = newModMsgLogs.length

    if (len > 0) {
      const updatedMessageLogs1 = newModMsgLogs
      const pulled1 = _.last(updatedMessageLogs1)

      loadMoreId = pulled1.id
    } else {
      loadMoreId = 0
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        modMessageLogs: newModMsgLogs,
        loading: false,
        modMessageLogsLoading: false,
        modMessageLogsLoadMoreId: loadMoreId,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        modMessageLogs: [],
        loading: false,
        modMessageLogsLoading: false,
        modMessageLogsLoadMoreId: 0,
      },
    })
  }
}

/* LOG MSG DELETE */

export function* DELETE_MESSAGE_LOG({ payload }) {
  const { id } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, messageSearchLogs } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(msgLogDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    // Filter out the deleted message from search results
    const updatedMessageSearchLogs = messageSearchLogs.filter(msg => msg.id !== id)

    // Refresh Live list and update History list
    yield put({
      type: 'apps/GET_MESSAGE_LOGS',
      payload: { currentPage: 1, data: activeApp, type: 'current' },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        messageSearchLogs: updatedMessageSearchLogs,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Chat Deleted' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    }
  }
}

/* CHAT WIDGETS */

export function* CHAT_WIDGETS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areWidgetsLoading: true,
    },
  })
  const appData = reduxStore.getState().apps.active
  let chatWidgetProcessingCompleting = false
  const allExtensions = yield call(extensionsList, appData, 'installed')
  let chatWidgetListCall = false
  if (allExtensions && allExtensions.data) {
    let chatWidgetsList = []
    let chatWidgetsCombinedList = []
    let chatWidgetAppUrl = false
    let chatWidgetActive = []
    if (!_.isEmpty(allExtensions.data)) {
      const checkIndex = _.findIndex(allExtensions.data, function fn2(a) {
        return a.id === 'widget'
      })
      if (checkIndex >= 0) {
        chatWidgetAppUrl = allExtensions.data[checkIndex].adminURL
      }
      if (chatWidgetAppUrl) {
        chatWidgetAppUrl = _.replace(chatWidgetAppUrl, 'show-setting', 'settings')
        chatWidgetAppUrl = _.replace(chatWidgetAppUrl, 'v1', 'v2')
        chatWidgetListCall = yield call(chatWidgetListService, appData, chatWidgetAppUrl)
        if (chatWidgetListCall && chatWidgetListCall.data) {
          chatWidgetsList = chatWidgetListCall.data
          chatWidgetsCombinedList = chatWidgetListCall.data
          chatWidgetsList = _.filter(chatWidgetsList, function fn(cwl) {
            return cwl.configuration.version !== undefined && cwl.configuration.version === 'v2'
          })
        }
        if (payload !== undefined && payload.id !== undefined) {
          const { id } = payload
          if (id !== undefined && id && id.length) {
            const checkIndexWidget = _.findIndex(chatWidgetsList, function fn2(a) {
              return a.widgetId === id
            })

            if (checkIndexWidget >= 0) {
              chatWidgetActive = chatWidgetsList[checkIndexWidget]
            }
          }
        }
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: appData,
        chatWidgetsList,
        chatWidgetsCombinedList,
        chatWidgetAppUrl,
        chatWidgetActive,
        loading: false,
        areWidgetsLoading: false,
      },
    })
    if (payload.redirectToCustomize !== undefined && payload.redirectToCustomize) {
      yield put(push(`/app/${appData.id}/widgets/${payload.id}/detail`))
    } else if (payload !== undefined && payload.id !== undefined && _.isEmpty(chatWidgetActive)) {
      yield put(push(`/app/${appData.id}/widgets`))
    }
    chatWidgetProcessingCompleting = chatWidgetActive
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        chatWidgetsList: [],
        chatWidgetsCombinedList: [],
        chatWidgetAppUrl: false,
        chatWidgetActive: [],
        loading: false,
        areWidgetsLoading: false,
      },
    })
    if (
      allExtensions.error !== undefined &&
      allExtensions.error.code !== undefined &&
      isAuthErrorCode(allExtensions.error.code)
    ) {
      if (allExtensions.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push('/login'))
    }
    chatWidgetProcessingCompleting = true
  }
  return chatWidgetProcessingCompleting
}

export function* GET_CHAT_WIDGET({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const { chatWidgetsList } = reduxStore.getState().apps
  const { id } = payload
  const checkIndex = _.findIndex(chatWidgetsList, function fn2(a) {
    return a.widgetId === id
  })
  let chatWidgetActive = []
  if (checkIndex >= 0) {
    chatWidgetActive = chatWidgetsList[checkIndex]
    chatWidgetActive.widgetId = id
  }

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      chatWidgetActive,
      loading: false,
    },
  })
  if (!chatWidgetActive.length) {
    yield put(push(`/app/${payload.data.id}/widgets`))
  }
}

/* ADD_CHAT_WIDGET */

export function* ADD_CHAT_WIDGET() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { chatWidgetAppUrl } = reduxStore.getState().apps
  const currentChatWidgetsList = reduxStore.getState().apps.chatWidgetsList
  const currentCombinedChatWidgetsList = reduxStore.getState().apps.chatWidgetsCombinedList
  const currentChatWidgetsIds = _.map(currentCombinedChatWidgetsList, 'widgetId')
  const activeApp = reduxStore.getState().apps.active
  // const { apikeysAuthList } = reduxStore.getState().apps
  const defaultChatWidgetName = `My ${numberToWords.toWordsOrdinal(
    currentChatWidgetsList.length + 1,
  )} chat`
  let enableVoiceCallingValue = true
  let enableVideoCallingValue = true
  let enableSoundForCallingValue = true
  let enableCallingNotificationsValue = true
  const enableCallRecordingValue = false

  enableVoiceCallingValue = !(
    checkIfFeatureRestricted(activeApp, 'one_on_one_voice_call') &&
    checkIfFeatureRestricted(activeApp, 'group_voice_call')
  )
  enableVideoCallingValue = !(
    checkIfFeatureRestricted(activeApp, 'one_on_one_video_call') &&
    checkIfFeatureRestricted(activeApp, 'group_video_call')
  )

  enableSoundForCallingValue = !(
    checkIfFeatureRestricted(activeApp, 'one_on_one_voice_call') &&
    checkIfFeatureRestricted(activeApp, 'group_voice_call') &&
    checkIfFeatureRestricted(activeApp, 'one_on_one_video_call') &&
    checkIfFeatureRestricted(activeApp, 'group_video_call')
  )

  enableCallingNotificationsValue = !(
    checkIfFeatureRestricted(activeApp, 'one_on_one_voice_call') &&
    checkIfFeatureRestricted(activeApp, 'group_voice_call') &&
    checkIfFeatureRestricted(activeApp, 'one_on_one_video_call') &&
    checkIfFeatureRestricted(activeApp, 'group_video_call')
  )

  // enableCallRecordingValue = !checkIfFeatureRestricted(activeApp, 'call_recording')

  const filtered = {
    ids: currentChatWidgetsIds,
    settings: {
      version: 'v2',
      // authKey: apikeysAuthList.length ? apikeysAuthList[0].apiKey : '',
      name: defaultChatWidgetName,
      style: {
        primary_color: '#03A9F4',
        foreground_color: '#000000',
        background_color: '#FFFFFF',
        // width: '800px',
        // height: '600px',
        // rounded_corners: true,
        override_system_background_colors: true,
        custom_js: '',
        custom_css: '',
        docked_layout_icon_open: constants.chatWidgetDefaults.docked_layout_icon_open,
        docked_layout_icon_close: constants.chatWidgetDefaults.docked_layout_icon_close,
        docked_layout_icon_background: constants.chatWidgetDefaults.docked_layout_icon_background,
      },
      sidebar: {
        recent_chat_listing: 'all_chats',
        user_listing: 'all_users',
        group_listing: 'public_and_password_protected_groups',
        chats: true,
        users: true,
        groups: true,
        calls: false, // changed
        user_settings: false, // changed
        sidebar_navigation_sequence: ['chats', 'users', 'groups', 'calls', 'settings'],
        start_a_new_conversation: 'all_chats',
      },
      main: {
        enable_sending_messages: true,
        allow_mention_members: false,
        enable_editing_messages: true,
        enable_deleting_messages: true,
        hide_deleted_messages: false,
        enable_replying_to_messages: false,
        enable_threaded_replies: !checkIfFeatureRestricted(
          activeApp,
          'threaded_conversations_and_replies',
        ),
        enable_share_copy_forward_messages: false,
        highlight_messages_from_moderators: false,
        enable_voice_calling: enableVoiceCallingValue,
        enable_video_calling: enableVideoCallingValue,
        show_call_recording_option: enableCallRecordingValue,
        send_photos_videos: !checkIfFeatureRestricted(activeApp, 'share_files_and_multimedia'),
        send_files: true,
        send_voice_notes: !checkIfFeatureRestricted(activeApp, 'record_send_voice_messages'),
        send_emojis: !checkIfFeatureRestricted(activeApp, 'extension_emojis'),
        show_emojis_in_larger_size: true,
        send_gifs: false,
        share_live_reactions: !checkIfFeatureRestricted(activeApp, 'live_reactions'),
        share_location: false,
        set_groups_in_qna_mode_by_moderators: false,
        create_groups: true,
        allow_add_members: true,
        join_or_leave_groups: true,
        hide_join_leave_notifications: false,
        allow_delete_groups: true,
        view_group_members: true,
        view_shared_media: true,
        send_message_in_private_to_group_member: false,
        show_typing_indicators: !checkIfFeatureRestricted(activeApp, 'typing_indicators'),
        show_delivery_read_indicators: !checkIfFeatureRestricted(activeApp, 'read_receipts'),
        show_user_presence: !checkIfFeatureRestricted(activeApp, 'user_presence'),
        show_call_notifications: enableCallingNotificationsValue,
        block_user: !checkIfFeatureRestricted(activeApp, 'user_to_user_blocking'),
        allow_moderator_to_delete_member_messages: false,
        allow_kick_ban_members: !(
          checkIfFeatureRestricted(activeApp, 'group_moderators') ||
          checkIfFeatureRestricted(activeApp, 'group_kick_member') ||
          checkIfFeatureRestricted(activeApp, 'group_ban_member')
        ),
        allow_promote_demote_members: !checkIfFeatureRestricted(activeApp, 'group_moderators'),
        allow_creating_polls: false,
        enable_sound_for_calls: enableSoundForCallingValue,
        enable_sound_for_messages: true,
        show_stickers: false,
        allow_message_reactions: false,
        enable_collaborative_document: false,
        enable_collaborative_whiteboard: false,
        enable_message_translation: false,
        send_reply_in_private_to_group_member: false,
      },
    },
  }
  const success = yield call(chatWidgetAdd, filtered, activeApp, chatWidgetAppUrl)

  if (success && success.data) {
    yield put({
      type: 'apps/CHAT_WIDGETS_LIST',
      payload: {
        data: activeApp,
        id: success.data.widgetId,
        redirectToCustomize: true,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Widget created' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
  }
}

/* UPDATE_CHAT_WIDGET */

export function* UPDATE_CHAT_WIDGET({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { chatWidgetActive } = reduxStore.getState().apps
  const { widgetId } = reduxStore.getState().apps.chatWidgetActive

  const activeApp = reduxStore.getState().apps.active

  const filtered = { settings: chatWidgetActive.configuration }
  filtered.settings.widgetId = widgetId
  if (payload.selectedComponent === 'GLOBAL') {
    filtered.settings.style = {
      primary_color: '#03A9F4',
      foreground_color: '#000000',
      background_color: '#FFFFFF',
      // override_system_background_colors: payload.values.override_system_background_colors,
      override_system_background_colors: true,
      custom_css: payload.values.custom_css,
      custom_js: payload.values.custom_js,
      docked_layout_icon_open: payload.values.docked_layout_icon_open,
      docked_layout_icon_close: payload.values.docked_layout_icon_close,
      docked_layout_icon_background: payload.values.docked_layout_icon_background,
    }

    filtered.settings.name = payload.values.name
  } else if (payload.selectedComponent === 'SIDEBAR') {
    const sidebarSettings = {
      recent_chat_listing: payload.values.recent_chat_listing,
      user_listing: payload.values.user_listing,
      group_listing: payload.values.group_listing,
      chats: payload.values.sidebar_chats,
      users: payload.values.sidebar_users,
      groups: payload.values.sidebar_groups,
      calls: payload.values.sidebar_calls,
      user_settings: payload.values.sidebar_user_settings,
      sidebar_navigation_sequence: payload.values.sidebar_navigation_sequence,
      start_a_new_conversation: payload.values.start_a_new_conversation,
    }
    filtered.settings.sidebar = sidebarSettings
  } else if (payload.selectedComponent === 'MAIN') {
    const mainSettings = {
      enable_sending_messages: payload.values.enable_sending_messages,
      allow_mention_members: payload.values.allow_mention_members,
      enable_editing_messages: payload.values.enable_editing_messages,
      enable_deleting_messages: payload.values.enable_deleting_messages,
      hide_deleted_messages: payload.values.hide_deleted_messages,
      enable_replying_to_messages: payload.values.enable_replying_to_messages,
      enable_threaded_replies: payload.values.enable_threaded_replies,
      enable_share_copy_forward_messages: payload.values.enable_share_copy_forward_messages,
      highlight_messages_from_moderators: payload.values.highlight_messages_from_moderators,
      enable_voice_calling: payload.values.enable_voice_calling,
      enable_video_calling: payload.values.enable_video_calling,
      show_call_recording_option: payload.values.show_call_recording_option,
      send_photos_videos: payload.values.send_photos_videos,
      send_files: payload.values.send_files,
      send_voice_notes: payload.values.send_voice_notes,
      send_emojis: payload.values.send_emojis,
      show_emojis_in_larger_size: payload.values.show_emojis_in_larger_size,
      send_gifs: payload.values.send_gifs,
      share_live_reactions: payload.values.share_live_reactions,
      share_location: payload.values.share_location,
      set_groups_in_qna_mode_by_moderators: payload.values.set_groups_in_qna_mode_by_moderators,
      create_groups: payload.values.create_groups,
      allow_add_members: payload.values.allow_add_members,
      join_or_leave_groups: payload.values.join_or_leave_groups,
      hide_join_leave_notifications: payload.values.hide_join_leave_notifications,
      allow_delete_groups: payload.values.allow_delete_groups,
      view_group_members: payload.values.view_group_members,
      view_shared_media: payload.values.view_shared_media,
      send_message_in_private_to_group_member:
        payload.values.send_message_in_private_to_group_member,
      show_typing_indicators: payload.values.show_typing_indicators,
      show_delivery_read_indicators: payload.values.show_delivery_read_indicators,
      show_user_presence: payload.values.show_user_presence,
      show_call_notifications: payload.values.show_call_notifications,
      block_user: payload.values.block_user,
      allow_moderator_to_delete_member_messages:
        payload.values.allow_moderator_to_delete_member_messages,
      allow_kick_ban_members: payload.values.allow_kick_ban_members,
      allow_promote_demote_members: payload.values.allow_promote_demote_members,
      allow_creating_polls: payload.values.allow_creating_polls,
      enable_sound_for_messages: payload.values.enable_sound_for_messages,
      enable_sound_for_calls: payload.values.enable_sound_for_calls,
      show_stickers: payload.values.show_stickers,
      allow_message_reactions: payload.values.allow_message_reactions,
      enable_collaborative_document: payload.values.enable_collaborative_document,
      enable_collaborative_whiteboard: payload.values.enable_collaborative_whiteboard,
      enable_message_translation: payload.values.enable_message_translation,
      send_reply_in_private_to_group_member: payload.values.send_reply_in_private_to_group_member,
    }
    filtered.settings.main = mainSettings
  }

  const success = yield call(chatWidgetUpdate, filtered, activeApp, payload.chatWidgetAppUrl)

  if (success) {
    yield put({
      type: 'apps/CHAT_WIDGETS_LIST',
      payload: { data: activeApp, id: widgetId },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Widget saved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
    yield put(push(`/app/${activeApp.id}/widgets`))
  }
  return success
}

export function* APPROVE_MOD_MESSAGE({ payload }) {
  const { modMessage } = payload
  const activeApp = reduxStore.getState().apps.active

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(modMessageLogsApprove, modMessage, activeApp)
  if (success && success.success) {
    yield put({
      type: 'apps/GET_MOD_MESSAGE_LOGS',
      payload: { currentPage: 1, action: 'refresh_load', data: activeApp, type: 'current' },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Chat Approved' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to approve' },
    })
  }
}

export function* REJECT_MOD_MESSAGE({ payload }) {
  const { modMessage } = payload

  const activeApp = reduxStore.getState().apps.active

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(modMessageLogsReject, modMessage, activeApp)

  if (success && success.success) {
    yield put({
      type: 'apps/GET_MOD_MESSAGE_LOGS',
      payload: { currentPage: 1, action: 'refresh_load', data: activeApp, type: 'current' },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Chat Rejected' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to reject' },
    })
  }
}

export function* DELETE_GROUP_MESSAGE_LOG({ payload }) {
  const { id } = payload

  const activeApp = reduxStore.getState().apps.active

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(
    groupMsgLogDelete,
    id,
    activeApp,
    getAppHost(reduxStore.getState().apps.appSettings),
  )

  if (success && success.data) {
    yield put({
      type: 'apps/GET_GROUP_MESSAGE_LOGS',
      payload: { id, currentPage: 1, data: activeApp },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Chat deleted' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Error deleting message' },
      })
    }
  }
}

/* UNREAD_BADGE_COUNT_TOGGLE_REQUEST_MANUAL_INTENT */

export function* UNREAD_BADGE_COUNT_TOGGLE_REQUEST_MANUAL_INTENT({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    const { requestedState } = payload
    const intent = _.join(
      [
        constants.ManualOutreachIntents['unread-badge-count-toggle-request'],
        activeApp.id,
        `requested-state: ${requestedState ? 'enable' : 'disable'}`,
      ],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)
    if (success && success.data) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message: `Request submitted successfully. We'll get back to you soon!`,
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details?.name || 'Request failed' },
        })
      }
    }
    return success
  }
}

/* IMPORT_USERS_REQUEST_MANUAL_INTENT */

export function* IMPORT_USERS_REQUEST_MANUAL_INTENT({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    const intent = _.join(
      [constants.ManualOutreachIntents['import-users-request'], activeApp.id, payload.importFrom],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)
    if (success && success.data) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message: `Response recorded, we'll get back to you soon!`,
        },
      })
      yield put({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'visibleModalID',
          value: '',
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      }
    }
    return success
  }
}

export function* SHOW_IMPORT_USER_REQUEST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      currentIntentRequest: '',
    },
  })
  const { intent: currentIntentRequest } = payload
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      currentIntentRequest,
    },
  })
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      visibleModalID: 'importUserRequest',
    },
  })
}

/* TEAM COLLABORATION */

export function* TEAM_COLLABORATOR_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areTeamMembersLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  const userData = reduxStore.getState().user
  const searchText = reduxStore.getState().apps.teamCollaboratorSearchText
  const success = yield call(appCollaboratorsList, payload.data, payload.currentPage, searchText)

  if (success && success.data) {
    let totalCollaboratorCount = success.data.length

    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalCollaboratorCount = success.meta.pagination.total
    }
    let sortedList = success.data
    if (sortedList.length > 0) {
      const loggedInCollaboratorIndex = _.findIndex(sortedList, function fn(sl) {
        return _.toLower(sl.email) === _.toLower(userData.email)
      })
      if (loggedInCollaboratorIndex > 0) {
        const loggedInCollaboratorValue = sortedList[loggedInCollaboratorIndex]
        _.pullAt(sortedList, [loggedInCollaboratorIndex])
        sortedList = _.concat(sortedList, loggedInCollaboratorValue)
        sortedList = _.reverse(sortedList)
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        teamCollaboratorsList: sortedList,
        teamCollaboratorsListTotal: totalCollaboratorCount,
        loading: false,
        areTeamMembersLoading: false,
      },
    })
  } else if (success && success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: success.errDescription },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        teamCollaboratorsList: [],
        teamCollaboratorsListTotal: 0,
        loading: false,
        areTeamMembersLoading: false,
      },
    })
  }

  if (
    success.error !== undefined &&
    success.error.code !== undefined &&
    isAuthErrorCode(success.error.code)
  ) {
    if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
      yield put({
        type: 'user/LOGOUT',
      })
    } else yield put(push(`/login`))
  } else if (success && success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: success.errDescription },
    })
  }
}

/* COLLABORATOR ADD */

export function* TEAM_COLLABORATOR_INVITE({ payload, appCreated }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let activeApp = appCreated
  if (activeApp === undefined) {
    activeApp = reduxStore.getState().apps.active
  }
  let success = []
  if (
    appCreated ||
    (activeApp.role !== undefined && (isAppAdmin(activeApp) || isAppOwner(activeApp)))
  ) {
    success = yield call(collaboratorAdd, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: 'apps/TEAM_COLLABORATOR_LIST',
        payload: { currentPage: 1, data: activeApp },
      })
      let invitationSuccess = false
      let invitationActionMsg = 'Invitation not sent. Please try again.'
      if (payload.admins && payload.admins.length > 0) {
        const invitationEmail = payload.admins[0]

        if (
          success.data.admins[invitationEmail] !== undefined &&
          success.data.admins[invitationEmail].success &&
          success.data.admins[invitationEmail].sentInvitation
        ) {
          invitationSuccess = true
        } else if (
          success.data.admins !== undefined &&
          success.data.admins[invitationEmail] !== undefined &&
          success.data.admins[invitationEmail].success &&
          success.data.admins[invitationEmail].alreadyAcceptedInvite &&
          success.data.admins[invitationEmail].collaboratorExists
        ) {
          invitationActionMsg = 'This user is an existing collaborator'
        } else if (
          success.data.admins !== undefined &&
          success.data.admins[invitationEmail] !== undefined &&
          success.data.admins[invitationEmail].error !== undefined
        ) {
          if (success.data.admins[invitationEmail].error.code === 'ERR_SELF_ACTION_DENIED') {
            invitationActionMsg = 'You are already collaborating in this app! :)'
          } else if (success.data.admins[invitationEmail].error.code === 'ERR_ALREADY_AN_OWNER') {
            invitationActionMsg = 'This user is an existing collaborator (owner)'
          } else {
            invitationActionMsg = success.data.admins[invitationEmail].error.message
          }
        }
      } else if (payload.developers && payload.developers.length > 0) {
        const invitationEmail = payload.developers[0]
        if (
          success.data.developers !== undefined &&
          success.data.developers[invitationEmail] !== undefined &&
          success.data.developers[invitationEmail].success &&
          success.data.developers[invitationEmail].sentInvitation
        ) {
          invitationSuccess = true
        } else if (
          success.data.developers !== undefined &&
          success.data.developers[invitationEmail] !== undefined &&
          success.data.developers[invitationEmail].success &&
          success.data.developers[invitationEmail].alreadyAcceptedInvite &&
          success.data.developers[invitationEmail].collaboratorExists
        ) {
          invitationActionMsg = 'This user is an existing collaborator'
        } else if (
          success.data.developers !== undefined &&
          success.data.developers[invitationEmail] !== undefined &&
          success.data.developers[invitationEmail].error !== undefined
        ) {
          if (success.data.developers[invitationEmail].error.code === 'ERR_SELF_ACTION_DENIED') {
            invitationActionMsg = 'You are already collaborating in this app! :)'
          } else if (
            success.data.developers[invitationEmail].error.code === 'ERR_ALREADY_AN_OWNER'
          ) {
            invitationActionMsg = 'This user is an existing collaborator (owner)'
          } else {
            invitationActionMsg = success.data.developers[invitationEmail].error.message
          }
        }
      } else if (payload.moderators && payload.moderators.length > 0) {
        const invitationEmail = payload.moderators[0]
        if (
          success.data.moderators !== undefined &&
          success.data.moderators[invitationEmail] !== undefined &&
          success.data.moderators[invitationEmail].success &&
          success.data.moderators[invitationEmail].sentInvitation
        ) {
          invitationSuccess = true
        } else if (
          success.data.moderators !== undefined &&
          success.data.moderators[invitationEmail] !== undefined &&
          success.data.moderators[invitationEmail].success &&
          success.data.moderators[invitationEmail].alreadyAcceptedInvite &&
          success.data.moderators[invitationEmail].collaboratorExists
        ) {
          invitationActionMsg = 'This user is an existing collaborator'
        } else if (
          success.data.moderators !== undefined &&
          success.data.moderators[invitationEmail] !== undefined &&
          success.data.moderators[invitationEmail].error !== undefined
        ) {
          if (success.data.moderators[invitationEmail].error.code === 'ERR_SELF_ACTION_DENIED') {
            invitationActionMsg = 'You are already collaborating in this app! :)'
          } else if (
            success.data.moderators[invitationEmail].error.code === 'ERR_ALREADY_AN_OWNER'
          ) {
            invitationActionMsg = 'This user is an existing collaborator (owner)'
          } else {
            invitationActionMsg = success.data.moderators[invitationEmail].error.message
          }
        }
      }
      if (invitationSuccess) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: 'Invitation sent' },
        })
      } else if (success && success.error) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.errDescription },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: invitationActionMsg },
        })
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_ACCESS_DENIED') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'error',
            message: 'Access Denied - you are not authorized to perform this action',
          },
        })
      } else if (success.error.message !== undefined) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Some error occurred' },
        })
      }
    }
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Access Denied - you are not authorized to perform this action',
      },
    })
    yield put(push(`/app/${activeApp.id}/members`))
  }

  return success
}

/* COLLABORATOR REMOVE */

export function* TEAM_COLLABORATOR_REMOVE({ payload, removalType }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  if (activeApp.role !== undefined && (activeApp.role === 'admin' || activeApp.role === 'owner')) {
    const success = yield call(collaboratorRemove, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: 'apps/TEAM_COLLABORATOR_LIST',
        payload: { currentPage: 1, data: activeApp },
      })
      let removeCollaboratorSuccess = false
      let removeCollaboratorActionMsg =
        'Collaborator removal is not successful. Please try refreshing the page and try again.'
      const collaboratorToRemoveEmail = payload.collaboratorsToRemove[0]

      if (
        success.data.collaboratorsToRemove !== undefined &&
        success.data.collaboratorsToRemove[collaboratorToRemoveEmail] !== undefined &&
        success.data.collaboratorsToRemove[collaboratorToRemoveEmail].success
      ) {
        removeCollaboratorSuccess = true
        if (removalType === 'remove') removeCollaboratorActionMsg = 'Collaborator removed'
        else removeCollaboratorActionMsg = 'Invitation cancelled'
      }

      if (removeCollaboratorSuccess) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: removeCollaboratorActionMsg },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: removeCollaboratorActionMsg },
        })
      }
    } else if (success && success.error) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.errDescription },
      })
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      success.error.code === 'ERR_BAD_REQUEST'
    ) {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED'
      ) {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      success.error.code === 'ERR_ACCESS_DENIED'
    ) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Access Denied - you are not authorized to perform this action',
        },
      })
    } else if (success.error !== undefined && success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Access Denied - you are not authorized to perform this action',
      },
    })
  }
}

/* TEAM_COLLABORATOR_CHANGE_ROLE  */

export function* TEAM_COLLABORATOR_CHANGE_ROLE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  if (activeApp.role !== undefined && (isAppAdmin(activeApp) || isAppOwner(activeApp))) {
    const success = yield call(collaboratorChangeRole, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: 'apps/TEAM_COLLABORATOR_LIST',
        payload: { currentPage: 1, data: activeApp },
      })
      let changeCollaboratorRoleSuccess = false
      let changeCollaboratorRoleActionMsg =
        'Collaborator role update is not successful. Please try refreshing the page and try again.'
      if (payload.admins && payload.admins.length > 0) {
        const invitationEmail = payload.admins[0]
        if (
          success.data.admins !== undefined &&
          success.data.admins[invitationEmail] !== undefined &&
          success.data.admins[invitationEmail].success &&
          success.data.admins[invitationEmail].changedRole
        ) {
          changeCollaboratorRoleSuccess = true
          changeCollaboratorRoleActionMsg = `Collaborator is now an admin`
        }
      } else if (payload.moderators && payload.moderators.length > 0) {
        const invitationEmail = payload.moderators[0]
        if (
          success.data.moderators !== undefined &&
          success.data.moderators[invitationEmail] !== undefined &&
          success.data.moderators[invitationEmail].success &&
          success.data.moderators[invitationEmail].changedRole
        ) {
          changeCollaboratorRoleSuccess = true
          changeCollaboratorRoleActionMsg = `Collaborator is now a Moderator.`
        }
      } else if (payload.developers && payload.developers.length > 0) {
        const invitationEmail = payload.developers[0]
        if (
          success.data.developers !== undefined &&
          success.data.developers[invitationEmail] !== undefined &&
          success.data.developers[invitationEmail].success &&
          success.data.developers[invitationEmail].changedRole
        ) {
          changeCollaboratorRoleSuccess = true
          changeCollaboratorRoleActionMsg = `Collaborator is now a Developer.`
        }
      }
      if (changeCollaboratorRoleSuccess) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: changeCollaboratorRoleActionMsg },
        })

        yield put(push(`/app/${activeApp.id}/members`))
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: changeCollaboratorRoleActionMsg },
        })
      }
    } else if (success && success.error) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.errDescription },
      })
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (
      success.error !== undefined &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({
          type: 'user/LOGOUT',
        })
      } else yield put(push(`/login`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_ACCESS_DENIED') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Access Denied - you are not authorized to perform this action',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
    yield put(push(`/app/${activeApp.id}/members`))
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Access Denied - you are not authorized to perform this action',
      },
    })
    yield put(push(`/app/${activeApp.id}/members`))
  }
}

/*   TEAM_COLLABORATOR_LEAVE
 */

export function* TEAM_COLLABORATOR_LEAVE() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const success = yield call(collaboratorLeave, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/ENTER_APP_TEXT',
      payload: {
        searchText: '',
        clearText: true,
      },
    })
    yield put({
      type: 'apps/LIST',
      payload: { currentPage: 1 },
    })
    yield put(push(`/apps`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'You are no longer a collaborator' },
    })
  } else if (success && success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: success.errDescription },
    })
  }

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
  if (
    success.error !== undefined &&
    success.error.code !== undefined &&
    isAuthErrorCode(success.error.code)
  ) {
    if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
      yield put({
        type: 'user/LOGOUT',
      })
    } else yield put(push(`/login`))
  } else if (success.error.code === 'ERR_BAD_REQUEST') {
    _.forEach(success.error.details, function fn(value) {
      message.error(value)
    })
  } else if (success.error.code === 'ERR_OWNER_LEAVE_DENIED') {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Access Denied - Owner is not allowed to leave the group',
      },
    })
  } else if (success.error.message !== undefined) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: success.error.message },
    })
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Some error occurred' },
    })
  }
  yield put(push(`/app/${activeApp.id}/members`))
}

/* COLLABORATOR TRANSFER_OWNERSHIP */

export function* TEAM_TRANSFER_OWNERSHIP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  if (activeApp.role !== undefined && activeApp.role === 'owner') {
    // NOTE: transfer ownership API is commented for now. The backend transfer wasn't
    // updating the owner at the Chargebee end, so for now we only raise a manual outreach
    // request and support performs the actual ownership transfer (incl. Chargebee) manually.
    // const success = yield call(collaboratorTransferOwnership, payload, activeApp)

    const intent = _.join(
      [
        constants.ManualOutreachIntents['transfer-ownership-request'],
        activeApp.id,
        `new-owner: ${payload.email}`,
        `previous-owner: ${_.toLower(reduxStore.getState().user.email)}`,
      ],
      ' / ',
    )
    const success = yield call(manualOutreach, { intent })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success && success.data) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message:
            'Your request to transfer app ownership has been submitted. Our team will get back to you shortly.',
        },
      })
    } else if (
      success &&
      success.error &&
      success.error.code !== undefined &&
      isAuthErrorCode(success.error.code)
    ) {
      if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
        yield put({ type: 'user/LOGOUT' })
      } else {
        yield put(push(`/login`))
      }
    }
    // Any other failure already surfaces a warning notification from the manualOutreach service.
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Access Denied - you are not authorized to perform this action',
      },
    })
  }
}

/* ENTER_TEAM_COLLABORATOR_TEXT */

export function* ENTER_TEAM_COLLABORATOR_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        teamCollaboratorSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        teamCollaboratorSearchText: searchText,
        loading: true,
      },
    })

    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_TEAM_COLLABORATOR',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_TEAM_COLLABORATOR */

export function* SEARCH_TEAM_COLLABORATOR() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const userData = reduxStore.getState().user
  const searchText = reduxStore.getState().apps.teamCollaboratorSearchText

  const success = yield call(collaboratorsSearch, activeApp, searchText)

  if (success && success.data) {
    let totalCollaboratorCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalCollaboratorCount = success.meta.pagination.total
    }
    let sortedList = success.data
    if (sortedList.length > 0) {
      const loggedInCollaboratorIndex = _.findIndex(sortedList, function fn(sl) {
        return _.toLower(sl.email) === _.toLower(userData.email)
      })
      if (loggedInCollaboratorIndex > 0) {
        const loggedInCollaboratorValue = sortedList[loggedInCollaboratorIndex]
        _.pullAt(sortedList, [loggedInCollaboratorIndex])
        sortedList = _.concat(sortedList, loggedInCollaboratorValue)
        sortedList = _.reverse(sortedList)
      }
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        teamCollaboratorsList: sortedList,
        teamCollaboratorsListTotal: totalCollaboratorCount,
        loading: false,
      },
    })
  } else if (success && success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: success.errDescription },
    })
  }
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      active: activeApp,
      teamCollaboratorsListTotal: 0,
      loading: false,
    },
  })
  if (
    success.error !== undefined &&
    success.error.code !== undefined &&
    isAuthErrorCode(success.error.code)
  ) {
    if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
      yield put({
        type: 'user/LOGOUT',
      })
    } else yield put(push(`/login`))
  }
}

export function* ENTER_USER_FRIEND_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        friendUserSearchText: '',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        friendUserSearchText: searchText,
      },
    })
    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_USER_FRIEND',
      })
    }
  }
}

/* GROUP_USER_SEARCH */

export function* SEARCH_USER_FRIEND() {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.friendUserSearchText
  const { uid } = reduxStore.getState().apps.usersActive
  const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let userNonFriendsList = success.data
    if (userNonFriendsList.length) {
      userNonFriendsList = _.filter(userNonFriendsList, function fn(unf) {
        return unf.uid !== uid
      })
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        userNonFriendsList,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        userNonFriendsList: [],
      },
    })
  }
}

/* UNFRIEND_USER */

export function* UNFRIEND_USER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings, uFriendsListPagination } = reduxStore.getState().apps

  const { uid } = reduxStore.getState().apps.usersActive
  const { friendUID } = payload
  const success = yield call(userRemoveFriends, uid, friendUID, activeApp, getAppHost(appSettings))
  if (success && success.data) {
    const friendsListPageNo =
      uFriendsListPagination !== undefined && uFriendsListPagination.count > 1
        ? uFriendsListPagination.current_page
        : 1

    const friendsRes = yield call(
      userFriendList,
      uid,
      activeApp,
      getAppHost(appSettings),
      friendsListPageNo,
    )
    let totalUserFriendCount = 0
    if (friendsRes.data.length) {
      if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
        totalUserFriendCount = friendsRes.meta.pagination.total_pages * 10
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uFriendsList: friendsRes.data,
        uFriendsListTotal: totalUserFriendCount,
        uFriendsListPagination: friendsRes.meta.pagination,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `User removed as a friend` },
    })
  } else {
    const friendsRes = yield call(userFriendList, uid, activeApp, getAppHost(appSettings))
    let totalUserFriendCount = 0
    if (friendsRes.data.length) {
      if (friendsRes.meta && friendsRes.meta.pagination && friendsRes.meta.pagination.total_pages) {
        totalUserFriendCount =
          friendsRes.meta.pagination.total_pages * friendsRes.meta.pagination.per_page
      }
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        uFriendsList: friendsRes.data,
        uFriendsListTotal: totalUserFriendCount,
        uFriendsListPagination: friendsRes.meta.pagination,
        loading: false,
      },
    })
    if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* APP METRICS */

export function* GET_METRICS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      metricsLoading: true,
    },
  })

  if (!payload.dcuCurrentFilter) payload.dcuCurrentFilter = 30
  if (!payload.pcuCurrentFilter) payload.pcuCurrentFilter = 30
  if (!payload.ccuCurrentFilter) payload.ccuCurrentFilter = 60

  if (!payload.voiceCurrentFilter) payload.voiceCurrentFilter = 30
  if (!payload.videoCurrentFilter) payload.videoCurrentFilter = 30

  if (!payload.mauCurrentFilter) payload.mauCurrentFilter = 3
  if (!payload.mcuCurrentFilter) payload.mcuCurrentFilter = 3

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let metricsPlanSupport = false
  metricsPlanSupport = checkIfAnalyticsIsSupported(payload.data)
  let requestTimeOut = false
  const nowDate = new Date()

  const endRange = nowDate.getTime()
  // const timezoneDiffInMs = nowDate.getTimezoneOffset() * 60 * 1000
  let metricsAUCDay = '0'
  let metricsAUCMonth = '0'
  let metricsAUCPeak = '0'
  let metricsAVoMToday = '0'
  let metricsAViMToday = '0'
  let metricsAReMToday = '0'

  // DCU

  const startRangeTempDCU = endRange - (payload.dcuCurrentFilter - 1) * 24 * 60 * 60 * 1000
  const startRangeTempDateDCU = new Date(startRangeTempDCU)
  const startRangeDateDCU = new Date(
    startRangeTempDateDCU.getFullYear(),
    startRangeTempDateDCU.getMonth(),
    startRangeTempDateDCU.getDate(),
  )
  const startRangeDCU = startRangeDateDCU.getTime()

  const metricsDcuXaxisValues = [startRangeDCU]
  let metricsDcu = [metricsDcuXaxisValues[0], 0]
  const metricsDcuNoData = [metricsDcuXaxisValues[0], 0]
  let isDCUEmpty = true
  for (let i = 1; i <= payload.dcuCurrentFilter; i += 1) {
    if (i === payload.dcuCurrentFilter) {
      metricsDcuXaxisValues[i] = endRange
      metricsDcu[i] = [endRange, 0]
      metricsDcuNoData[i] = [endRange, 0]
    } else {
      metricsDcuXaxisValues[i] = startRangeDCU + i * 24 * 60 * 60 * 1000
    }
  }

  for (let i = 0; i < payload.dcuCurrentFilter; i += 1) {
    metricsDcu[i] = [metricsDcuXaxisValues[i], 0]
    metricsDcuNoData[i] = [metricsDcuXaxisValues[i], 0]
  }
  let dcuServiceParams = {}
  dcuServiceParams = {
    type: 'dcu',
    startRange: metricsDcuXaxisValues[0],
    endRange,
  }
  let successDcu = { data: false, appSettings: [] }

  // MAU
  const metricsMauXaxisValues = [
    getTimestampOfMonth(2, 1) * 1000,
    getTimestampOfMonth(1) * 1000,
    endRange,
  ]

  let metricsMau = []
  const metricsMauNoData = []
  let isMAUEmpty = true

  let mauServiceParams = {}
  mauServiceParams = {
    type: 'mau',
    startRange: metricsMauXaxisValues[0],
    endRange,
  }
  let successMau = { data: false, appSettings: [] }

  // MAU
  const metricsMcuXaxisValues = [
    getTimestampOfMonth(2, 1) * 1000,
    getTimestampOfMonth(1) * 1000,
    endRange,
  ]

  let metricsMcu = []
  const metricsMcuNoData = []
  let isMCUEmpty = true

  let mcuServiceParams = {}
  mcuServiceParams = {
    type: 'mcu',
    startRange: metricsMcuXaxisValues[0],
    endRange,
  }
  let successMcu = { data: false, appSettings: [] }

  // PEAK CCU

  const startRangePeakTemp = endRange - (payload.pcuCurrentFilter - 1) * 24 * 60 * 60 * 1000
  const startRangePeakTempDate = new Date(startRangePeakTemp)
  const startRangePeakDate = new Date(
    startRangePeakTempDate.getFullYear(),
    startRangePeakTempDate.getMonth(),
    startRangePeakTempDate.getDate(),
  )
  const startRangePeak = startRangePeakDate.getTime()

  const metricsPeakXaxisValues = [startRangePeak]
  let metricsPeak = [metricsPeakXaxisValues[0], 0]
  const metricsPeakNoData = [metricsPeakXaxisValues[0], 0]
  let isPeakEmpty = true
  for (let i = 1; i <= payload.pcuCurrentFilter; i += 1) {
    if (i === payload.pcuCurrentFilter) {
      metricsPeakXaxisValues[i] = endRange
      metricsPeak[i] = [endRange, 0]
      metricsPeakNoData[i] = [endRange, 0]
    } else {
      metricsPeakXaxisValues[i] = startRangePeak + i * 24 * 60 * 60 * 1000
    }
  }

  for (let i = 0; i < payload.pcuCurrentFilter; i += 1) {
    metricsPeak[i] = [metricsPeakXaxisValues[i], 0]
    metricsPeakNoData[i] = [metricsPeakXaxisValues[i], 0]
  }
  let successPeak = { data: false }

  const peakCallServiceParams = { startRange: metricsPeakXaxisValues[0], endRange, type: 'pcc' }

  // Voice and Video Analytics

  // const startRangeVoiceTemp = endRange - (payload.videoCurrentFilter - 1) * 24 * 60 * 60 * 1000
  const startRangeVideoTemp = endRange - (payload.videoCurrentFilter - 1) * 24 * 60 * 60 * 1000

  // const startRangeVoiceTempDate = new Date(startRangeVideoTemp)
  const startRangeVideoTempDate = new Date(startRangeVideoTemp)

  // const startRangeVoiceDate = new Date(
  //   startRangeVoiceTempDate.getFullYear(),
  //   startRangeVoiceTempDate.getMonth(),
  //   startRangeVoiceTempDate.getDate(),
  // )

  const startRangeVideoDate = new Date(
    startRangeVideoTempDate.getFullYear(),
    startRangeVideoTempDate.getMonth(),
    startRangeVideoTempDate.getDate(),
  )

  const startRangeVoice = startRangeVideoDate.getTime()
  const startRangeVideo = startRangeVideoDate.getTime()

  const metricsVoiceXaxisValues = [startRangeVideo]
  const metricsVideoXaxisValues = [startRangeVideo]
  const metricsRecordingXaxisValues = [startRangeVideo]

  let metricsVoice = [metricsVoiceXaxisValues[0], 0]
  let metricsVideo = [metricsVideoXaxisValues[0], 0]
  let metricsRecording = [metricsRecordingXaxisValues[0], 0]

  const metricsVoiceNoData = [metricsVoiceXaxisValues[0], 0]
  const metricsVideoNoData = [metricsVideoXaxisValues[0], 0]
  const metricsRecordingNoData = [metricsRecordingXaxisValues[0], 0]

  for (let i = 0; i < payload.videoCurrentFilter; i += 1) {
    metricsVoiceXaxisValues[i] = startRangeVoice + i * 24 * 60 * 60 * 1000
    metricsVoice[i] = [metricsVoiceXaxisValues[i], 0]
    metricsVoiceNoData[i] = [metricsVoiceXaxisValues[i], 0]
  }
  for (let i = 0; i < payload.videoCurrentFilter; i += 1) {
    metricsVideoXaxisValues[i] = startRangeVoice + i * 24 * 60 * 60 * 1000
    metricsVideo[i] = [metricsVideoXaxisValues[i], 0]
    metricsVideoNoData[i] = [metricsVideoXaxisValues[i], 0]
  }
  for (let i = 0; i < payload.videoCurrentFilter; i += 1) {
    metricsRecordingXaxisValues[i] = startRangeVoice + i * 24 * 60 * 60 * 1000
    metricsRecording[i] = [metricsRecordingXaxisValues[i], 0]
    metricsRecordingNoData[i] = [metricsRecordingXaxisValues[i], 0]
  }

  let successVoice = { data: false }
  let successVideo = { data: false }
  let successRecording = { data: false }

  const voiceVideoCallServiceParams = {
    startRange: metricsVoiceXaxisValues[0],
    endRange,
  }

  const getMetricCalls = yield call(
    getMetrics,
    payload.data,
    mauServiceParams,
    peakCallServiceParams,
    voiceVideoCallServiceParams,
    mcuServiceParams,
    dcuServiceParams,
  )

  if (getMetricCalls.metricSuccess !== undefined && getMetricCalls.metricSuccess) {
    successMau = getMetricCalls.mau
    successPeak = getMetricCalls.peakCcu
    successVoice = getMetricCalls.voice
    successVideo = getMetricCalls.video
    successRecording = getMetricCalls.recording
    successMcu = getMetricCalls.mcu
    successDcu = getMetricCalls.dcu
  } else if (getMetricCalls.err_code !== undefined) {
    requestTimeOut = true
  }

  if (!requestTimeOut) {
    if (successMau.data) {
      const metricsMauDataResponse = successMau.data

      if (metricsMauDataResponse.length > 0) {
        _.forEach(metricsMauDataResponse, function fn(mdx, key) {
          isMAUEmpty = false
          metricsMau[key] = [mdx, metricsMauDataResponse[key].MAU]
          if (mdx.date) {
            const monthTemp = _.split(mdx.date, '-')

            metricsMau[key] = {
              x: getMetricMonthFromMonthNo(_.toNumber(monthTemp[1])),
              y: metricsMauDataResponse[key].MAU,
              // y: Math.floor(Math.random() * 20 + 1), // Testing
            }

            // if (metricsMauDataResponse.length === key + 1)
            metricsAUCMonth = metricsMauDataResponse[key].MAU
          }
        })
      }
    }
    metricsMau = metricsMau.slice(-3)

    if (successMcu.data) {
      const metricsMcuDataResponse = successMcu.data

      if (metricsMcuDataResponse.length > 0) {
        _.forEach(metricsMcuDataResponse, function fn(mdx, key) {
          isMCUEmpty = false
          if (mdx.date > 0) {
            metricsMcu[key] = {
              x: getMetricMonthFromMonthNo(mdx.date),
              y: metricsMcuDataResponse[key].MCU,
              // y: Math.floor(Math.random() * 20 + 1),  // Testing
            }

            if (metricsMcuDataResponse.length === key + 1)
              metricsAUCMonth = metricsMcuDataResponse[key].MCU
          }
        })
      }
    }
    metricsMcu = metricsMcu.slice(-3)

    if (successPeak.data) {
      const metricsPeakDataResponse = successPeak.data
      if (metricsPeakDataResponse.length > 0) {
        _.forEach(metricsPeakDataResponse, function fn(mdx, key) {
          const fullDate = _.split(mdx.date, '-', 3)
          isPeakEmpty = false
          const date = new Date(fullDate[0], fullDate[1] - 1, fullDate[2], 0, 0, 0)
          const timestampLocal = date.getTime()

          metricsPeak[key] = [timestampLocal, metricsPeakDataResponse[key].PCC]
          // metricsPeak[key] = [timestampLocal, Math.floor(Math.random() * 10 + 1)]  // Testing

          // const monthToday = getMetricMonthTimestamp(endRange)
          // if (metricsPeakDataResponse[key].PCC > metricsAUCPeak && monthToday === mdx.month)
          metricsAUCPeak = metricsPeakDataResponse[key].PCC
        })
      }
    }
    metricsPeak = metricsPeak.slice(-30)

    // DCU
    if (successDcu.data) {
      const metricsDcuDataResponse = successDcu.data
      if (metricsDcuDataResponse.length > 0) {
        _.forEach(metricsDcuDataResponse, function fn(mdx, key) {
          const fullDate = _.split(mdx.date, '-', 3)
          isDCUEmpty = false
          const date = new Date(fullDate[0], fullDate[1] - 1, fullDate[2], 0, 0, 0)
          const timestampLocal = date.getTime()

          metricsDcu[key] = [timestampLocal, metricsDcuDataResponse[key].DCU]
          // metricsDcu[key] = [timestampLocal, Math.floor(Math.random() * 10 + 1)]  // Testing

          if (metricsDcuDataResponse.length === key + 1)
            metricsAUCDay = metricsDcuDataResponse[key].DCU
        })
      }
    }

    // Voice and Video Analytics

    if (successVoice.data) {
      const metricsVoiceDataResponse = successVoice.data
      if (metricsVoiceDataResponse.length > 0) {
        _.forEach(metricsVoiceXaxisValues, function fn(mvxv, key) {
          metricsVoice[key] = [mvxv, metricsVoiceDataResponse[key].voice_minutes]
          // metricsVoice[key] = [mvxv, Math.floor(Math.random() * 10 + 1)]  // Testing
          // if (metricsVoiceDataResponse.length === key + 1)
          metricsAVoMToday = metricsVoiceDataResponse[key].voice_minutes
        })
      }
    } else {
      metricsVoice = []
    }

    if (successVideo.data) {
      const metricsVideoDataResponse = successVideo.data
      if (metricsVideoDataResponse.length > 0) {
        _.forEach(metricsVoiceXaxisValues, function fn(mvxv, key) {
          metricsVideo[key] = [mvxv, metricsVideoDataResponse[key].video_minutes]
          // metricsVideo[key] = [mvxv, Math.floor(Math.random() * 10 + 1)]  // Testing
          // if (metricsVideoDataResponse.length === key + 1)
          metricsAViMToday = metricsVideoDataResponse[key].video_minutes
        })
      }
    } else {
      metricsVideo = []
    }

    if (successRecording.data) {
      const metricsRecordingDataResponse = successRecording.data
      if (metricsRecordingDataResponse.length > 0) {
        _.forEach(metricsVoiceXaxisValues, function fn(mvxv, key) {
          metricsRecording[key] = [mvxv, metricsRecordingDataResponse[key].recording_minutes]
          // metricsRecording[key] = [mvxv, Math.floor(Math.random() * 100 + 1)]  // Testing

          // if (metricsRecordingDataResponse.length === key + 1) {

          metricsAReMToday = metricsRecordingDataResponse[key].recording_minutes
          // }
        })
      }
    } else {
      metricsRecording = []
    }
  }

  metricsDcu = _.compact(metricsDcu)
  if (isDCUEmpty) {
    metricsDcu = []
  }
  metricsMau = _.compact(metricsMau)
  if (isMAUEmpty) {
    metricsMau = []
  }

  metricsMcu = _.compact(metricsMcu)

  if (isMCUEmpty) {
    metricsMcu = []
  }

  if (isPeakEmpty) {
    metricsPeak = []
  }

  if (!metricsPlanSupport) {
    metricsMau = metricsMauNoData
    metricsMcu = metricsMcuNoData
    metricsDcu = metricsDcuNoData
    metricsPeak = metricsPeakNoData
  }

  metricsVoice = _.compact(metricsVoice)
  // if (isVoiceEmpty) {
  //   metricsVoice = []
  // }
  metricsVideo = _.compact(metricsVideo)
  metricsRecording = _.compact(metricsRecording)
  // if (isVideoEmpty) {
  //   metricsVideo = []
  // }

  // for testing
  // metricsAUCDay = 69
  // metricsAUCHour = 79
  // metricsAUCMonth = 80
  // metricsAUCMinute = 200
  if (requestTimeOut) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Request Time-out ',
      },
    })
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        metricsDcu: [],
        metricsMcu: [],
        metricsMau: [],
        metricsPeak: [],
        metricsVoice: [],
        metricsVideo: [],
        metricsRecording: [],
        metricsAUCDay: 0,
        metricsAUCPeak: 0,
        metricsAReMToday: 0,
        metricsAVoMToday: 0,
        metricsAViMToday: 0,
        metricsAUCMonth: 0,
        metricsPlanSupport,
        metricsLoading: false,
        loading: false,
        metricsUpdateSuccess: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        metricsDcu,
        metricsMcu,
        metricsMau,
        metricsPeak,
        metricsVoice,
        metricsVideo,
        metricsRecording,
        metricsAUCDay,
        metricsAUCPeak,
        metricsAReMToday,
        metricsAVoMToday,
        metricsAViMToday,
        metricsAUCMonth,
        metricsPlanSupport,
        metricsLoading: false,
        loading: false,
        metricsUpdateSuccess: true,
      },
    })
  }

  return successMau
}
export function* APPS_LIST() {
  yield put({
    type: 'apps/LIST',
    payload: { currentPage: 1 },
  })
}

export function* GET_MESSAGE_SEARCH_LOGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      messageSearchLogsLoading: true,
      messageSearchExceedsLimit: false,
    },
  })
  if (payload !== undefined && payload.fromDate !== undefined && payload.toDate !== undefined) {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const filters = payload.filters || {}
    const responseTemp = []

    const success = yield call(
      searchMessageLogs,
      payload.data,
      getAppHost(payload.appSettings),
      payload.fromDate,
      payload.toDate,
      'current',
      0,
      filters,
    )
    let searchResultsExceedsLimit = false
    if (success && success.data) {
      let filteredMessages
      if (filters.categories) {
        filteredMessages = _.filter(success.data, function fn(m) {
          return m.type !== 'extension_human-moderation'
        })
      } else {
        filteredMessages = _.filter(success.data, function fn(m) {
          return (
            m.category === 'message' ||
            m.category === 'agentic' ||
            (m.category === 'custom' && m.type !== 'extension_human-moderation')
          )
        })
      }

      filteredMessages = _.reverse(filteredMessages)
      let newMsgLogs = filteredMessages
      newMsgLogs = filteredMessages
      responseTemp.push(success)

      for (let i = 1; i < constants.messages_filter_export_call_limit; i += 1) {
        if (
          responseTemp[i - 1].meta !== undefined &&
          responseTemp[i - 1].meta.previous !== undefined &&
          responseTemp[i - 1].meta.previous.id !== undefined
        ) {
          responseTemp[i] = yield call(
            searchMessageLogs,
            payload.data,
            getAppHost(payload.appSettings),
            responseTemp[i - 1].meta.previous.fromTimestamp,
            responseTemp[i - 1].meta.previous.toTimestamp,
            'previous',
            responseTemp[i - 1].meta.previous.id,
            filters,
          )
          if (responseTemp[i] && responseTemp[i].data) {
            let filteredMessages2
            if (filters.categories) {
              filteredMessages2 = _.filter(responseTemp[i].data, function fn(m) {
                return m.type !== 'extension_human-moderation'
              })
            } else {
              filteredMessages2 = _.filter(responseTemp[i].data, function fn(m) {
                return (
                  m.category === 'message' ||
                  (m.category === 'custom' && m.type !== 'extension_human-moderation')
                )
              })
            }

            filteredMessages2 = _.reverse(filteredMessages2)
            newMsgLogs = _.concat(newMsgLogs, filteredMessages2)
          }
        } else {
          break
        }
        if (responseTemp[i].meta !== undefined && responseTemp[i].meta.previous === undefined) {
          break
        }
        if (
          i === constants.messages_filter_export_call_limit - 1 &&
          responseTemp[constants.messages_filter_export_call_limit - 1].meta !== undefined &&
          responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous !==
            undefined &&
          responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous.id !==
            undefined
        ) {
          searchResultsExceedsLimit = true
        }
      }

      if (searchResultsExceedsLimit) {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            active: payload.data,
            messageSearchExceedsLimit: true,
            loading: false,
            messageSearchLogsLoading: false,
          },
        })
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'info',
            message:
              'Message logs are huge for the selected dates. Please reduce the date range to search.',
          },
        })
      } else {
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            active: payload.data,
            messageSearchLogs: newMsgLogs,
            loading: false,
            messageSearchExceedsLimit: false,
            messageSearchLogsLoading: false,
          },
        })
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          messageSearchLogs: [],
          loading: false,
          messageSearchExceedsLimit: false,
          messageSearchLogsLoading: false,
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        messageSearchLogs: [],
        loading: false,
        messageSearchExceedsLimit: false,
        messageSearchLogsLoading: false,
      },
    })
  }
}

/* ROLES */

export function* ROLES_PERMISSIONS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const success = yield call(rolesPermissionsList, payload.data, getAppHost(payload.appSettings))

  if (success && success.data) {
    let totalRolePermissionsCount = success.data.length
    if (success.meta && success.meta.pagination && success.meta.pagination.total) {
      totalRolePermissionsCount = success.meta.pagination.total
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        rolesPermissionsList: success.data,
        rolesPermissionsListTotal: totalRolePermissionsCount,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsList: [],
        rolesPermissionsListTotal: 0,
        loading: false,
      },
    })
  }
}

/* ROLE GET */

export function* GET_ROLE_RESTRICTIONS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  let success = []
  if (!isAppModerator(activeApp) && activeApp.region !== 'legacy') {
    success = yield call(listRoleRestrictions, id, activeApp, getAppHost(appSettings))
  }

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesActiveRestrictionList: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${activeApp.id}/roles`))
  }
}

/* ADD_ROLE_RESTRICTION */

export function* ADD_ROLE_RESTRICTION({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(addRoleRestriction, id, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/GET_ROLE_RESTRICTIONS',
      payload: { id },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Feature access restricted' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

/* DELETE_ROLE_RESTRICTION */

export function* DELETE_ROLE_RESTRICTION({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(delRoleRestriction, id, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/GET_ROLE_RESTRICTIONS',
      payload: { id },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Feature access enabled' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

/* ROLES_PERMISSIONS_V2_LIST */

export function* ROLES_PERMISSIONS_V2_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(listRolePermissionsV2, payload.id, activeApp, getAppHost(appSettings))
  console.log('success isssss', success)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsV2List: success.data.permissions,
        rolesPermissionsV2ListTotal: success.data.permissions.length || 0,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsV2List: [],
        rolesPermissionsV2ListTotal: 0,
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* ROLES_PERMISSIONS_V2_VALUES_GET */

export function* ROLES_PERMISSIONS_V2_VALUES_GET({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(getRolePermissionsV2Values, id, activeApp, getAppHost(appSettings))

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsV2Values: success.data.permissions,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsV2Values: {},
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* ROLES_PERMISSIONS_V2_UPDATE */

export function* ROLES_PERMISSIONS_V2_UPDATE({ id, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    updateRolePermissionsV2,
    id,
    payload,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsV2Values: success.data.permissions,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Permissions updated successfully' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Failed to update permissions' },
      })
    }
  }
}

/* ROLES_PERMISSIONS_V2_RESET */

export function* ROLES_PERMISSIONS_V2_RESET({ id, permissionId }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    resetRolePermissionsV2,
    id,
    permissionId,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        rolesPermissionsV2Values: success.data.permissions,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Permission reset to default' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Failed to reset permission' },
      })
    }
  }
}

/* GROUP_SCOPE_PERMISSIONS_LIST */

export function* GROUP_SCOPE_PERMISSIONS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    listGroupScopePermissions,
    payload.guid,
    payload.scope,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupScopePermissionsList: success.data.permissions,
        groupScopePermissionsListTotal: success.data.permissions.length || 0,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupScopePermissionsList: [],
        groupScopePermissionsListTotal: 0,
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* GROUP_SCOPE_PERMISSIONS_VALUES_GET */

export function* GROUP_SCOPE_PERMISSIONS_VALUES_GET({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { guid, scope } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    getGroupScopePermissionsValues,
    guid,
    scope,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupScopePermissionsValues: success.data.permissions,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupScopePermissionsValues: {},
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* GROUP_SCOPE_PERMISSIONS_UPDATE */

export function* GROUP_SCOPE_PERMISSIONS_UPDATE({ guid, scope, payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    updateGroupScopePermissions,
    guid,
    scope,
    payload,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupScopePermissionsValues: success.data.permissions,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Permissions updated successfully' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Failed to update permissions' },
      })
    }
  }
}

/* GROUP_SCOPE_PERMISSIONS_RESET */

export function* GROUP_SCOPE_PERMISSIONS_RESET({ guid, scope, permissionId }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    resetGroupScopePermission,
    guid,
    scope,
    permissionId,
    activeApp,
    getAppHost(appSettings),
  )

  if (success && success.data && success.data.permissions) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        groupScopePermissionsValues: success.data.permissions,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Permission reset to default' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.message) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Failed to reset permission' },
      })
    }
  }
}

export function* UPDATE_SUBSCRIBE_DOWNGRADE_EOT({ payload }) {
  const { subscribeDowngradeAtEOT } = payload
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      subscribeDowngradeAtEOT,
    },
  })
}

/* SUBSCRIBE_CUSTOM_PLAN_REQUEST_MANUAL_INTENT */

export function* SUBSCRIBE_CUSTOM_PLAN_REQUEST_MANUAL_INTENT({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    const intent = _.join(
      [
        constants.ManualOutreachIntents['subscribe-to-custom-plan-request'],
        activeApp.id,
        payload.plan,
      ],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)

    return success
  }
}

export function* UPDATE_APP_STATE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { id, state } = payload

  const activeApp = reduxStore.getState().apps.active
  if (isAppAdmin(activeApp) || isAppOwner(activeApp)) {
    const post = { state }
    const success = yield call(update, id, post, activeApp)
    if (success && success.data) {
      const allApps = reduxStore.getState().apps.data
      const appIndex = _.findIndex(allApps, function fn(a) {
        return a.id === activeApp.id
      })
      if (appIndex >= 0) {
        allApps[appIndex] = success.data
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          active: success.data,
        },
      })
      yield put(push(`/app/${activeApp.id}/overview`))
      if (success.data.state === 'migrating')
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: 'App status set as Migrating successfullyy' },
        })
      else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: 'App migrated to v3 successfully' },
        })
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Error updating App' },
        })
      }
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Access Denied - you are not authorized to perform this action',
      },
    })

    if (isAppModerator(activeApp)) {
      yield put(push(`/app/${activeApp.id}/users`))
    } else yield put(push(`/app/${activeApp.id}/overview`))
  }
}

/* APP_MIGRATION_REQUEST_MANUAL_INTENT */

export function* APP_MIGRATION_REQUEST_MANUAL_INTENT() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    const intent = _.join(
      [
        constants.ManualOutreachIntents['app-migration-request-to-v3'],
        activeApp.id,
        activeApp.region,
      ],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)

    if (success && success.data) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'intentRequestSuccess',
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      }
    }

    return success
  }
}

/* RESTORE_DELETED_APP_REQUEST */

export function* RESTORE_DELETED_APP_REQUEST() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    const intent = _.join(
      [
        constants.ManualOutreachIntents['restore-app-scheduled-for-deletion-request'],
        activeApp.id,
        activeApp.region,
      ],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)
    if (success && success.data) {
      yield put({
        type: 'settings/SET_STATE',
        payload: {
          visibleModalID: 'intentSuccess',
        },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      }
    }
    return success
  }
}

/* UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT */

export function* UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  const extensionToUpgradeList = reduxStore.getState().apps.sentManualIntentExtensionIds
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    if (payload.setLoader !== undefined && payload.setLoader) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: true,
        },
      })
    }
    if (activeApp.parent !== undefined && activeApp.parent && activeApp.parent.length > 0) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'info', message: `Taking you to your primary app's billing` },
      })
    }
    if (payload.featureSlug === undefined) {
      payload.featureSlug = ''
    }
    payload.featureSlug = _.replace(payload.featureSlug, '_', ' ')
    const intent = _.join(
      [
        constants.ManualOutreachIntents['upgrade-plan-since-feature-restricted'],
        activeApp.id,
        _.replace(payload.featureSlug, '_', ' '),
      ],
      ' / ',
    )

    extensionToUpgradeList.push(payload.featureSlug)
    const post = { intent }

    const success = yield call(manualOutreach, post)
    if (activeApp.parent !== undefined && activeApp.parent && activeApp.parent.length > 0) {
      yield put(push(`/app/${activeApp.parent}/plans-billing`))
    } else {
      yield put(push(`/app/${activeApp.id}/plans-billing`))
    }
    if (payload.setLoader !== undefined && payload.setLoader) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          sentManualIntentExtensionIds: extensionToUpgradeList,
        },
      })
    }
    return success
  }
}

/* UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT */

export function* UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    if (payload.featureSlug === undefined) {
      payload.featureSlug = ''
    }
    const intent = _.join(
      [
        constants.ManualOutreachIntents['add-higher-plan-extension'],
        activeApp.id,
        _.replace(payload.featureSlug, '_', ' '),
      ],
      ' / ',
    )
    const post = { intent }

    const success = yield call(manualOutreach, post)

    return success
  }
}

export function* GET_CALL_LOGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      callSearchLogsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  if (!payload.data || !payload.data.appRegion || !payload.data.appRegion.meta) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        callSearchLogsLoading: false,
        callLogs: [],
      },
    })
    return
  }

  try {
    let startRange = 0
    let endRange = 0
    if (payload !== undefined && payload.fromDate !== undefined && payload.toDate !== undefined) {
      startRange = payload.fromDate
      endRange = payload.toDate
    }

    const filters = payload.filters || {}
    const pageNo = payload.currentPage || 1

    const success = yield call(
      callLogs,
      payload.data,
      getAppCallsHost(payload.appSettings),
      'calls',
      startRange ? Math.floor(startRange / 1000) : 0,
      endRange ? Math.floor(endRange / 1000) : 0,
      filters,
      pageNo,
    )

    if (success && success.data) {
      // Use backend-provided order (already sorted correctly)
      const callLogData = success.data
      let callSearchLogsTotal = callLogData.length
      let callSearchLogsPagination = {}

      if (success.meta && success.meta.pagination) {
        callSearchLogsTotal = success.meta.pagination.total || callLogData.length
        callSearchLogsPagination = success.meta.pagination
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          callSearchLogs: callLogData,
          callSearchLogsTotal,
          callSearchLogsPagination,
          loading: false,
          callSearchLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          callSearchLogs: [],
          callSearchLogsTotal: 0,
          callSearchLogsPagination: {},
          loading: false,
          callSearchLogsLoading: false,
        },
      })
    }
  } catch (error) {
    if (window.triggerNotification) {
      window.triggerNotification('Failed to load call logs', 'error')
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        callSearchLogs: [],
        callSearchLogsTotal: 0,
        callSearchLogsPagination: {},
        loading: false,
        callSearchLogsLoading: false,
      },
    })
  }
}

export function* GET_MESSAGE_EXPORT_LOGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      messageExportLogsLoading: true,
      messageExportAllExceedsLimit: false,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const responseTemp = []

  const success = yield call(
    exportMessageLogs,
    payload.data,
    getAppHost(payload.appSettings),
    'current',
  )
  let searchResultsExceedsLimit = false
  if (success && success.data) {
    let filteredMessages = _.filter(success.data, function fn(m) {
      return (
        m.category === 'message' ||
        m.category === 'agentic' ||
        (m.category === 'custom' && m.type !== 'extension_human-moderation')
      )
    })

    filteredMessages = _.reverse(filteredMessages)
    let newMsgLogs = filteredMessages
    newMsgLogs = filteredMessages
    responseTemp.push(success)

    for (let i = 1; i < constants.messages_filter_export_call_limit; i += 1) {
      if (
        responseTemp[i - 1].meta !== undefined &&
        responseTemp[i - 1].meta.previous !== undefined &&
        responseTemp[i - 1].meta.previous.id !== undefined
      ) {
        responseTemp[i] = yield call(
          exportMessageLogs,
          payload.data,
          getAppHost(payload.appSettings),
          'previous',
          responseTemp[i - 1].meta.previous.sentAt,
          responseTemp[i - 1].meta.previous.id,
        )
        if (responseTemp[i] && responseTemp[i].data) {
          let filteredMessages2 = _.filter(responseTemp[i].data, function fn(m) {
            return (
              m.category === 'message' ||
              (m.category === 'custom' && m.type !== 'extension_human-moderation')
            )
          })

          filteredMessages2 = _.reverse(filteredMessages2)
          newMsgLogs = _.concat(newMsgLogs, filteredMessages2)
        }
      } else {
        break
      }
      if (responseTemp[i].meta !== undefined && responseTemp[i].meta.previous === undefined) {
        break
      }
      if (
        i === constants.messages_filter_export_call_limit - 1 &&
        responseTemp[constants.messages_filter_export_call_limit - 1].meta !== undefined &&
        responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous !== undefined &&
        responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous.id !== undefined
      ) {
        searchResultsExceedsLimit = true
      }
    }

    if (searchResultsExceedsLimit) {
      // send manual intent
      const intent = _.join(
        [
          constants.ManualOutreachIntents['export-messages-exceeding-100k-request'],
          payload.data.id,
        ],
        ' / ',
      )
      const post = { intent }
      yield call(manualOutreach, post)
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          messageExportAllExceedsLimit: true,
          loading: false,
          messageExportLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          messageExportLogs: newMsgLogs,
          loading: false,
          messageExportLogsLoading: false,
          messageExportAllExceedsLimit: false,
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        messageExportLogs: [],
        loading: false,
        messageExportLogsLoading: false,
        messageExportAllExceedsLimit: false,
      },
    })
  }
}

/* APP GET USAGE AND OVERAGES */

export function* GET_USAGE_AND_OVERAGES({
  payload,
  redirectToIntegrate = false,
  callSourceRedirectURL,
}) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      appUsageAndOveragesLoading: true,
      appLoadingInProgress: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let requestTimeOut = false

  let appUsageAndOverages = []
  appUsageAndOverages = {
    currentUsageUsers: 0,
    ccu: 0,
    voice_minutes: 0,
    video_minutes: 0,
    mauLimit: payload.data.parameters['overages.mau.included'],
    ccuLimit: payload.data.parameters['overages.ccu.included'],
    mcuLimit: payload.data.parameters['overages.mcu.included'],
    dcuLimit: payload.data.parameters['overages.dcu.included'],
    voice_minutes_limit: payload.data.parameters['overages.calling.included'],
    video_minutes_limit: payload.data.parameters['overages.calling.included'],
    currentUsageUsersUsed: 0,
    ccuUsed: 0,
    voiceMinutesUsed: 0,
    videoMinutesUsed: 0,
    recorded_minutes: 0,
    mau_overage: 0,
    ccu_overage: 0,
    fromDate: '',
    toDate: '',
  }

  let isUsageEmpty = true
  const billingTypeCurrent = checkBillingType(payload.data)

  if (payload.data.plan === 'trial' && getTrialLeftInDays(payload.data.trialEndsAt) > 0) {
    payload.data.currentTermStart = payload.data.createdAt
    payload.data.currentTermEnd = payload.data.trialEndsAt
  }
  if (payload.fromDate !== undefined && payload.toDate !== undefined) {
    payload.data.currentTermStart = payload.fromDate
    payload.data.currentTermEnd = payload.toDate
  }

  let successUsageAndOverages = { data: false }
  if (payload.data.currentTermStart !== undefined && payload.data.currentTermEnd !== undefined) {
    successUsageAndOverages = yield call(getBillingCycleUsageMetrics, payload.data)

    if (successUsageAndOverages.users !== undefined) {
      const appUsageAndOveragesResponse = successUsageAndOverages
      let overageParamForBillingType = payload.data.parameters['overages.mau.included']
      if (billingTypeCurrent === 'dcu') {
        overageParamForBillingType = ['overages.dcu.included']
      } else if (billingTypeCurrent === 'mcu') {
        overageParamForBillingType = ['overages.mcu.included']
      }
      isUsageEmpty = false
      appUsageAndOverages = {
        currentUsageUsers: appUsageAndOveragesResponse.users,
        ccu: appUsageAndOveragesResponse.ccu,
        voice_minutes: appUsageAndOveragesResponse.voice_minutes,
        video_minutes: appUsageAndOveragesResponse.video_minutes,
        mauLimit: payload.data.parameters['overages.mau.included'],
        ccuLimit: payload.data.parameters['overages.ccu.included'],
        mcuLimit: payload.data.parameters['overages.mcu.included'],
        dcuLimit: payload.data.parameters['overages.dcu.included'],
        voice_minutes_limit: payload.data.parameters['overages.calling.included'],
        video_minutes_limit: payload.data.parameters['overages.calling.included'],
        currentUsageUsersUsed:
          (appUsageAndOveragesResponse.users / overageParamForBillingType) * 100,
        ccuUsed:
          (appUsageAndOveragesResponse.ccu / payload.data.parameters['overages.ccu.included']) *
          100,
        voiceMinutesUsed:
          (appUsageAndOveragesResponse.voice_minutes /
            payload.data.parameters['overages.calling.included']) *
          100,
        videoMinutesUsed:
          (appUsageAndOveragesResponse.video_minutes /
            payload.data.parameters['overages.calling.included']) *
          100,
        recorded_minutes: appUsageAndOveragesResponse.recorded_minutes,
        mau_overage: 0,
        ccu_overage: 0,
        fromDate: getTimestampAsFullHumanDateOrdinal(payload.data.currentTermStart),
        toDate: getTimestampAsFullHumanDateOrdinal(payload.data.currentTermEnd),
      }
      if (
        payload.overagesEmpty === undefined &&
        payload.data.parameters !== undefined &&
        payload.data.parameters['overages.ccu.enabled'] !== undefined &&
        payload.data.parameters['overages.ccu.enabled'] &&
        payload.data.parameters['overages.ccu.included'] !== undefined &&
        appUsageAndOveragesResponse.ccu > payload.data.parameters['overages.ccu.included']
      ) {
        appUsageAndOverages.ccu_overage =
          appUsageAndOveragesResponse.ccu - payload.data.parameters['overages.ccu.included']
      }
      if (
        payload.overagesEmpty === undefined &&
        payload.data.parameters !== undefined &&
        payload.data.parameters['overages.mau.enabled'] !== undefined &&
        payload.data.parameters['overages.mau.enabled'] &&
        payload.data.parameters['overages.mau.included'] !== undefined &&
        appUsageAndOveragesResponse.users > payload.data.parameters['overages.mau.included']
      ) {
        appUsageAndOverages.mau_overage =
          appUsageAndOveragesResponse.users - payload.data.parameters['overages.mau.included']
      }
    } else if (successUsageAndOverages.err_code !== undefined) {
      requestTimeOut = true
    }
  }
  if (isUsageEmpty) {
    appUsageAndOverages = {
      mau: 0,
      ccu: 0,
      voice_minutes: 0,
      video_minutes: 0,
      mauLimit: payload.data.parameters['overages.mau.included'],
      ccuLimit: payload.data.parameters['overages.ccu.included'],
      mcuLimit: payload.data.parameters['overages.mcu.included'],
      dcuLimit: payload.data.parameters['overages.dcu.included'],
      voice_minutes_limit: payload.data.parameters['overages.calling.included'],
      video_minutes_limit: payload.data.parameters['overages.calling.included'],
      currentUsageUsers: 0,
      currentUsageUsersUsed: 0,
      ccuUsed: 0,
      voiceMinutesUsed: 0,
      videoMinutesUsed: 0,
      recorded_minutes: 0,
      mau_overage: 0,
      ccu_overage: 0,
      fromDate: '',
      toDate: '',
    }
  }

  if (requestTimeOut) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: 'Request Time-out ',
      },
    })
    appUsageAndOverages = {
      mau: 0,
      ccu: 0,
      voice_minutes: 0,
      video_minutes: 0,
      mauLimit: payload.data.parameters['overages.mau.included'],
      ccuLimit: payload.data.parameters['overages.ccu.included'],
      mcuLimit: payload.data.parameters['overages.mcu.included'],
      dcuLimit: payload.data.parameters['overages.dcu.included'],
      voice_minutes_limit: payload.data.parameters['overages.calling.included'],
      video_minutes_limit: payload.data.parameters['overages.calling.included'],
      currentUsageUsersUsed: 0,
      currentUsageUsers: 0,
      ccuUsed: 0,
      voiceMinutesUsed: 0,
      videoMinutesUsed: 0,
      recorded_minutes: 0,
      mau_overage: 0,
      ccu_overage: 0,
      fromDate: '',
      toDate: '',
    }
  }

  // only redirect when `redirectToIntegrate` is set. The previous
  // `else` branch ran for every caller and trimmed query params off the
  // current URL — notably the `?flow=cli` signal used by the Skills builder
  // entry, which broke `isSkillsMode` detection on the builder page.
  if (redirectToIntegrate) {
    if (
      !(
        appUsageAndOverages.currentUsageUsers ||
        appUsageAndOverages.voice_minutes ||
        appUsageAndOverages.ccu ||
        appUsageAndOverages.video_minutes
      ) &&
      !_.includes(constants.trialPlansIDList, payload?.data?.plan)
    ) {
      yield put(push(`/app/${payload.data.id}/messaging-get-started`))
    } else if (callSourceRedirectURL) {
      yield put(push(callSourceRedirectURL))
    }
  }

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      appUsageAndOverages,
      loading: false,
      appUsageAndOveragesLoading: false,
      appLoadingInProgress: false,
    },
  })

  return appUsageAndOverages
}

export function* GET_INSIGHTS_DATA({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let fetchedInsightsData = []
  fetchedInsightsData = yield call(getInsightsData, payload.activeApp)

  if (typeof fetchedInsightsData !== 'boolean' && fetchedInsightsData !== null) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        fetchedInsightsData,
      },
    })
  }
}

export function* DOWNLOAD_CALL_RECORDING({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(downloadCallRecording, payload.fileUrl, payload.fileName)
  if (response && response.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: response.error },
    })
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'info', message: 'Recording download in progress...' },
    })
  }
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* DOWNLOAD_CALL_RECORDING_LEGACY({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(downloadCallRecordingLegacy, payload.fileUrl, payload.sessionID)
  if (response && response.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: response.error },
    })
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'info', message: 'Recording download in progress...' },
    })
  }
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

/* APP METRICS */
export function* GET_METRICS_BY_FILTER({ payload }) {
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let metricsPlanSupport = false
  metricsPlanSupport = checkIfAnalyticsIsSupported(payload.data)

  let requestTimeOut = false
  const nowDate = new Date()

  const endRange = nowDate.getTime()
  const timezoneDiffInMs = nowDate.getTimezoneOffset() * 60 * 1000

  if (payload.type === 'ccu') {
    let metricsAUCMinute = '0'
    // get CCU
    let isCCUEmpty = true
    const endRangeCcu = endRange
    const metricsCcuXaxisValues = []
    for (let i = payload.filter; i > 0; i -= 1) {
      if (i === payload.filter) {
        metricsCcuXaxisValues[payload.filter - 1] = endRangeCcu
      } else metricsCcuXaxisValues[payload.filter - 1 - i] = endRangeCcu - i * 60 * 1000
    }

    let metricsCcu = []
    const metricsCcuNoData = []
    for (let i = 0; i < payload.filter; i += 1) {
      metricsCcu[i] = [metricsCcuXaxisValues[i], 0]
      metricsCcuNoData[i] = [metricsCcuXaxisValues[i], 0]
    }

    let successCcu = { data: false }
    const ccuServiceParams = {
      startRange: metricsCcuXaxisValues[0],
      endRange: endRangeCcu,
    }
    const getMetricCalls = yield call(
      getMetricsByType,
      payload.data,
      getAppMetricHost(payload.appSettings),
      payload.type,
      ccuServiceParams,
    )

    if (getMetricCalls.data !== undefined && getMetricCalls.data) {
      successCcu = getMetricCalls.data
    } else if (getMetricCalls.err_code !== undefined) {
      requestTimeOut = true
    }
    if (!requestTimeOut) {
      if (getMetricCalls.data) {
        const metricsCcuDataResponse = successCcu
        if (metricsCcuDataResponse.length > 0) {
          const lastOfCCU = _.last(metricsCcuDataResponse)
          metricsAUCMinute = lastOfCCU.users_count
          _.forEach(metricsCcuDataResponse, function fn(mdx, key) {
            const checkIndex = _.findIndex(metricsCcuXaxisValues, function fn2(mmau) {
              const day = getMetricDayTimestamp(mmau)
              const month = getMetricMonthTimestamp(mmau)
              const year = getMetricYearTimestamp(mmau)
              const hour = getMetricHoursTimestamp(mmau)
              const minute = getMetricMinutesTimestamp(mmau)
              return (
                mdx.day === day &&
                mdx.month === month &&
                mdx.year === year &&
                mdx.hour === hour &&
                mdx.minute === minute
              )
            })
            if (checkIndex >= 0) {
              isCCUEmpty = false
              if (
                mdx.day > 0 &&
                mdx.year > 0 &&
                mdx.month >= 0 &&
                mdx.hour >= 0 &&
                mdx.minute >= 0
              ) {
                const date = new Date(mdx.year, mdx.month, mdx.day, mdx.hour, mdx.minute, 0)
                const timestampLocal = date.getTime() - timezoneDiffInMs
                metricsCcu[checkIndex] = [timestampLocal, metricsCcuDataResponse[key].users_count]
                const dayToday = getMetricDayTimestamp(endRange)
                const monthToday = getMetricMonthTimestamp(endRange)
                const yearToday = getMetricYearTimestamp(endRange)
                const hourNow = getMetricHoursTimestamp(endRange)
                const minuteNow = getMetricMinutesTimestamp(endRange)
                if (
                  mdx.day === dayToday &&
                  mdx.month === monthToday &&
                  mdx.year === yearToday &&
                  mdx.hour === hourNow &&
                  mdx.minute === minuteNow
                )
                  metricsAUCMinute = metricsCcuDataResponse[key].users_count
              }
            }
          })
        }
      }
    }

    metricsCcu = _.compact(metricsCcu)
    if (isCCUEmpty) {
      metricsCcu = []
    }
    if (!metricsPlanSupport) {
      metricsCcu = metricsCcuNoData
    }
    if (requestTimeOut) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Request Time-out ',
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          metricsCcu,
          metricsAUCMinute,
          metricsUpdateSuccess: true,
        },
      })
    }
  } else if (payload.type === 'pcu') {
    let metricsAUCPeak = '0'

    // PEAK CCU

    const startRangePeakTemp = endRange - (payload.filter - 1) * 24 * 60 * 60 * 1000
    const startRangePeakTempDate = new Date(startRangePeakTemp)
    const startRangePeakDate = new Date(
      startRangePeakTempDate.getFullYear(),
      startRangePeakTempDate.getMonth(),
      startRangePeakTempDate.getDate(),
    )
    const startRangePeak = startRangePeakDate.getTime()

    const metricsPeakXaxisValues = [startRangePeak]
    let metricsPeak = [metricsPeakXaxisValues[0], 0]
    const metricsPeakNoData = [metricsPeakXaxisValues[0], 0]
    let isPeakEmpty = true
    for (let i = 1; i <= payload.filter; i += 1) {
      if (i === payload.filter) {
        metricsPeakXaxisValues[i] = endRange
        metricsPeak[i] = [endRange, 0]
        metricsPeakNoData[i] = [endRange, 0]
      } else {
        metricsPeakXaxisValues[i] = startRangePeak + i * 24 * 60 * 60 * 1000
      }
    }

    for (let i = 0; i < payload.filter; i += 1) {
      metricsPeak[i] = [metricsPeakXaxisValues[i], 0]
      metricsPeakNoData[i] = [metricsPeakXaxisValues[i], 0]
    }
    let successPeak = { data: false }

    const peakCallServiceParams = { startRange: metricsPeakXaxisValues[0], endRange }
    const getMetricCalls = yield call(
      getMetricsByType,
      payload.data,
      getAppMetricHost(payload.appSettings),
      payload.type,
      peakCallServiceParams,
    )
    if (getMetricCalls.data !== undefined && getMetricCalls.data) {
      successPeak = getMetricCalls.data
    } else if (getMetricCalls.err_code !== undefined) {
      requestTimeOut = true
    }
    if (!requestTimeOut) {
      if (getMetricCalls.data) {
        const metricsPeakDataResponse = successPeak
        if (metricsPeakDataResponse.length > 0) {
          _.forEach(metricsPeakDataResponse, function fn(mdx, key) {
            const checkIndex = _.findIndex(metricsPeakXaxisValues, function fn2(mmau) {
              const day = getMetricDayTimestamp(mmau)
              const month = getMetricMonthTimestamp(mmau)
              const year = getMetricYearTimestamp(mmau)
              return mdx.day === day && mdx.month === month && mdx.year === year
            })
            if (checkIndex >= 0) {
              isPeakEmpty = false
              if (mdx.day > 0 && mdx.year > 0 && mdx.month >= 0) {
                const date = new Date(mdx.year, mdx.month, mdx.day, 0, 0, 0)
                const timestampLocal = date.getTime()

                metricsPeak[checkIndex] = [timestampLocal, metricsPeakDataResponse[key].ccu]
                const monthToday = getMetricMonthTimestamp(endRange)
                if (metricsPeakDataResponse[key].ccu > metricsAUCPeak && monthToday === mdx.month)
                  metricsAUCPeak = metricsPeakDataResponse[key].ccu
              }
            }
          })
        }
      }
    }
    if (isPeakEmpty) {
      metricsPeak = []
    }

    if (!metricsPlanSupport) {
      metricsPeak = metricsPeakNoData
    }
    if (requestTimeOut) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Request Time-out ',
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          metricsPeak,
          metricsAUCPeak,
          metricsUpdateSuccess: true,
        },
      })
    }
  } else if (payload.type === 'dau') {
    // DAU
    let metricsAUCDay = '0'

    const startRangeTempDAU = endRange - (payload.filter - 1) * 24 * 60 * 60 * 1000
    const startRangeTempDateDAU = new Date(startRangeTempDAU)
    const startRangeDateDAU = new Date(
      startRangeTempDateDAU.getFullYear(),
      startRangeTempDateDAU.getMonth(),
      startRangeTempDateDAU.getDate(),
    )
    const startRangeDAU = startRangeDateDAU.getTime()

    const metricsDauXaxisValues = [startRangeDAU]

    let metricsDau = [metricsDauXaxisValues[0], 0]
    const metricsDauNoData = [metricsDauXaxisValues[0], 0]
    let isDAUEmpty = true
    for (let i = 1; i <= payload.filter; i += 1) {
      if (i === payload.filter) {
        metricsDauXaxisValues[i] = endRange
        metricsDau[i] = [endRange, 0]
        metricsDauNoData[i] = [endRange, 0]
      } else {
        metricsDauXaxisValues[i] = startRangeDAU + i * 24 * 60 * 60 * 1000
      }
    }

    for (let i = 0; i < payload.filter; i += 1) {
      metricsDau[i] = [metricsDauXaxisValues[i], 0]
      metricsDauNoData[i] = [metricsDauXaxisValues[i], 0]
    }
    let dauServiceParams = {}
    dauServiceParams = {
      startRange: metricsDauXaxisValues[0],
      endRange,
    }
    let successDau = { data: false }

    const getMetricCalls = yield call(
      getMetricsByType,
      payload.data,
      getAppMetricHost(payload.appSettings),
      payload.type,
      dauServiceParams,
    )
    if (getMetricCalls.data !== undefined && getMetricCalls.data) {
      successDau = getMetricCalls.data
    } else if (getMetricCalls.err_code !== undefined) {
      requestTimeOut = true
    }
    if (!requestTimeOut) {
      if (getMetricCalls.data) {
        const metricsDauDataResponse = successDau
        if (metricsDauDataResponse.length > 0) {
          _.forEach(metricsDauDataResponse, function fn(mdx, key) {
            const checkIndex = _.findIndex(metricsDauXaxisValues, function fn2(mmau) {
              const day = getMetricDayTimestamp(mmau)
              const month = getMetricMonthTimestamp(mmau)
              const year = getMetricYearTimestamp(mmau)
              return mdx.day === day && mdx.month === month && mdx.year === year
            })
            if (checkIndex >= 0) {
              isDAUEmpty = false
              if (mdx.day > 0 && mdx.year > 0 && mdx.month >= 0) {
                const date = new Date(mdx.year, mdx.month, mdx.day, 0, 0, 0)
                const timestampLocal = date.getTime()
                metricsDau[checkIndex] = [timestampLocal, metricsDauDataResponse[key].DAU]

                const dayToday = getMetricDayTimestamp(endRange)
                const monthToday = getMetricMonthTimestamp(endRange)
                const yearToday = getMetricYearTimestamp(endRange)
                if (mdx.day === dayToday && mdx.month === monthToday && mdx.year === yearToday)
                  metricsAUCDay = metricsDauDataResponse[key].DAU
              }
            }
          })
        }
      }
    }
    metricsDau = _.compact(metricsDau)
    if (isDAUEmpty) {
      metricsDau = []
    }
    if (!metricsPlanSupport) {
      metricsDau = metricsDauNoData
    }
    if (requestTimeOut) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Request Time-out ',
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          metricsDau,
          metricsAUCDay,
          metricsUpdateSuccess: true,
        },
      })
    }
  } else if (payload.type === 'mau') {
    let metricsAUCMonth = '0'
    // MAU

    // MAU
    let metricsMauXaxisValues = [
      getTimestampOfMonth(2, 1) * 1000,
      getTimestampOfMonth(1) * 1000,
      endRange,
    ]
    if (payload.filter === '6') {
      metricsMauXaxisValues = [
        getTimestampOfMonth(5, 1) * 1000,
        getTimestampOfMonth(4) * 1000,
        getTimestampOfMonth(3) * 1000,
        getTimestampOfMonth(2) * 1000,
        getTimestampOfMonth(1) * 1000,
        endRange,
      ]
    }

    let metricsMau = []
    const metricsMauNoData = []
    let isMAUEmpty = true
    for (let i = 0; i < payload.filter - 1; i += 1) {
      metricsMau[i] = {
        x: getMetricMonthFromTimestamp(metricsMauXaxisValues[i]),
        y: 0,
      }
      metricsMauNoData[i] = {
        x: getMetricMonthFromTimestamp(metricsMauXaxisValues[i]),
        y: 0,
      }
    }
    let mauServiceParams = {}
    mauServiceParams = {
      startRange: getTimestampOfMonth(payload.filter - 1, 1) * 1000,
      endRange,
    }
    let successMau = { data: false }
    const getMetricCalls = yield call(
      getMetricsByType,
      payload.data,
      getAppMetricHost(payload.appSettings),
      payload.type,
      mauServiceParams,
    )
    if (getMetricCalls.data !== undefined && getMetricCalls.data) {
      successMau = getMetricCalls.data
    } else if (getMetricCalls.err_code !== undefined) {
      requestTimeOut = true
    }
    if (!requestTimeOut) {
      if (getMetricCalls.data) {
        const metricsMauDataResponse = successMau
        if (metricsMauDataResponse.length > 0) {
          _.forEach(metricsMauDataResponse, function fn(mdx, key) {
            const checkIndex = _.findIndex(metricsMauXaxisValues, function fn2(mmau) {
              const month = getMetricMonthTimestamp(mmau)
              const year = getMetricYearTimestamp(mmau)

              return mdx.month === month && mdx.year === year
            })
            if (checkIndex >= 0) {
              isMAUEmpty = false
              if (mdx.year > 0 && mdx.month >= 0) {
                const date = new Date(mdx.year, mdx.month, 2, 0, 0, 0)
                const timestampLocal = date.getTime() - timezoneDiffInMs
                metricsMau[checkIndex] = {
                  x: getMetricMonthFromTimestamp(timestampLocal),
                  y: metricsMauDataResponse[key].MAU,
                }
                const monthToday = getMetricMonthTimestamp(endRange)
                const yearToday = getMetricYearTimestamp(endRange)
                if (mdx.month === monthToday && mdx.year === yearToday)
                  metricsAUCMonth = metricsMauDataResponse[key].MAU
              }
            }
          })
        }
      }
    }
    metricsMau = _.compact(metricsMau)
    if (isMAUEmpty) {
      metricsMau = []
    }
    if (!metricsPlanSupport) {
      metricsMau = metricsMauNoData
    }
    if (requestTimeOut) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Request Time-out ',
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          metricsMau,
          metricsAUCMonth,
          metricsUpdateSuccess: true,
        },
      })
    }
  } else if (payload.type === 'voice') {
    let metricsAVoMMonth = 0
    let metricsAVoMToday = '0'
    const startRangeVoiceTemp = endRange - (payload.filter - 1) * 24 * 60 * 60 * 1000
    const startRangeVoiceTempDate = new Date(startRangeVoiceTemp)
    const startRangeVoiceDate = new Date(
      startRangeVoiceTempDate.getFullYear(),
      startRangeVoiceTempDate.getMonth(),
      startRangeVoiceTempDate.getDate(),
    )
    const startRangeVoice = startRangeVoiceDate.getTime()
    const metricsVoiceXaxisValues = [startRangeVoice]
    let metricsVoice = [metricsVoiceXaxisValues[0], 0]

    const metricsVoiceNoData = [metricsVoiceXaxisValues[0], 0]

    for (let i = 0; i < payload.filter; i += 1) {
      metricsVoiceXaxisValues[i] = startRangeVoice + i * 24 * 60 * 60 * 1000
      metricsVoice[i] = [metricsVoiceXaxisValues[i], 0]
      metricsVoiceNoData[i] = [metricsVoiceXaxisValues[i], 0]
    }
    let successVoice = { data: false }

    const voiceVideoCallServiceParams = {
      startRange: metricsVoiceXaxisValues[0],
      endRange,
    }
    const getMetricCalls = yield call(
      getMetricsByType,
      payload.data,
      payload.type,
      voiceVideoCallServiceParams,
    )
    if (getMetricCalls.data !== undefined && getMetricCalls.data) {
      successVoice = getMetricCalls.data
    } else if (getMetricCalls.err_code !== undefined) {
      requestTimeOut = true
    }

    if (!requestTimeOut) {
      if (getMetricCalls.data) {
        const metricsVoiceVideoDataResponse = successVoice
        if (metricsVoiceVideoDataResponse.length > 0) {
          _.forEach(metricsVoiceXaxisValues, function fn(mvxv, key) {
            const checkIndex = _.findIndex(metricsVoiceVideoDataResponse, function fn2(mvvdr) {
              const tempMonth = mvvdr.month - 1
              const date = new Date(mvvdr.year, tempMonth, mvvdr.day, 0, 0, 0)
              const timestampLocal = date.getTime()
              return mvxv === timestampLocal
            })
            if (checkIndex >= 0) {
              metricsVoice[key] = [mvxv, metricsVoiceVideoDataResponse[checkIndex].voice_minutes]

              const monthToday = getMetricMonthTimestamp(endRange) + 1
              const dayToday = getMetricDayTimestamp(endRange)

              if (monthToday === metricsVoiceVideoDataResponse[checkIndex].month) {
                metricsAVoMMonth += metricsVoiceVideoDataResponse[checkIndex].voice_minutes
              }
              if (dayToday === metricsVoiceVideoDataResponse[checkIndex].day) {
                metricsAVoMToday = metricsVoiceVideoDataResponse[checkIndex].voice_minutes
              }
            }
          })
        }
      } else {
        metricsVoice = []
      }
    }
    metricsVoice = _.compact(metricsVoice)

    if (requestTimeOut) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Request Time-out ',
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          metricsVoice,
          metricsAVoMMonth,
          metricsAVoMToday,
          metricsUpdateSuccess: true,
        },
      })
    }
  } else if (payload.type === 'video') {
    let metricsAViMMonth = 0
    let metricsAViMToday = '0'
    const startRangeVideoTemp = endRange - (payload.filter - 1) * 24 * 60 * 60 * 1000
    const startRangeVideoTempDate = new Date(startRangeVideoTemp)
    const startRangeVideoDate = new Date(
      startRangeVideoTempDate.getFullYear(),
      startRangeVideoTempDate.getMonth(),
      startRangeVideoTempDate.getDate(),
    )
    const startRangeVideo = startRangeVideoDate.getTime()
    const metricsVideoXaxisValues = [startRangeVideo]
    let metricsVideo = [metricsVideoXaxisValues[0], 0]
    const metricsVideoNoData = [metricsVideoXaxisValues[0], 0]

    for (let i = 0; i < payload.filter; i += 1) {
      metricsVideoXaxisValues[i] = startRangeVideo + i * 24 * 60 * 60 * 1000
      metricsVideo[i] = [metricsVideoXaxisValues[i], 0]
      metricsVideoNoData[i] = [metricsVideoXaxisValues[i], 0]
    }

    let successVideo = { data: false }
    const voiceVideoCallServiceParams = {
      startRange: metricsVideoXaxisValues[0],
      endRange,
    }
    const getMetricCalls = yield call(
      getMetricsByType,
      payload.data,
      payload.type,
      voiceVideoCallServiceParams,
    )
    if (getMetricCalls.data !== undefined && getMetricCalls.data) {
      successVideo = getMetricCalls.data
    } else if (getMetricCalls.err_code !== undefined) {
      requestTimeOut = true
    }

    if (!requestTimeOut) {
      if (getMetricCalls.data) {
        const metricsVoiceVideoDataResponse = successVideo
        if (metricsVoiceVideoDataResponse.length > 0) {
          _.forEach(metricsVideoXaxisValues, function fn(mvxv, key) {
            const checkIndex = _.findIndex(metricsVoiceVideoDataResponse, function fn2(mvvdr) {
              const tempMonth = mvvdr.month - 1
              const date = new Date(mvvdr.year, tempMonth, mvvdr.day, 0, 0, 0)
              const timestampLocal = date.getTime()
              return mvxv === timestampLocal
            })
            if (checkIndex >= 0) {
              metricsVideo[key] = [mvxv, metricsVoiceVideoDataResponse[checkIndex].video_minutes]
              const monthToday = getMetricMonthTimestamp(endRange) + 1
              const dayToday = getMetricDayTimestamp(endRange)
              if (monthToday === metricsVoiceVideoDataResponse[checkIndex].month) {
                metricsAViMMonth += metricsVoiceVideoDataResponse[checkIndex].video_minutes
              }
              if (dayToday === metricsVoiceVideoDataResponse[checkIndex].day) {
                metricsAViMToday = metricsVoiceVideoDataResponse[checkIndex].video_minutes
              }
            }
          })
        }
      } else {
        metricsVideo = []
      }
    }
    metricsVideo = _.compact(metricsVideo)

    if (requestTimeOut) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Request Time-out ',
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          metricsVideo,
          metricsAViMMonth,
          metricsAViMToday,
          metricsUpdateSuccess: true,
        },
      })
    }
  }
  return true
}

export function* GET_MESSAGE_BY_ID({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(messageGet, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        messageActive: success.data,
        loading: false,
      },
    })
  }

  return success
}

export function* GET_CALL_BY_ID({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  if (payload !== undefined && payload.id !== undefined) {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    if (!payload.data || !payload.data.appRegion || !payload.data.appRegion.meta) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          callActive: null,
        },
      })
      return
    }

    const success = yield call(
      getCallDetail,
      payload.data,
      getAppCallsHost(payload.appSettings),
      payload.id,
    )

    if (success && success.data) {
      let currentCallData = success.data[0]
      let participantsList = success.data[0].participants
      let recordingsList = success.data[0].recordings
      if (success.data.length > 1) {
        const currentCallIndex = _.findIndex(success.data, function fn(sp) {
          return sp.mid === payload.id2
        })
        if (currentCallIndex < 0) {
          currentCallData = _.first(success.data)
        } else currentCallData = success.data[currentCallIndex]
        participantsList =
          success.data[currentCallIndex] !== undefined
            ? success.data[currentCallIndex].participants
            : []
        recordingsList =
          success.data[currentCallIndex] !== undefined
            ? success.data[currentCallIndex].recordings
            : []
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          callActive: currentCallData,
          callSessionParticipants: participantsList,
          callRecordings: recordingsList,
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          callActive: [],
          callSessionParticipants: [],
          callRecordings: [],
          loading: false,
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        callActive: [],
        callSessionParticipants: [],
        callRecordings: [],
        loading: false,
      },
    })
  }
}

/* ADD TO GROUPS */

export function* ADD_MEMBERS_TO_GROUP({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const { uids } = payload
  const { guid: addGUID } = reduxStore.getState().apps.groupsActive
  const success = yield call(addMembersToGroup, uids, addGUID, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'apps/GET_GROUP_MEMBERS',
      payload: {
        id: addGUID,
        currentPage: 1,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `User added to group` },
    })
  } else if (success.error.message !== undefined) {
    if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Group action not allowed ',
        },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Some error occurred' },
    })
  }

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: false,
    },
  })
  return success
}

export function* INITIATE_NOTIFICATION({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      notification_type: payload.type,
      notification_message: payload.message,
      notification_auto_close: !!payload.autoClose,
    },
  })
}

export function* RESET_NOTIFICATION() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      notification_type: 'info',
      notification_message: '',
      notification_auto_close: false,
    },
  })
}

export function* SHOW_INTENT_REQUEST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      currentIntentRequest: '',
    },
  })
  const { intent: currentIntentRequest } = payload
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      currentIntentRequest,
    },
  })
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      visibleModalID: 'intentRequest',
    },
  })
}

export function* HIDE_INTENT_REQUEST() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      currentIntentRequest: '',
    },
  })
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      visibleModalID: '',
    },
  })
}

export function* NON_PARTICIPANTS_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.nonParticipantSearchText
  const nonParticipantsPagination = reduxStore.getState().apps.nonParticipantsListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && nonParticipantsPagination.current_page !== undefined)
    pageNo = nonParticipantsPagination.current_page + 1
  const success = yield call(
    usersList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText || '',
  )

  if (success && success.data) {
    let totalUserCount = success.data.length
    let nonParticipantsListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      nonParticipantsListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        nonParticipantsList: success.data,
        nonParticipantsListTotal: totalUserCount,
        nonParticipantsListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonParticipantsList: [],
        nonParticipantsListTotal: 0,
        nonParticipantsListPagination: {},
        loading: false,
      },
    })
  }
}

/* USER SEARCH TEXT */

export function* ENTER_NON_PARTICIPANT_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonParticipantSearchText: '',
        loading: false,
      },
    })
    yield put({
      type: 'apps/SEARCH_NON_PARTICIPANT',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonParticipantSearchText: searchText,
        loading: true,
      },
    })

    yield put({
      type: 'apps/SEARCH_NON_PARTICIPANT',
      payload: {
        loading: false,
      },
    })
  }
}

/* SEARCH_NON_PARTICIPANT */

export function* SEARCH_NON_PARTICIPANT() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.nonParticipantSearchText
  const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText || '')

  if (success && success.data) {
    let totalUserCount = success.data.length
    let nonParticipantsListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      nonParticipantsListPagination = success.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        nonParticipantsList: success.data,
        nonParticipantsListTotal: totalUserCount,
        nonParticipantsListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        nonParticipantsListTotal: 0,
        nonParticipantsListPagination: {},
        loading: false,
      },
    })
  }
}

export function* NON_USER_FRIEND_LIST_MODAL({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.nonFriendSearchText
  const nonFriendPagination = reduxStore.getState().apps.nonFriendListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && nonFriendPagination.current_page !== undefined)
    pageNo = nonFriendPagination.current_page + 1
  if (_.trim(searchText) === '') {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonFriendList: [],
        nonFriendListTotal: 0,
        nonFriendListPagination: {},
        loading: false,
      },
    })

    return
  }

  const success = yield call(
    usersList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  if (success && success.data) {
    let totalUserCount = success.data.length
    let nonFriendListPagination = []

    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      nonFriendListPagination = success.meta.pagination
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        nonFriendList: success.data,
        nonFriendListTotal: totalUserCount,
        nonFriendListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonFriendList: [],
        nonFriendListTotal: 0,
        nonFriendListPagination: [],
        loading: false,
      },
    })
  }
}

/* NON FRIENDS LIST TEXT */

export function* ENTER_NON_FRIEND_LIST_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonFriendSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonFriendSearchText: searchText,
        loading: true,
      },
    })

    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_NON_FRIEND_LIST_MODAL',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_NON_FRIEND_LIST_MODAL */

export function* SEARCH_NON_FRIEND_LIST_MODAL() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.nonFriendSearchText
  if (_.trim(searchText) === '') {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonFriendList: [],
        nonFriendListTotal: 0,
        nonFriendListPagination: {},
        loading: false,
      },
    })

    return
  }
  const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText)

  if (success && success.data) {
    let totalUserCount = success.data.length
    let nonFriendListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      nonFriendListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        nonFriendList: success.data,
        nonFriendListTotal: totalUserCount,
        nonFriendListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        nonFriendListTotal: 0,
        nonFriendListPagination: [],
        loading: false,
      },
    })
  }
}

export function* NON_USER_GROUP_LIST_MODAL({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.nonGroupSearchText
  const nonGroupPagination = reduxStore.getState().apps.nonGroupListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && nonGroupPagination.current_page !== undefined)
    pageNo = nonGroupPagination.current_page + 1
  if (_.trim(searchText) === '') {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonGroupList: [],
        nonGroupListTotal: 0,
        nonGroupListPagination: {},
        loading: false,
      },
    })

    return
  }
  const success = yield call(
    groupsList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  if (success && success.data) {
    let totalGroupCount = success.data.length
    let nonGroupListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      nonGroupListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        nonGroupList: success.data,
        nonGroupListTotal: totalGroupCount,
        nonGroupListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonGroupList: [],
        nonGroupListTotal: 0,
        nonGroupListPagination: {},
        loading: false,
      },
    })
  }
}

/* NON FRIENDS LIST TEXT */

export function* ENTER_NON_GROUP_LIST_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonGroupSearchText: '',
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonGroupSearchText: searchText,
        loading: true,
      },
    })

    if (searchText.length === 0 || searchText.length >= 2) {
      yield put({
        type: 'apps/SEARCH_NON_GROUP_LIST_MODAL',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  }
}

/* SEARCH_NON_GROUP_LIST_MODAL */

export function* SEARCH_NON_GROUP_LIST_MODAL() {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const searchText = reduxStore.getState().apps.nonGroupSearchText
  if (_.trim(searchText) === '') {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        nonGroupList: [],
        nonGroupListTotal: 0,
        loading: false,
      },
    })

    return
  }
  const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)
  if (success && success.data) {
    let totalGroupCount = success.data.length
    let nonGroupListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      nonGroupListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        nonGroupList: success.data,
        nonGroupListTotal: totalGroupCount,
        nonGroupListPagination,
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: activeApp,
        nonGroupList: [],
        nonGroupListTotal: 0,
        nonGroupListPagination: {},
        loading: false,
      },
    })
  }
}

export function* GET_CALL_SESSION_PARTICIPANT_DETAILS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (payload !== undefined && payload.id !== undefined) {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      getCallSessionParticipants,
      payload.data,
      getAppMetricHost(payload.appSettings),
      'calls',
      payload.id,
      payload.beginningTimestamp,
      payload.endingTimestamp,
    )

    if (success && success.data) {
      const callSessionParticipants = success.data
      const callSessionParticipantUIDs = _.uniq(_.map(callSessionParticipants, 'uid')).join(',')

      if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
      const multipleUserData = yield call(
        getMultipleUsers,
        callSessionParticipantUIDs,
        payload.data,
        getAppHost(payload.appSettings),
      )

      let callSessionParticipantData = []
      _.forEach(callSessionParticipants, function fn(v1) {
        const matchingIndexTemp = _.findIndex(multipleUserData.data, function fn2(v2) {
          return v2.uid === v1.uid
        })
        if (matchingIndexTemp >= 0) {
          let tempPlatform = 'Other'

          const tempRowData = {
            uid: v1.uid,
            name: multipleUserData.data[matchingIndexTemp].name,
            role: multipleUserData.data[matchingIndexTemp].role,
            isDeleted: false,
            audioMinutes: '-',
            video_minutes: '-',
            avatar:
              multipleUserData.data[matchingIndexTemp].avatar !== undefined
                ? multipleUserData.data[matchingIndexTemp].avatar
                : '',
            platform: tempPlatform,
            start_time: v1.start_time,
          }

          if (_.includes(v1.device_id, 'WEB', 0)) tempPlatform = 'Web'
          else if (_.includes(v1.device_id, 'Android', 0)) tempPlatform = 'Android'
          else if (_.includes(v1.device_id, 'ios', 0)) tempPlatform = 'IOS'
          else if (_.includes(v1.device_id, 'ionic', 0)) tempPlatform = 'Ionic'
          else if (_.includes(v1.device_id, 'react_native', 0)) tempPlatform = 'React Native'

          tempRowData.platform = tempPlatform
          tempRowData.audioMinutes = v1.voice_minutes > 0 ? v1.voice_minutes : '-'
          tempRowData.videoMinutes = v1.video_minutes > 0 ? v1.video_minutes : '-'

          callSessionParticipantData = _.concat(callSessionParticipantData, tempRowData)
        } else {
          const tempRowData = {
            uid: v1.uid,
            name: 'User',
            role: '-',
            isDeleted: true,
          }
          let tempPlatform = 'Other'
          if (_.includes(v1.device_id, 'WEB', 0)) tempPlatform = 'Web'
          else if (_.includes(v1.device_id, 'Android', 0)) tempPlatform = 'Android'
          else if (_.includes(v1.device_id, 'ios', 0)) tempPlatform = 'IOS'
          else if (_.includes(v1.device_id, 'ionic', 0)) tempPlatform = 'Ionic'
          else if (_.includes(v1.device_id, 'react_native', 0)) tempPlatform = 'React Native'
          tempRowData.platform = tempPlatform
          tempRowData.audioMinutes = v1.voice_minutes > 0 ? v1.voice_minutes : '-'
          tempRowData.videoMinutes = v1.video_minutes > 0 ? v1.video_minutes : '-'
          callSessionParticipantData = _.concat(callSessionParticipantData, tempRowData)
        }
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          callSessionParticipantsLegacy: callSessionParticipantData,
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          callSessionParticipantsLegacy: [],
          loading: false,
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        callSessionParticipantsLegacy: [],
        loading: false,
      },
    })
  }
}

export function* GET_CALL_LOGS_LEGACY({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      callSearchLogsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let startRange = 0
  let endRange = 0
  if (payload !== undefined && payload.fromDate !== undefined && payload.toDate !== undefined) {
    startRange = payload.fromDate
    endRange = payload.toDate
  } else {
    const nowDate = new Date()
    endRange = nowDate.getTime()
    const todayStartTime = new Date(
      nowDate.getFullYear(),
      nowDate.getMonth(),
      nowDate.getDate(),
      0,
      0,
      0,
    )
    const startRangeDate = new Date(todayStartTime - 7 * 24 * 60 * 60 * 1000)

    startRange = startRangeDate.getTime()
  }

  const success = yield call(
    callLogsLegacy,
    payload.data,
    getAppMetricHost(payload.appSettings),
    'calls',
    Math.floor(startRange),
    Math.floor(endRange),
  )

  if (success && success.data) {
    let callLogData = success.data
    callLogData = _.sortBy(callLogData, ['start_time'])
    callLogData = _.reverse(callLogData)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        callSearchLogsLegacy: callLogData,
        loading: false,
        callSearchLogsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        callSearchLogsLegacy: [],
        loading: false,
        callSearchLogsLoading: false,
      },
    })
  }
}

export function* GET_CALL_BY_ID_LEGACY({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  if (payload !== undefined && payload.id !== undefined) {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      getCallDetailLegacy,
      payload.data,
      getAppMetricHost(payload.appSettings),
      payload.id,
      payload.beginningTimestamp,
      payload.endingTimestamp,
    )

    if (success && success.data && success.data.length) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          callActiveLegacy: success.data[0],
          loading: false,
        },
      })
      yield put({
        type: 'apps/GET_CALL_SESSION_PARTICIPANT_DETAILS',
        payload,
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          callActiveLegacy: [],
          loading: false,
        },
      })
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        callActiveLegacy: [],
        loading: false,
      },
    })
  }
}

/* MODERATION RULES */

export function* MODERATION_LIST_RULES({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const rulesPagination = reduxStore.getState().apps.moderationRulesListPagination
  const { paginationType, pageNo } = payload
  let paginationPayload = ''
  if (paginationType === 'next' && rulesPagination.next !== undefined) {
    paginationPayload = objectToParams(rulesPagination.next)
  } else if (paginationType === 'previous' && rulesPagination.previous !== undefined) {
    paginationPayload = objectToParams(rulesPagination.previous)
  }

  const success = yield call(moderationRulesList, payload.data, paginationPayload)

  if (success && success.data) {
    let totalRuleCount = success.data.length
    let moderationRulesListPagination = {}

    if (success.meta) {
      moderationRulesListPagination = success.meta
      totalRuleCount = success.meta.current.limit + 1
      if (pageNo !== undefined && paginationType === undefined) {
        totalRuleCount = pageNo * success.meta.current.limit
      } else if (
        pageNo !== undefined &&
        paginationType === 'next' &&
        success.meta.next !== undefined
      ) {
        totalRuleCount = pageNo * success.meta.current.limit + 1
      } else if (
        pageNo !== undefined &&
        paginationType === 'previous' &&
        success.meta.previous !== undefined
      ) {
        totalRuleCount = pageNo * success.meta.current.limit + 1
      } else if (
        pageNo === undefined &&
        paginationType === undefined &&
        success.meta.next === undefined
      ) {
        totalRuleCount = pageNo * success.meta.current.limit
      }
    }
    const nonDefaultRules = success.data.filter(item => !item.default)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        moderationRulesList: success.data,
        moderationRulesListTotal: totalRuleCount,
        moderationRulesNonDefaultListTotal: nonDefaultRules.length,
        moderationRulesListPagination,
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationRulesList: [],
        moderationRulesListTotal: 0,
        moderationRulesNonDefaultListTotal: 0,
        moderationRulesListPagination: [],
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
  }
}

/* MODERATION RULES */
export function* MODERATION_LIST_DROPPED_MESSAGES({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
      isModerationActivityLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const activityPagination = reduxStore.getState().apps.moderationActivityListPagination
  const currentParams =
    reduxStore.getState().apps.moderationActivityListPaginationCurentParams || {}
  let moderationActivityListPaginationCurentParams = {}

  const { paginationType, pageNo, paginationPayloadCurrent } = payload
  const effectivePageNo = pageNo === undefined && paginationType === undefined ? 1 : pageNo

  let paginationPayloadObj = {}
  let paginationPayload = ''

  if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.affix !== undefined) {
    paginationPayload = objectToParams(paginationPayloadCurrent)
    paginationPayloadObj.affix = paginationPayloadCurrent.affix
  } else if (paginationType === 'next' && activityPagination.next !== undefined) {
    paginationPayload = objectToParams(activityPagination.next)
    paginationPayloadObj = { ...activityPagination.next }
  } else if (paginationType === 'previous' && activityPagination.previous !== undefined) {
    paginationPayload = objectToParams(activityPagination.previous)
    paginationPayloadObj = { ...activityPagination.previous }
  }

  let startRange = 0
  let endRange = 0
  if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.startRange !== undefined) {
    const { startRange: startRangeCurrent, endRange: endRangeCurrent } = paginationPayloadCurrent
    startRange = startRangeCurrent
    endRange = endRangeCurrent
  } else if (
    payload !== undefined &&
    payload.fromDate !== undefined &&
    payload.toDate !== undefined &&
    payload.fromDate &&
    payload.toDate
  ) {
    startRange = payload.fromDate
    endRange = payload.toDate
  } else if (paginationType && currentParams.startRange) {
    ;({ startRange, endRange } = currentParams)
  }

  let filters = {}
  if (payload.filters && Object.keys(payload.filters).length > 0) {
    ;({ filters } = payload)
  } else if (paginationType && currentParams.filters) {
    ;({ filters } = currentParams)
  }

  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    moderationActivityList,
    payload.data,
    getAppHost(appSettings),
    paginationPayload,
    startRange ? Math.floor(startRange / 1000) : 0,
    endRange ? Math.floor(endRange / 1000) : 0,
    filters,
  )

  if (success && success.data) {
    paginationPayloadObj.startRange = startRange
    paginationPayloadObj.endRange = endRange
    paginationPayloadObj.filters = filters

    moderationActivityListPaginationCurentParams = paginationPayloadObj
    let totalActivityCount = success.data.length
    let moderationActivityListPagination = {}

    if (success.meta) {
      moderationActivityListPagination = success.meta

      totalActivityCount = moderationActivityListPagination.current.limit + 1

      moderationActivityListPaginationCurentParams = paginationPayloadObj

      if (
        effectivePageNo !== undefined &&
        paginationType === undefined &&
        success.meta.next === undefined
      ) {
        totalActivityCount = success.meta.current.count
      } else if (effectivePageNo !== undefined && paginationType === undefined) {
        totalActivityCount = effectivePageNo * success.meta.current.limit + 1
      } else if (
        effectivePageNo !== undefined &&
        paginationType === 'next' &&
        success.meta.next !== undefined
      ) {
        totalActivityCount = effectivePageNo * success.meta.current.limit + 1
      } else if (
        effectivePageNo !== undefined &&
        paginationType === 'previous' &&
        success.meta.previous !== undefined
      ) {
        totalActivityCount = effectivePageNo * success.meta.current.limit + 1
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        moderationActivityList: success.data,
        moderationActivityListTotal: totalActivityCount,
        moderationActivityListPagination,
        loading: false,
        areModerationSectionsLoading: false,
        isModerationActivityLoading: false,
        moderationActivityListPaginationCurentParams,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationActivityList: [],
        moderationActivityListTotal: 0,
        moderationActivityListPagination: {},
        loading: false,
        areModerationSectionsLoading: false,
        isModerationActivityLoading: false,
        moderationActivityListPaginationCurentParams: {},
      },
    })
  }
  return success
}

/* MODERATION_LIST_FLAGGED_MESSAGES */
export function* MODERATION_LIST_FLAGGED_MESSAGES({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
      isModerationFlaggedMessagesLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const flaggedMessagesPagination = reduxStore.getState().apps
    .moderationFlaggedMessagesListPagination
  const currentParams =
    reduxStore.getState().apps.moderationFlaggedMessagesListPaginationCurrentParams || {}
  let moderationFlaggedMessagesListPaginationCurrentParams = {}

  const { paginationType, pageNo, paginationPayloadCurrent } = payload
  const effectivePageNo = pageNo === undefined && paginationType === undefined ? 1 : pageNo

  let paginationPayloadObj = {}
  let paginationPayload = ''

  if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.affix !== undefined) {
    paginationPayload = objectToParams(paginationPayloadCurrent)
    paginationPayloadObj.affix = paginationPayloadCurrent.affix
  } else if (paginationType === 'next' && flaggedMessagesPagination.next !== undefined) {
    paginationPayload = objectToParams(flaggedMessagesPagination.next)
    paginationPayloadObj = { ...flaggedMessagesPagination.next }
  } else if (paginationType === 'previous' && flaggedMessagesPagination.previous !== undefined) {
    paginationPayload = objectToParams(flaggedMessagesPagination.previous)
    paginationPayloadObj = { ...flaggedMessagesPagination.previous }
  }

  let startRange = 0
  let endRange = 0
  if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.startRange !== undefined) {
    const { startRange: startRangeCurrent, endRange: endRangeCurrent } = paginationPayloadCurrent
    startRange = startRangeCurrent
    endRange = endRangeCurrent
  } else if (
    payload !== undefined &&
    payload.fromDate !== undefined &&
    payload.toDate !== undefined &&
    payload.fromDate &&
    payload.toDate
  ) {
    startRange = payload.fromDate
    endRange = payload.toDate
  } else if (paginationType && currentParams.startRange) {
    ;({ startRange, endRange } = currentParams)
  }

  let flaggedFilters = {}
  if (payload.filters && Object.keys(payload.filters).length > 0) {
    flaggedFilters = payload.filters
  } else if (paginationType && currentParams.filters) {
    flaggedFilters = currentParams.filters
  }

  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    moderationFlaggedMessagesList,
    payload.data,
    getAppHost(appSettings),
    paginationPayload,
    startRange ? Math.floor(startRange / 1000) : 0,
    endRange ? Math.floor(endRange / 1000) : 0,
    flaggedFilters,
  )

  if (success && success.data) {
    moderationFlaggedMessagesListPaginationCurrentParams = paginationPayloadObj
    paginationPayloadObj.startRange = startRange
    paginationPayloadObj.endRange = endRange
    paginationPayloadObj.filters = flaggedFilters
    let totalFlaggedMessagesCount = success.data.length
    let moderationFlaggedMessagesListPagination = {}

    if (success.meta) {
      moderationFlaggedMessagesListPagination = success.meta

      totalFlaggedMessagesCount = moderationFlaggedMessagesListPagination.current.limit + 1

      moderationFlaggedMessagesListPaginationCurrentParams = paginationPayloadObj

      if (
        effectivePageNo !== undefined &&
        paginationType === undefined &&
        success.meta.next === undefined
      ) {
        totalFlaggedMessagesCount = success.meta.current.count
      } else if (effectivePageNo !== undefined && paginationType === undefined) {
        totalFlaggedMessagesCount = effectivePageNo * success.meta.current.limit + 1
      } else if (
        effectivePageNo !== undefined &&
        paginationType === 'next' &&
        success.meta.next !== undefined
      ) {
        totalFlaggedMessagesCount = effectivePageNo * success.meta.current.limit + 1
      } else if (
        effectivePageNo !== undefined &&
        paginationType === 'previous' &&
        success.meta.previous !== undefined
      ) {
        totalFlaggedMessagesCount = effectivePageNo * success.meta.current.limit + 1
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        moderationFlaggedMessagesList: success.data,
        moderationFlaggedMessagesListTotal: totalFlaggedMessagesCount,
        moderationFlaggedMessagesListPagination,
        loading: false,
        areModerationSectionsLoading: false,
        isModerationFlaggedMessagesLoading: false,
        moderationFlaggedMessagesListPaginationCurrentParams,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationFlaggedMessagesList: [],
        moderationFlaggedMessagesListTotal: 0,
        moderationFlaggedMessagesListPagination: {},
        loading: false,
        areModerationSectionsLoading: false,
        isModerationFlaggedMessagesLoading: false,
        moderationFlaggedMessagesListPaginationCurrentParams: {},
      },
    })
  }
  return success
}

/* MODERATION_LIST_REVIEWED_MESSAGES */
export function* MODERATION_LIST_REVIEWED_MESSAGES({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
      isModerationReviewedMessagesLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const reviewedMessagesPagination = reduxStore.getState().apps
    .moderationReviewedMessagesListPagination
  const currentParams =
    reduxStore.getState().apps.moderationReviewedMessagesListPaginationCurrentParams || {}
  let moderationReviewedMessagesListPaginationCurrentParams = {}

  const { paginationType, pageNo, paginationPayloadCurrent } = payload
  const effectivePageNo = pageNo === undefined && paginationType === undefined ? 1 : pageNo

  let paginationPayloadObj = {}
  let paginationPayload = ''

  if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.affix !== undefined) {
    paginationPayload = objectToParams(paginationPayloadCurrent)
    paginationPayloadObj.affix = paginationPayloadCurrent.affix
  } else if (paginationType === 'next' && reviewedMessagesPagination.next !== undefined) {
    paginationPayload = objectToParams(reviewedMessagesPagination.next)
    paginationPayloadObj = { ...reviewedMessagesPagination.next }
  } else if (paginationType === 'previous' && reviewedMessagesPagination.previous !== undefined) {
    paginationPayload = objectToParams(reviewedMessagesPagination.previous)
    paginationPayloadObj = { ...reviewedMessagesPagination.previous }
  }

  // determine start/end range (UI provides ms timestamps; backend expects seconds)
  let startRange = 0
  let endRange = 0
  if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.startRange !== undefined) {
    const { startRange: startRangeCurrent, endRange: endRangeCurrent } = paginationPayloadCurrent
    startRange = startRangeCurrent
    endRange = endRangeCurrent
  } else if (
    payload !== undefined &&
    payload.fromDate !== undefined &&
    payload.toDate !== undefined &&
    payload.fromDate &&
    payload.toDate
  ) {
    startRange = payload.fromDate
    endRange = payload.toDate
  } else if (paginationType && currentParams.startRange) {
    // Use persisted date range when paginating
    ;({ startRange, endRange } = currentParams)
  }

  // Use filters from payload, or fall back to persisted filters when paginating
  let reviewedFilters = {}
  if (payload.filters && Object.keys(payload.filters).length > 0) {
    reviewedFilters = payload.filters
  } else if (paginationType && currentParams.filters) {
    reviewedFilters = currentParams.filters
  }

  const { appSettings } = reduxStore.getState().apps

  const success = yield call(
    moderationReviewedMessagesList,
    payload.data,
    getAppHost(appSettings),
    paginationPayload,
    startRange ? Math.floor(startRange / 1000) : 0,
    endRange ? Math.floor(endRange / 1000) : 0,
    reviewedFilters,
  )

  if (success && success.data) {
    moderationReviewedMessagesListPaginationCurrentParams = paginationPayloadObj
    // persist start/end (ms) in current pagination params for subsequent requests
    paginationPayloadObj.startRange = startRange
    paginationPayloadObj.endRange = endRange
    // persist filters for subsequent pagination requests
    paginationPayloadObj.filters = reviewedFilters
    let totalReviewedMessagesCount = success.data.length
    let moderationReviewedMessagesListPagination = {}

    if (success.meta) {
      moderationReviewedMessagesListPagination = success.meta

      totalReviewedMessagesCount = moderationReviewedMessagesListPagination.current.limit + 1
      moderationReviewedMessagesListPaginationCurrentParams = paginationPayloadObj

      if (
        effectivePageNo !== undefined &&
        paginationType === undefined &&
        success.meta.next === undefined
      ) {
        totalReviewedMessagesCount = success.meta.current.count
      } else if (effectivePageNo !== undefined && paginationType === undefined) {
        totalReviewedMessagesCount = effectivePageNo * success.meta.current.limit + 1
      } else if (
        effectivePageNo !== undefined &&
        paginationType === 'next' &&
        success.meta.next !== undefined
      ) {
        totalReviewedMessagesCount = effectivePageNo * success.meta.current.limit + 1
      } else if (
        effectivePageNo !== undefined &&
        paginationType === 'previous' &&
        success.meta.previous !== undefined
      ) {
        totalReviewedMessagesCount = effectivePageNo * success.meta.current.limit + 1
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        moderationReviewedMessagesList: Array.isArray(success.data) ? success.data : [],
        moderationReviewedMessagesListTotal: totalReviewedMessagesCount,
        moderationReviewedMessagesListPagination,
        loading: false,
        areModerationSectionsLoading: false,
        isModerationReviewedMessagesLoading: false,
        moderationReviewedMessagesListPaginationCurrentParams,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationReviewedMessagesList: [],
        moderationReviewedMessagesListTotal: 0,
        moderationReviewedMessagesListPagination: {},
        loading: false,
        areModerationSectionsLoading: false,
        isModerationReviewedMessagesLoading: false,
        moderationReviewedMessagesListPaginationCurrentParams: {},
      },
    })
  }

  return success
}

/* MODERATION_GET_RULE */

export function* MODERATION_GET_RULE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id, redirectTo } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(getModerationRule, id, payload.data)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationRuleActive: success.data,
        loading: false,
      },
    })
    if (redirectTo && redirectTo === 'view') {
      const pushObj = {
        pathname: `/app/${payload.data.id}/moderation/rules/${success.data.id}/view`,
      }
      if (payload.from) pushObj.state = { from: payload.from }
      yield put(push(pushObj))
    } else if (redirectTo && redirectTo === 'edit') {
      yield put(push(`/app/${payload.data.id}/moderation/rules/${success.data.id}/edit`))
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationRuleActive: [],
        loading: false,
      },
    })
    yield put(push(`/app/${payload.data.id}/moderation/rules`))
  }
}

/* MODERATION RULES */

export function* MODERATION_GET_RULE_AND_RULE_REVISIONS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
    },
  })
  const { id, redirectTo } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const successRule = yield call(getModerationRule, id, payload.data)
  if (successRule && successRule.data) {
    const ruleRevisionsPagination = reduxStore.getState().apps.moderationRuleRevisionsList

    const { paginationType, pageNo } = payload
    let paginationPayload = ''
    if (paginationType === 'next' && ruleRevisionsPagination.next !== undefined) {
      paginationPayload = objectToParams(ruleRevisionsPagination.next)
    } else if (paginationType === 'previous' && ruleRevisionsPagination.previous !== undefined) {
      paginationPayload = objectToParams(ruleRevisionsPagination.previous)
    }

    const success = yield call(moderationRuleRevisionsList, id, payload.data, paginationPayload)

    if (success && success.data) {
      let totalRuleRevisionCount = success.data.length
      let moderationRuleRevisionsListPagination = {}

      if (success.meta) {
        moderationRuleRevisionsListPagination = success.meta
        totalRuleRevisionCount = success.meta.current.limit + 1
        if (pageNo !== undefined && paginationType === undefined) {
          totalRuleRevisionCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta.next !== undefined
        ) {
          totalRuleRevisionCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalRuleRevisionCount = pageNo * success.meta.current.limit
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          moderationRuleRevisionsList: success.data,
          moderationRuleRevisionsListTotal: totalRuleRevisionCount,
          moderationRuleRevisionsListPagination,
          loading: false,
          areModerationSectionsLoading: false,
          moderationRuleActive: successRule.data,
        },
      })
      if (redirectTo && redirectTo === 'view') {
        const pushObj = { pathname: `/app/${payload.data.id}/moderation/rules/${id}/view` }
        if (payload.from) pushObj.state = { from: payload.from }
        yield put(push(pushObj))
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          moderationRuleRevisionsList: [],
          moderationRuleRevisionsListTotal: 0,
          moderationRuleRevisionsListPagination: [],
          loading: false,
          areModerationSectionsLoading: false,
          moderationRuleActive: successRule.data,
        },
      })
      if (success.error.message !== undefined) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      }
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationRuleActive: [],
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
    if (successRule.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: successRule.error.message },
      })
    }
  }
}

/* RULE DELETE */

export function* MODERATION_DELETE_RULE({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { moderationRulesListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(moderationRuleDelete, id, activeApp)

  if (success && success.data) {
    const ruleListPageNo =
      moderationRulesListPagination !== undefined && moderationRulesListPagination.count > 1
        ? moderationRulesListPagination.current_page
        : 1
    yield put({
      type: 'apps/MODERATION_LIST_RULES',
      payload: { currentPage: ruleListPageNo, data: activeApp },
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Rule deleted` },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/moderation`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* CHANGE_MODERATION_RULE_STATUS */

export function* CHANGE_MODERATION_RULE_STATUS({ payload }) {
  const { id, status } = payload

  const activeApp = reduxStore.getState().apps.active

  const allRules = reduxStore.getState().apps.moderationRulesList

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const data = { enabled: !status }

  const success = yield call(moderationRuleUpdate, id, data, activeApp)

  let successMessage

  if (success && success.data) {
    _.forEach(allRules, function fn(c, k) {
      if (c.id === id) {
        if (allRules[k].enabled) {
          successMessage = 'disabled'
        } else {
          successMessage = 'enabled'
        }

        allRules[k].enabled = !allRules[k].enabled
      }
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationRulesList: allRules,
        loading: false,
      },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Moderation rule ${successMessage}` },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.code !== undefined && success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* MODERATION  */

export function* MODERATION_LIST_KEYWORDS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const keywordsPagination = reduxStore.getState().apps.moderationKeywordListPagination
  const { paginationType, pageNo } = payload
  let paginationPayload = ''
  if (paginationType === 'next' && keywordsPagination.next !== undefined) {
    paginationPayload = objectToParams(keywordsPagination.next)
  } else if (paginationType === 'previous' && keywordsPagination.previous !== undefined) {
    paginationPayload = objectToParams(keywordsPagination.previous)
  }

  const success = yield call(moderationKeywordsList, payload.data, paginationPayload)

  if (success && success.data) {
    let totalKeywordCount = success.data.length
    let moderationKeywordListPagination = {}

    if (success.meta) {
      moderationKeywordListPagination = success.meta
      totalKeywordCount = success.meta.current.limit + 1
      if (pageNo !== undefined && paginationType === undefined) {
        totalKeywordCount = pageNo * success.meta.current.limit
      } else if (
        pageNo !== undefined &&
        paginationType === 'next' &&
        success.meta.next !== undefined
      ) {
        totalKeywordCount = pageNo * success.meta.current.limit + 1
      } else if (
        pageNo === undefined &&
        paginationType === undefined &&
        success.meta.next === undefined
      ) {
        totalKeywordCount = pageNo * success.meta.current.limit
      }
    }

    const nonDefaultkeywords = success.data.filter(item => !item.default)
    const moderationKeywordNonDefaultListTotal = nonDefaultkeywords.length
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        moderationKeywordsList: success.data,
        moderationKeywordListTotal: totalKeywordCount,
        moderationKeywordNonDefaultListTotal,
        moderationKeywordListPagination,
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationKeywordsList: [],
        moderationKeywordListTotal: 0,
        moderationKeywordNonDefaultListTotal: 0,
        moderationKeywordListPagination: [],
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
  }
}

/* KEYWORD DELETE */

export function* MODERATION_DELETE_KEYWORD({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { moderationKeywordListPagination } = reduxStore.getState().apps

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(moderationKeywordDelete, id, activeApp)

  if (success && success.data) {
    const keywordListPageNo =
      moderationKeywordListPagination !== undefined && moderationKeywordListPagination.count > 1
        ? moderationKeywordListPagination.current_page
        : 1

    yield put({
      type: 'apps/MODERATION_LIST_KEYWORDS',
      payload: { currentPage: keywordListPageNo, data: activeApp },
    })

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `List deleted` },
    })

    if (refresh) yield put(push(`/app/${activeApp.id}/moderation`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.code !== undefined && success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

export function* MODERATION_ADD_KEYWORD({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(moderationKeywordAdd, payload, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/MODERATION_LIST_KEYWORDS',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/moderation/lists`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'List added' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* MODERATION_UPDATE_KEYWORD UPDATE */

export function* MODERATION_UPDATE_KEYWORD({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(moderationKeywordUpdate, payload.id, payload, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/MODERATION_LIST_KEYWORDS',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/moderation/lists`))

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'List updated' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
  }
}

/* MODERARATION KEYWORD GET */

export function* MODERATION_GET_KEYWORD({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  const activeApp = reduxStore.getState().apps.active

  const success = yield call(moderationKeywordGet, id, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationKeywordActive: success.data,
        loading: false,
      },
    })
  } else {
    if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
    yield put(push(`/app/${activeApp.id}/moderation`))
  }
  return success
}

/* MODERARATION CONFIG GET */

export function* MODERATION_LIST_CONFIGURATION({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areModerationSectionsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(moderationConfigurationList, payload.data)

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationConfigurationList: success.data,
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
  } else {
    if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationConfigurationList: [],
        loading: false,
        areModerationSectionsLoading: false,
      },
    })
  }
  return success
}

export function* MODERATION_ADD_RULE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(moderationRuleAdd, payload, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/MODERATION_LIST_RULES',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/moderation/rules`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Rule added' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* MODERATION_UPDATE_RULE UPDATE */

export function* MODERATION_UPDATE_RULE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(moderationRuleUpdate, payload.id, payload, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/MODERATION_LIST_RULES',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/moderation/rules`))

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Rule updated' },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Unknown Error' },
      })
    }
  }
}

/* RULE DELETE */

export function* MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS({ payload }) {
  const { id, status, reviewed, refresh, fromDate, toDate } = payload

  const activeApp = reduxStore.getState().apps.active

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(moderationUpdateBlockedMessageStatus, id, status, activeApp, reviewed)

  if (success && success.data) {
    const {
      moderationActivityListPagination,
    } = reduxStore.getState().apps.moderationActivityListPagination
    const blockedMessageListPageNo =
      moderationActivityListPagination !== undefined && moderationActivityListPagination.count > 1
        ? moderationActivityListPagination.current_page
        : 1

    const { moderationActivityListPaginationCurentParams } = reduxStore.getState().apps

    yield put({
      type: 'apps/MODERATION_LIST_DROPPED_MESSAGES',
      payload: {
        pageNo: blockedMessageListPageNo,
        paginationPayloadCurrent: moderationActivityListPaginationCurentParams,
        data: activeApp,
        ...(fromDate && toDate ? { fromDate, toDate } : {}),
      },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: success.data.success ? 'success' : 'warning',
        message: success.data.message,
      },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/moderation`))
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.details.name },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

export function* MODERATION_ACCEPT_FLAGGED_MESSAGE({ payload }) {
  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  yield put({ type: 'apps/SET_STATE', payload: { loading: true } })
  const success = yield call(moderationReviewFlaggedMessage, activeApp, id)
  if (success && !success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Message approved & marked reviewed' },
    })
    yield delay(750)
    const cacheBust = { paginationPayloadCurrent: { ts: Date.now() } }
    yield put({
      type: 'apps/MODERATION_LIST_FLAGGED_MESSAGES',
      payload: { data: activeApp, ...cacheBust },
    })
    yield put({
      type: 'apps/MODERATION_LIST_REVIEWED_MESSAGES',
      payload: { data: activeApp, ...cacheBust },
    })
  } else {
    const errMsg = success?.error?.message || 'Failed to review message'
    yield put({ type: 'apps/INITIATE_NOTIFICATION', payload: { type: 'error', message: errMsg } })
  }
  yield put({ type: 'apps/SET_STATE', payload: { loading: false } })
}

export function* MODERATION_APPROVE_FLAGGED_MESSAGE({ payload }) {
  const { id, fromDate, toDate } = payload
  const activeApp = reduxStore.getState().apps.active
  yield put({ type: 'apps/SET_STATE', payload: { loading: true } })
  const success = yield call(moderationApproveOnlyFlaggedMessage, activeApp, id)
  if (success && !success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Message approved' },
    })
    yield delay(750)
    const cacheBust = { paginationPayloadCurrent: { ts: Date.now() } }
    yield put({
      type: 'apps/MODERATION_LIST_FLAGGED_MESSAGES',
      payload: {
        data: activeApp,
        ...cacheBust,
        ...(fromDate && toDate ? { fromDate, toDate } : {}),
      },
    })
  } else {
    const errMsg = success?.error?.message || 'Failed to approve message'
    yield put({ type: 'apps/INITIATE_NOTIFICATION', payload: { type: 'error', message: errMsg } })
  }
  yield put({ type: 'apps/SET_STATE', payload: { loading: false } })
}

export function* MODERATION_BLOCK_FLAGGED_MESSAGE({ payload }) {
  const { id, fromDate, toDate } = payload
  const activeApp = reduxStore.getState().apps.active
  yield put({ type: 'apps/SET_STATE', payload: { loading: true } })
  const success = yield call(moderationBlockFlaggedMessage, activeApp, id)
  if (success && !success.error) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Message blocked' },
    })
    yield delay(750)
    const cacheBust = { paginationPayloadCurrent: { ts: Date.now() } }
    yield put({
      type: 'apps/MODERATION_LIST_FLAGGED_MESSAGES',
      payload: {
        data: activeApp,
        ...cacheBust,
        ...(fromDate && toDate ? { fromDate, toDate } : {}),
      },
    })
    yield put({
      type: 'apps/MODERATION_LIST_DROPPED_MESSAGES',
      payload: { data: activeApp, ...cacheBust },
    })
  } else {
    const errMsg = success?.error?.message || 'Failed to block message'
    yield put({ type: 'apps/INITIATE_NOTIFICATION', payload: { type: 'error', message: errMsg } })
  }
  yield put({ type: 'apps/SET_STATE', payload: { loading: false } })
}

export function* MODERATION_BAN_FLAGGED_MESSAGE_SENDER({ payload }) {
  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  yield put({
    type: 'apps/SET_STATE',
    payload: { loading: true },
  })
  const success = yield call(moderationBanSenderOfFlaggedMessage, activeApp, id)
  if (success && success.data) {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Sender banned successfully' },
    })
    yield put({ type: 'apps/MODERATION_LIST_FLAGGED_MESSAGES', payload: { data: activeApp } })
  } else {
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to ban sender' },
    })
  }
  yield put({
    type: 'apps/SET_STATE',
    payload: { loading: false },
  })
}

export function* UPDATE_APP_SETTINGS({
  id,
  payload,
  successModalId,
  notification = { hidden: false, msg: '' },
  suppressModal = false,
}) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  let activeApp = reduxStore.getState().apps.active
  if (activeApp.id === undefined) {
    activeApp = reduxStore.getState().apps.appCreated
  }

  if (isAppAdmin(activeApp) || isAppOwner(activeApp)) {
    const success = yield call(updateSettings, id, payload, activeApp)
    if (success && success.data) {
      const allApps = reduxStore.getState().apps.data
      const appIndex = _.findIndex(allApps, function fn(a) {
        return a.id === activeApp.id
      })
      const appData = yield call(get, id)
      if (appIndex >= 0) {
        allApps[appIndex] = appData.data
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          active: appData.data,
        },
      })
      if (!notification.hidden) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'success', message: notification.msg || 'App updated successfully' },
        })
      }

      if (successModalId) {
        yield put({
          type: 'settings/CHANGE_SETTING',
          payload: {
            setting: 'visibleModalID',
            value: successModalId,
          },
        })
      }
      if (payload[constants.featureSlugList.advanced_search_enabled] && !suppressModal) {
        yield put({
          type: 'settings/CHANGE_SETTING',
          payload: {
            setting: 'visibleModalID',
            value: 'ConversationSearchEnabled',
          },
        })
      }
    } else if (success && success.error) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.errDescription },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (
        success.error !== undefined &&
        success.error.code !== undefined &&
        isAuthErrorCode(success.error.code)
      ) {
        if (success.error.code === 'AUTH_ERR_TOKEN_BLACKLISTED') {
          yield put({
            type: 'user/LOGOUT',
          })
        } else yield put(push(`/login`))
      } else if (success.error.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.details.name },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Error Updating the App' },
        })
      }
    }
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Access Denied - Not Authorized' },
    })
    if (isAppModerator(activeApp)) {
      yield put(push(`/app/${activeApp.id}/users`))
    } else yield put(push(`/app/${activeApp.id}/overview`))
  }
  return activeApp
}

export function* MULTITENANT_GET_USAGE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(requestMultiTenantBillingUsage, payload, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message: 'The report has been successfully shared with the app owner via email.',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    let errorMessage = 'Some error occurred, please try again'
    if (success.error.code !== undefined && success.error.message !== undefined) {
      errorMessage = success.error.message
    }
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'error',
        message: errorMessage,
      },
    })
  }
  return success
}

export function* UPDATE_MODERATION_GLOBAL_SETTINGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { updatedSettings, isCustomApi } = payload

  const success = yield call(moderationUpdateGlobalSettings, activeApp, updatedSettings)

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield put({
      type: 'apps/GET_MODERATION_GLOBAL_SETTINGS',
      payload: { payload },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message: isCustomApi ? 'Custom API settings saved' : 'OpenAI settings saved',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      message.error(success.error.message)
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* GET_MODERATION_GLOBAL_SETTINGS */

export function* GET_MODERATION_GLOBAL_SETTINGS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(moderationGetGlobalSettings, payload.data)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        moderationOpenAICustomAPISettings: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${payload.data.id}/moderation/${'rules'}`))
  }
}

/* GTM_TRIGGERED_MANUAL_INTENT */

export function* GTM_TRIGGERED_MANUAL_INTENT({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  if (!_.isEmpty(activeApp) && activeApp.id !== undefined) {
    const intent = _.join([payload.intent, activeApp.id], ' / ')
    const post = { intent }

    const success = yield call(manualOutreach, post)

    return success
  }
}

export function* BUILDER_GET({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(builderGet, id, payload.data)
  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        buildersActive: success.data,
        loading: false,
      },
    })
  }
}

export function* BUILDER_ADD({ payload, isCometChatAgent, agentId, navigateCallback }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(builderAdd, payload, activeApp)

  if (success && success.data) {
    localStorage.removeItem('ccPreviewBuilderId')
    localStorage.setItem('ccIsNewBuilder', 'true')
    const baseUrl = window.location.origin
    if (isCometChatAgent && agentId && navigateCallback) {
      // Use history.push (via callback) for same-tab SPA navigation to preserve Redux state.
      // window.open or window.location.href would wipe the store, causing infinite loading.
      navigateCallback(
        `/app/${activeApp.id}/ai-agents/${agentId}/deploy/${success.data?.builderId}`,
      )
    } else {
      window.open(`${baseUrl}/app/${activeApp.id}/builder/${success.data?.builderId}`, '_blank')
    }
    if (isCometChatAgent) {
      const payloadTemp = {
        metadata: {
          ...activeApp.metadata,
          ccAgentBuilderId: success.data?.builderId,
        },
      }
      yield put({
        type: 'apps/EDIT',
        payload: payloadTemp,
        id: activeApp.id,
      })
    }
    yield put({
      type: 'apps/BUILDER_LIST',
      payload: { currentPage: 1, data: activeApp },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

export function* BUILDER_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areBuildersLoading: true,
    },
  })

  if (!payload.data) {
    payload.data = reduxStore.getState().apps.active
  }

  const success = yield call(builderList, payload.data)
  const firstLowCodeBuilder = _.find(success.data, { type: 'low-code' })

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        builderList: success.data,
        buildersActive: firstLowCodeBuilder || success.data[0],
        loading: false,
        areBuildersLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        builderList: [],
        loading: false,
        areBuildersLoading: false,
      },
    })
  }
}

export function* AGENT_BUILDER_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areBuildersLoading: true,
    },
  })

  if (!payload.data) {
    payload.data = reduxStore.getState().apps.active
  }
  const success = yield call(builderList, payload.data, 'agent')

  if (success && success.data) {
    const builders = success?.data || []
    const ccAgentBuilderId = payload?.data?.metadata?.ccAgentBuilderId

    const currentAgentBuilder = payload?.isCometChatAgent
      ? builders.find(b => b.builderId === ccAgentBuilderId) || null
      : builders.find(b => b.builderId !== ccAgentBuilderId) || null

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        agentBuilderList: success.data,
        agentBuildersActive: currentAgentBuilder,
        loading: false,
        areBuildersLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        agentBuilderList: [],
        agentBuildersActive: null,
        loading: false,
        areBuildersLoading: false,
      },
    })
  }
}

export function* BUILDER_UPDATE({ id, payload, noCodeMessage, setIsDataSaved, callback }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(builderUpdate, id, payload, activeApp)

  if (!success || !success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Plan restriction - Feature not available' },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  } else if (success && success.data) {
    if (typeof callback === 'function') {
      callback(success)
    }

    if (noCodeMessage) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'success',
          message: noCodeMessage,
        },
      })
      setIsDataSaved?.(true)
    }
  }
  return success
}

export function* BUILDER_RESET({ id }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active

  const success = yield call(builderReset, id, activeApp)

  if (success && success.data) {
    yield put({
      type: 'apps/BUILDER_GET',
      payload: { id, data: activeApp },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: {
        type: 'success',
        message: 'UI Kit Builder has been successfully reset to its default settings!',
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
      _.forEach(success.error.details, function fn(value) {
        message.error(value)
      })
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* KNOWLEDGE BASE */
export function* GET_KNOWLEDGE_BASE_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      knowledgeBaseLoading: true,
    },
  })

  if (!payload.data) {
    payload.data = reduxStore.getState().apps.active
  }

  const { appSettings } = reduxStore.getState().apps
  const { knowledgeBasePagination } = reduxStore.getState().apps

  const { paginationType } = payload

  let paginationPayload = ''

  // Handle pagination based on type
  if (paginationType === 'next' && knowledgeBasePagination.next !== undefined) {
    paginationPayload = objectToParams(knowledgeBasePagination.next)
  } else if (paginationType === 'previous' && knowledgeBasePagination.previous !== undefined) {
    paginationPayload = objectToParams(knowledgeBasePagination.previous)
  }

  const success = yield call(
    knowledgeBaseList,
    payload.data,
    appSettings,
    payload.agentUid,
    paginationPayload,
  )

  if (success && success.data) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseList: success.data,
        knowledgeBaseTotal: success.meta?.current?.count || success.data.length,
        knowledgeBasePagination: success.meta || {},
        knowledgeBaseLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseList: [],
        knowledgeBaseTotal: 0,
        knowledgeBasePagination: {},
        knowledgeBaseLoading: false,
      },
    })
  }
}

export function* SYNC_DISCOVERED_URLS({ payload }) {
  const { parentUniqueId, uniqueIds } = payload
  const app = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(
      knowledgeBaseSyncDiscoveredUrls,
      app,
      appSettings,
      parentUniqueId,
      uniqueIds,
    )

    if (success) {
      message.success('Sync initiated successfully')
    }

    return success.data
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      message.error(error.response.data.error.message)
    } else {
      message.error('Failed to initiate sync')
    }
    return { success: false, error }
  }
}

export function* SYNC_KNOWLEDGE_BASE_ITEM({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }

    const { appSettings } = reduxStore.getState().apps

    yield call(knowledgeBaseSync, payload.data, appSettings, payload.sourceType, payload.uniqueId)

    message.success('Source sync initiated successfully')

    // Refresh list
    yield call(GET_KNOWLEDGE_BASE_LIST, {
      payload: {
        agentUid: payload.agentUid,
        data: payload.data,
      },
    })
  } catch (error) {
    console.error(error)
    message.error('Failed to sync source')
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
  }
}

export function* DELETE_KNOWLEDGE_BASE_ITEM({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }

    const { appSettings } = reduxStore.getState().apps

    const response = yield call(
      knowledgeBaseDeleteFile,
      payload.data,
      appSettings,
      payload.uploadId,
      payload.fileType,
    )

    message.success('Source deleted successfully')

    // Refresh list
    yield call(GET_KNOWLEDGE_BASE_LIST, {
      payload: {
        agentUid: payload.agentUid,
        data: payload.data,
      },
    })
    return response
  } catch (error) {
    console.error(error)
    message.error('Failed to delete source')
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
  }
}
export function* GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    // Get active app if not provided
    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }
    const { appSettings } = reduxStore.getState().apps

    // Prepare files array for upload initiation
    const files = payload.files || []
    const initiatePayload = {
      files: files.map(file => ({
        fileName: file.fileName,
        mimeType: file.mimeType,
        fileSize: file.fileSize,
      })),
    }

    // Call initiateUpload service
    const response = yield call(
      knowledgeBaseInitiateUpload,
      payload.data,
      appSettings,
      initiatePayload,
    )

    if (response && payload.agentUid) {
      yield call(GET_KNOWLEDGE_BASE_LIST, {
        payload: {
          agentUid: payload.agentUid,
          data: payload.data,
        },
      })
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return response
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return { success: false, error }
  }
}

export function* GET_KNOWLEDGE_BASE_DETAILS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseDetailsLoading: true,
      },
    })

    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }

    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      knowledgeBaseGetDetails,
      payload.data,
      appSettings,
      payload.sourceType,
      payload.uniqueId,
      payload.page || 1,
      payload.limit || 10,
      payload.affix || null,
    )

    if (success && success.data) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          knowledgeBaseDetails: success.data,
          knowledgeBaseDetailsPagination: success.meta || {},
          knowledgeBaseDetailsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          knowledgeBaseDetails: null,
          knowledgeBaseDetailsPagination: {},
          knowledgeBaseDetailsLoading: false,
        },
      })
    }
  } catch (error) {
    console.error(error)
    message.error('Failed to load knowledge base details')
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseDetails: null,
        knowledgeBaseDetailsPagination: {},
        knowledgeBaseDetailsLoading: false,
      },
    })
  }
}

export function* KNOWLEDGE_BASE_CREATE_TEXT_ITEM({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    // Get active app if not provided
    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }
    const { appSettings } = reduxStore.getState().apps

    // Prepare payload for text item creation
    const createPayload = {
      title: payload.title,
      text: payload.text,
    }

    // Call createTextItem service
    const response = yield call(
      knowledgeBaseCreateTextItem,
      payload.data,
      appSettings,
      createPayload,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return response
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return { success: false, error }
  }
}

export function* KNOWLEDGE_BASE_UPDATE_TEXT_ITEM({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    // Get active app if not provided
    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }
    const { appSettings } = reduxStore.getState().apps

    // Prepare payload for text item update
    const updatePayload = {
      title: payload.title,
      text: payload.text,
    }

    // Call updateTextItem service
    const response = yield call(
      knowledgeBaseUpdateTextItem,
      payload.data,
      appSettings,
      payload.uniqueId,
      updatePayload,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return response
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return { success: false, error }
  }
}

export function* KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    // Get active app if not provided
    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }
    const { appSettings } = reduxStore.getState().apps

    // Prepare payload for individual link creation
    const createPayload = {
      url: payload.url,
    }

    // Call createIndividualLink service
    const response = yield call(
      knowledgeBaseCreateIndividualLink,
      payload.data,
      appSettings,
      createPayload,
    )

    if (response && response.data) {
      // Update activeBuilderAgent with the new link
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })

    return response.data
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return { success: false, error }
  }
}

export function* KNOWLEDGE_BASE_GET_ITEM({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: true,
      },
    })

    // Get active app if not provided
    if (!payload.data) {
      payload.data = reduxStore.getState().apps.active
    }
    const { appSettings } = reduxStore.getState().apps

    // Call getItem service
    const response = yield call(
      knowledgeBaseGetItem,
      payload.data,
      appSettings,
      payload.uniqueId,
      payload.fileType,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return response
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        knowledgeBaseLoading: false,
      },
    })
    return { success: false, error }
  }
}

export function* ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      knowledgeBaseLoading: true,
    },
  })
  const { data, appSettings, agentUid, source, uniqueIds, onError } = payload

  try {
    const success = yield call(
      knowledgeBaseAddSourceToAgent,
      data,
      appSettings,
      agentUid,
      source,
      uniqueIds,
    )

    if (success) {
      message.success('Source added to agent successfully')
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: success?.data,
        },
      })
      // stop loader on success
      yield put({
        type: 'apps/SET_STATE',
        payload: { knowledgeBaseLoading: false },
      })
    }
  } catch (error) {
    if (onError) onError()
    if (error.response && error.response.data && error.response.data.error) {
      message.error(error.response.data.error.message)
    } else {
      message.error('Failed to add source to agent')
    }
    // stop loader on error
    yield put({
      type: 'apps/SET_STATE',
      payload: { knowledgeBaseLoading: false },
    })
  }
}

export function* REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      knowledgeBaseLoading: true,
    },
  })
  const { data, appSettings, agentUid, source, uniqueIds, onError } = payload

  try {
    const success = yield call(
      knowledgeBaseRemoveSourceFromAgent,
      data,
      appSettings,
      agentUid,
      source,
      uniqueIds,
    )

    if (success) {
      message.success('Source removed from agent successfully')
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: success?.data,
        },
      })
      // stop loader on success
      yield put({
        type: 'apps/SET_STATE',
        payload: { knowledgeBaseLoading: false },
      })
    }
  } catch (error) {
    if (onError) onError()
    if (error.response && error.response.data && error.response.data.error) {
      message.error(error.response.data.error.message)
    } else {
      message.error('Failed to remove source from agent')
    }
    // stop loader on error
    yield put({
      type: 'apps/SET_STATE',
      payload: { knowledgeBaseLoading: false },
    })
  }
}

export function* NOTIFICATION_LOGS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        isNotificationLogsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    const appsState = reduxStore.getState().apps
    const {
      appSettings,
      notificationLogsPagination: logsPagination,
      notificationLogsFilters: storedFilters = {},
    } = appsState

    // For pagination requests (next/previous), use stored filters
    // For filter apply/reset requests, use the provided filters
    const shouldUseStoredFilters =
      (payload.paginationType && !payload.filters) || payload.filters === undefined
    const filters = shouldUseStoredFilters ? storedFilters : payload.filters

    const { paginationType, pageNo } = payload
    let paginationPayload = ''
    if (paginationType === 'next' && logsPagination && logsPagination.next !== undefined) {
      paginationPayload = objectToParams(logsPagination.next)
    } else if (
      paginationType === 'previous' &&
      logsPagination &&
      logsPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(logsPagination.previous)
    }

    const success = yield call(
      getNotificationLogs,
      payload.data,
      getAppHost(appSettings),
      paginationPayload,
      filters,
    )

    if (success && success.data) {
      let totalLogCount = success.data.length
      let notificationLogsPagination = {}

      if (success.meta) {
        notificationLogsPagination = success.meta

        // Safely get limit with fallback to 10
        const limit = success.meta.current?.limit || 10

        // Check if there are more pages by checking if meta.next is a non-empty array or object
        // Handles: [], null, undefined, empty object {}, or populated array/object
        const hasNextPage =
          success.meta.next &&
          ((Array.isArray(success.meta.next) && success.meta.next.length > 0) ||
            (typeof success.meta.next === 'object' &&
              !Array.isArray(success.meta.next) &&
              Object.keys(success.meta.next).length > 0))

        // Calculate total count based on whether there are more pages
        // Use pageNo > 1 to distinguish between initial load (page 1) and subsequent pages
        if (pageNo !== undefined && pageNo > 1) {
          // We're on page 2 or higher (from navigation)
          if (hasNextPage) {
            // There are more pages after this one
            totalLogCount = pageNo * limit + 1
          } else {
            // This is the last page - calculate exact total
            totalLogCount = (pageNo - 1) * limit + success.data.length
          }
        } else if (hasNextPage) {
          // Initial load (page 1 or undefined) with more pages available
          totalLogCount = limit + 1
        } else {
          // Initial load (page 1 or undefined) with no more pages - use actual data length
          // This handles both empty results (0) and single page results
          totalLogCount = success.data.length
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          notificationLogs: success.data,
          notificationLogsTotal: totalLogCount,
          notificationLogsPagination,
          notificationLogsFilters: filters,
          loading: false,
          isNotificationLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          notificationLogs: [],
          notificationLogsTotal: 0,
          notificationLogsPagination: {},
          loading: false,
          isNotificationLogsLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        notificationLogs: [],
        notificationLogsTotal: 0,
        notificationLogsPagination: {},
        loading: false,
        isNotificationLogsLoading: false,
      },
    })
  }
}

export function UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR(action) {
  const STORAGE_KEY = 'cc_getStartedScreenBehaviour'
  const defaultBehaviour = {
    moderation: false,
    chat: false,
    calling: false,
  }

  const { feature, value } = action.payload

  // Read current behavior from localStorage or use default
  const stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || defaultBehaviour

  // Update the relevant feature flag
  const updated = {
    ...stored,
    [feature]: value,
  }

  // Save the updated object back to localStorage
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
}

/* AI AGENTS */

export function* AI_AGENTS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        areAiAgentsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().apps.aiAgentSearchText
    const { aiAgentsListPagination } = reduxStore.getState().apps

    let pageNo = payload.currentPage
    if (pageNo === undefined && aiAgentsListPagination.current_page !== undefined)
      pageNo = aiAgentsListPagination.current_page + 1

    const success = yield call(aiAgentsList, payload.data, payload.appSettings, pageNo, searchText)

    if (success && Array.isArray(success)) {
      const totalAiAgentsCount = success.length
      const aiAgentsListPaginationData = []

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          aiAgentsList: success,
          aiAgentsListTotal: totalAiAgentsCount,
          aiAgentsListPagination: aiAgentsListPaginationData,
          loading: false,
          areAiAgentsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiAgentsList: [],
          aiAgentsListTotal: 0,
          aiAgentsListPagination: [],
          loading: false,
          areAiAgentsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentsList: [],
        aiAgentsListTotal: 0,
        aiAgentsListPagination: [],
        loading: false,
        areAiAgentsLoading: false,
      },
    })
  }
}

export function* DELETE_AI_AGENT({ payload }) {
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  // Add agent ID to deleting list
  const currentState = reduxStore.getState().apps
  const updatedDeletingIds = [...(currentState.deletingAgentIds || []), payload.agentId]

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      deletingAgentIds: updatedDeletingIds,
    },
  })

  try {
    yield call(aiAgentRemove, payload.data, payload.appSettings, payload.agentId)

    // Remove the agent from the current list and from deleting list
    const updatedState = reduxStore.getState().apps
    const updatedAgentsList = updatedState.aiAgentsList.filter(
      agent => agent.uid !== payload.agentId,
    )
    const updatedTotal = updatedState.aiAgentsListTotal - 1
    const updatedDeletingIdsAfterRemoval = updatedState.deletingAgentIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentsList: updatedAgentsList,
        aiAgentsListTotal: updatedTotal,
        deletingAgentIds: updatedDeletingIdsAfterRemoval,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Agent deleted successfully' },
    })
  } catch (error) {
    // Remove agent ID from deleting list on error
    const errorState = reduxStore.getState().apps
    const updatedDeletingIdsOnError = errorState.deletingAgentIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        deletingAgentIds: updatedDeletingIdsOnError,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to delete AI Agent' },
    })
  }
}

export function* EDIT_AI_AGENT({ payload }) {
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  if (payload.isActive === undefined) payload.isActive = true

  const isActivePayload = {
    isActive: payload.isActive,
  }

  // Add agent ID to updating list
  const currentState = reduxStore.getState().apps
  const updatedUpdatingIds = [...(currentState.updatingAgentIds || []), payload.agentId]

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      updatingAgentIds: updatedUpdatingIds,
    },
  })

  try {
    yield call(aiAgentUpdate, payload.data, payload.appSettings, payload.agentId, isActivePayload)

    // Update the specific agent in the current list and remove from updating list
    const updatedState = reduxStore.getState().apps
    const updatedAgentsList = updatedState.aiAgentsList.map(agent =>
      agent.uid === payload.agentId ? { ...agent, ...payload } : agent,
    )
    const updatedUpdatingIdsAfterUpdate = updatedState.updatingAgentIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentsList: updatedAgentsList,
        updatingAgentIds: updatedUpdatingIdsAfterUpdate,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Agent status updated successfully' },
    })
  } catch (error) {
    // Remove agent ID from updating list on error
    const errorState = reduxStore.getState().apps
    const updatedUpdatingIdsOnError = errorState.updatingAgentIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        updatingAgentIds: updatedUpdatingIdsOnError,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to update AI Agent' },
    })
  }
}

/* AI TOOLS */

export function* AI_TOOLS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        areAiToolsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().apps.aiToolSearchText
    const { aiToolsListPagination } = reduxStore.getState().apps

    let pageNo = payload.currentPage
    if (pageNo === undefined && aiToolsListPagination.current_page !== undefined)
      pageNo = aiToolsListPagination.current_page + 1

    const success = yield call(
      aiToolsList,
      payload.data,
      payload.appSettings,
      pageNo,
      searchText,
      payload.queryParams,
    )

    if (success && Array.isArray(success)) {
      const totalAiToolsCount = success.length
      const aiToolsListPaginationData = []

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          aiToolsList: success,
          aiToolsListTotal: totalAiToolsCount,
          aiToolsListPagination: aiToolsListPaginationData,
          loading: false,
          areAiToolsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolsList: [],
          aiToolsListTotal: 0,
          aiToolsListPagination: [],
          loading: false,
          areAiToolsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolsList: [],
        aiToolsListTotal: 0,
        aiToolsListPagination: [],
        loading: false,
        areAiToolsLoading: false,
      },
    })
  }
}

export function* AI_ACTIONS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        areAiActionsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().apps.aiActionSearchText
    const { aiActionsListPagination } = reduxStore.getState().apps

    let pageNo = payload.currentPage
    if (pageNo === undefined && aiActionsListPagination.current_page !== undefined)
      pageNo = aiActionsListPagination.current_page + 1

    const success = yield call(
      aiToolsList,
      payload.data,
      payload.appSettings,
      pageNo,
      searchText,
      payload.queryParams,
    )

    if (success && Array.isArray(success)) {
      const totalAiActionsCount = success.length
      const aiActionsListPaginationData = []

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          aiActionsList: success,
          aiActionsListTotal: totalAiActionsCount,
          aiActionsListPagination: aiActionsListPaginationData,
          loading: false,
          areAiActionsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiActionsList: [],
          aiActionsListTotal: 0,
          aiActionsListPagination: [],
          loading: false,
          areAiActionsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiActionsList: [],
        aiActionsListTotal: 0,
        aiActionsListPagination: [],
        loading: false,
        areAiActionsLoading: false,
      },
    })
  }
}

export function* GET_AI_TOOL_EDIT_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiToolEditFormLoading: true,
      aiToolEditForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      aiToolGetEditForm,
      payload.data,
      payload.appSettings,
      payload.toolName,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiToolEditForm: success,
        isAiToolEditFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolEditForm: null,
        isAiToolEditFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_ACTION_EDIT_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiActionEditFormLoading: true,
      aiActionEditForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      `ai-agents/forms/action-edit/${encodeURIComponent(payload.toolName)}`,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiActionEditForm: success,
        isAiActionEditFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiActionEditForm: null,
        isAiActionEditFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_TOOL_CREATE_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiToolCreateFormLoading: true,
      aiToolCreateForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      'ai-agents/forms/tools-creation',
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiToolCreateForm: success,
        isAiToolCreateFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolCreateForm: null,
        isAiToolCreateFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_ACTION_CREATE_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiActionCreateFormLoading: true,
      aiActionCreateForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      'ai-agents/forms/actions-creation',
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiActionCreateForm: success,
        isAiActionCreateFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiActionCreateForm: null,
        isAiActionCreateFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* DELETE_AI_TOOL({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    yield call(aiToolRemove, payload.data, payload.appSettings, payload.toolName)

    // Get current state
    const currentState = reduxStore.getState().apps
    const updatedToolsList = (currentState.aiToolsList || []).filter(
      tool => tool.name !== payload.toolName,
    )
    const updatedTotal = Math.max(0, (currentState.aiToolsListTotal || 0) - 1)

    // Update state directly instead of refetching
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        aiToolsList: updatedToolsList,
        aiToolsListTotal: updatedTotal,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Tool deleted successfully' },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to delete AI Tool' },
    })
  }
}

export function* DELETE_AI_ACTION({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    yield call(aiToolRemove, payload.data, payload.appSettings, payload.toolName)

    // Get current state
    const currentState = reduxStore.getState().apps
    const updatedActionsList = (currentState.aiActionsList || []).filter(
      action => action.name !== payload.toolName,
    )
    const updatedTotal = Math.max(0, (currentState.aiActionsListTotal || 0) - 1)

    // Update state directly instead of refetching
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        aiActionsList: updatedActionsList,
        aiActionsListTotal: updatedTotal,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Action deleted successfully' },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to delete AI Action' },
    })
  }
}

/* AI_AGENT_USERS */
export function* AI_AGENT_USER_LIST({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
      areAIAgentUsersLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const searchText = reduxStore.getState().apps.aiAgentUserSearchText
  const usersPagination = reduxStore.getState().apps.aiAgentUserListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && usersPagination.current_page !== undefined)
    pageNo = usersPagination.current_page + 1
  pageNo = 1
  const success = yield call(
    usersAIAgentList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    searchText,
  )

  if (success && success.data) {
    let totalUserCount = success.data.length
    let aiAgentUserListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      aiAgentUserListPagination = success.meta.pagination
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiAgentUserList: success.data,
        aiAgentUserListTotal: totalUserCount,
        aiAgentUserListPagination,
        loading: false,
        areAIAgentUsersLoading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentUserList: [],
        aiAgentUserListTotal: 0,
        aiAgentUserListPagination: [],
        loading: false,
        areAIAgentUsersLoading: false,
      },
    })
  }
}

export function* GET_AI_AGENT_CREATE_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiAgentCreateFormLoading: true,
      aiAgentCreateForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      'ai-agents/forms/agent-creation',
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiAgentCreateForm: success,
        isAiAgentCreateFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentCreateForm: null,
        isAiAgentCreateFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_AGENT_EDIT_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiAgentEditFormLoading: true,
      aiAgentEditForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      `ai-agents/forms/agent-edit/${encodeURIComponent(payload.agentId)}`,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiAgentEditForm: success,
        isAiAgentEditFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentEditForm: null,
        isAiAgentEditFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_AGENT_INTEGRATIONS({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiAgentIntegrationsLoading: true,
      aiAgentIntegrations: [],
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      'ai-agents/integrations',
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiAgentIntegrations: success || [],
        isAiAgentIntegrationsLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentIntegrations: [],
        isAiAgentIntegrationsLoading: false,
        loading: false,
      },
    })
  }
}

/* AI AGENTS BUILDER */

export function* GET_AI_AGENT_BUILDER({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        isActiveBuilderAgentLoading: true,
        activeBuilderAgent: null,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      aiAgentBuilderGet,
      payload.data,
      payload.appSettings,
      payload.agentId,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: success,
          isActiveBuilderAgentLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: null,
          isActiveBuilderAgentLoading: false,
        },
      })
    }
  } catch (error) {
    console.error('GET_AI_AGENT_BUILDER error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        activeBuilderAgent: null,
        isActiveBuilderAgentLoading: false,
      },
    })
  }
}

export function* ADD_AI_AGENT_BUILDER({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        isAiAgentBuilderCreateFormLoading: true,
      },
    })

    const activeFromStore = reduxStore.getState().apps.active
    const appForCall = payload.data ? payload.data : activeFromStore
    const appSettingsForCall = payload.appSettings
      ? payload.appSettings
      : reduxStore.getState().apps.appSettings

    const success = yield call(aiAgentBuilderAdd, appForCall, appSettingsForCall, payload.values)

    if (success) {
      // Refresh the agents builder list
      yield put({
        type: 'apps/AI_AGENTS_BUILDER_LIST',
        payload: { currentPage: 1, data: appForCall, appSettings: appSettingsForCall },
      })

      // The created agent is in success.agent
      const createdAgent = success.agent

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          isAiAgentBuilderCreateFormLoading: false,
          aiAgentBuilderCreateForm: null,
          lastCreatedAgentId: createdAgent && createdAgent.uid ? createdAgent.uid : null, // Store the newly created agent ID
        },
      })

      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'AI Agent Builder created successfully' },
      })

      // Navigate to agent configuration page if needed
      if (payload.redirect !== false && success.agent && appForCall?.id) {
        yield put(push(`/app/${appForCall.id}/ai-agents/${success.agent.uid}/instructions`))
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
          isAiAgentBuilderCreateFormLoading: false,
        },
      })

      if (success && success.error) {
        if (success.error.code === 'ERR_BAD_REQUEST') {
          const errorMessage = success.error.details
            ? success.error.details.join(', ')
            : 'Failed to create AI Agent Builder'
          yield put({
            type: 'apps/INITIATE_NOTIFICATION',
            payload: { type: 'error', message: errorMessage },
          })
        } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
          yield put({
            type: 'apps/INITIATE_NOTIFICATION',
            payload: { type: 'error', message: 'Plan restriction - Feature not available' },
          })
        } else {
          yield put({
            type: 'apps/INITIATE_NOTIFICATION',
            payload: { type: 'error', message: 'Failed to create AI Agent Builder' },
          })
        }
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Failed to create AI Agent Builder' },
        })
      }
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        isAiAgentBuilderCreateFormLoading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to create AI Agent Builder' },
    })
  }
}

export function* AI_AGENTS_BUILDER_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        areAiAgentsBuildersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const agentsPagination = reduxStore.getState().apps.aiAgentsBuilderListPagination

    const { paginationType, pageNo } = payload
    let paginationPayload = ''

    // If pageNo is explicitly set to 1, start fresh (ignore existing pagination)
    if (pageNo === 1) {
      paginationPayload = ''
    } else if (
      paginationType === 'next' &&
      agentsPagination &&
      agentsPagination.next !== undefined
    ) {
      paginationPayload = objectToParams(agentsPagination.next)
    } else if (
      paginationType === 'previous' &&
      agentsPagination &&
      agentsPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(agentsPagination.previous)
    }

    const success = yield call(
      aiAgentsBuilderList,
      payload.data,
      payload.appSettings,
      paginationPayload,
      payload.searchQuery || '',
    )

    if (success && success.data) {
      let totalAgentsCount = success.data.length
      let aiAgentsBuilderListPagination = {}

      if (success.meta) {
        aiAgentsBuilderListPagination = success.meta
        totalAgentsCount = success.meta.current.limit + 1

        if (pageNo !== undefined && paginationType === undefined) {
          totalAgentsCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta?.next?.affix !== undefined
        ) {
          totalAgentsCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta?.previous?.affix !== undefined
        ) {
          totalAgentsCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalAgentsCount = pageNo * success.meta.current.limit
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          aiAgentsBuilderList: success.data,
          aiAgentsBuilderListTotal: totalAgentsCount,
          aiAgentsBuilderListPagination,
          loading: false,
          areAiAgentsBuildersLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiAgentsBuilderList: [],
          aiAgentsBuilderListTotal: 0,
          aiAgentsBuilderListPagination: {},
          loading: false,
          areAiAgentsBuildersLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentsBuilderList: [],
        aiAgentsBuilderListTotal: 0,
        aiAgentsBuilderListPagination: {},
        loading: false,
        areAiAgentsBuildersLoading: false,
      },
    })
  }
}

export function* DELETE_AI_AGENT_BUILDER({ payload }) {
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  // Add agent ID to deleting list
  const currentState = reduxStore.getState().apps
  const updatedDeletingIds = [...(currentState.deletingAgentBuilderIds || []), payload.agentId]

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      deletingAgentBuilderIds: updatedDeletingIds,
    },
  })

  try {
    yield call(aiAgentBuilderRemove, payload.data, payload.appSettings, payload.agentId)

    // Remove from deleting list after successful deletion
    const updatedState = reduxStore.getState().apps
    const updatedDeletingIdsAfterRemoval = updatedState.deletingAgentBuilderIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        deletingAgentBuilderIds: updatedDeletingIdsAfterRemoval,
      },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Agent deleted successfully' },
    })

    // Call the onSuccess callback if provided (component will handle refetch)
    if (payload.onSuccess && typeof payload.onSuccess === 'function') {
      payload.onSuccess()
    }
  } catch (error) {
    // Remove agent ID from deleting list on error
    const errorState = reduxStore.getState().apps
    const updatedDeletingIdsOnError = errorState.deletingAgentBuilderIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        deletingAgentBuilderIds: updatedDeletingIdsOnError,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to delete AI Agent' },
    })
  }
}

export function* EDIT_AI_AGENT_BUILDER({ payload }) {
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  // Add agent ID to updating list
  const currentState = reduxStore.getState().apps
  const updatedUpdatingIds = [...(currentState.updatingAgentBuilderIds || []), payload.agentId]

  yield put({
    type: 'apps/SET_STATE',
    payload: {
      updatingAgentBuilderIds: updatedUpdatingIds,
    },
  })

  try {
    yield call(
      aiAgentBuilderUpdate,
      payload.data,
      payload.appSettings,
      payload.agentId,
      payload.agentData,
    )

    // Update the specific agent in the current list and remove from updating list
    const updatedState = reduxStore.getState().apps
    const updatedAgentsList = updatedState.aiAgentsBuilderList.map(agent =>
      agent.uid === payload.agentId ? { ...agent, ...payload.agentData } : agent,
    )
    const updatedUpdatingIdsAfterUpdate = updatedState.updatingAgentBuilderIds.filter(
      id => id !== payload.agentId,
    )

    // Update activeBuilderAgent if it matches the updated agent
    // NOTE: This is the source of truth update for activeBuilderAgent after Save & Run
    const currentActiveAgent = updatedState.activeBuilderAgent
    let updatedActiveAgent = currentActiveAgent
    if (currentActiveAgent && currentActiveAgent.uid === payload.agentId) {
      updatedActiveAgent = {
        ...currentActiveAgent,
        ...payload.agentData,
      }
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentsBuilderList: updatedAgentsList,
        updatingAgentBuilderIds: updatedUpdatingIdsAfterUpdate,
        activeBuilderAgent: updatedActiveAgent, // Update activeBuilderAgent with saved changes
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Agent updated successfully' },
    })
  } catch (error) {
    // Remove agent ID from updating list on error and revert any optimistic changes
    const errorState = reduxStore.getState().apps
    const updatedUpdatingIdsOnError = errorState.updatingAgentBuilderIds.filter(
      id => id !== payload.agentId,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        updatingAgentBuilderIds: updatedUpdatingIdsOnError,
        // Optionally revert the agents list, but it's better to refetch
        // aiAgentsBuilderList: revertedAgentsList,
      },
    })

    // Refetch the agents list to ensure we have the correct state
    yield put({
      type: 'apps/AI_AGENTS_BUILDER_LIST',
      payload: {
        data: payload.data,
        appSettings: payload.appSettings,
      },
    })

    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to update AI Agent' },
    })
  }
}

/* AI TOOLS BUILDER */

export function* AI_TOOLS_BUILDER_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        areAiToolsBuildersLoading: true,
      },
    })

    // Get app data from Redux if not provided
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    // Get active builder agent
    const { activeBuilderAgent } = reduxStore.getState().apps
    const agentUid = payload.agentUid || activeBuilderAgent?.uid

    if (!agentUid) {
      console.error('No agent UID provided and no active builder agent found')
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolsBuilderList: [],
          aiToolsBuilderListTotal: 0,
          aiToolsBuilderListPagination: {},
          loading: false,
          areAiToolsBuildersLoading: false,
        },
      })
      return
    }

    const { aiToolsBuilderListPagination } = reduxStore.getState().apps

    const { paginationType } = payload
    let paginationPayload = ''
    if (
      paginationType === 'next' &&
      aiToolsBuilderListPagination &&
      aiToolsBuilderListPagination.next !== undefined
    ) {
      paginationPayload = objectToParams(aiToolsBuilderListPagination.next)
    } else if (
      paginationType === 'previous' &&
      aiToolsBuilderListPagination &&
      aiToolsBuilderListPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(aiToolsBuilderListPagination.previous)
    }

    const success = yield call(
      aiToolsBuilderList,
      payload.data,
      payload.appSettings,
      payload.pageNo || 1,
      payload.searchText || '',
      paginationPayload,
      agentUid,
    )

    if (success && success.data) {
      let totalCount = success.data.length
      let newPaginationMeta = {}

      if (success.meta) {
        newPaginationMeta = success.meta

        if (success?.meta?.next && success?.meta?.next?.affix !== undefined) {
          // Has next page - calculate total to allow navigation
          // For Ant Design Pagination: current page * pageSize + 1 (to show next page exists)
          const currentPage = payload.pageNo || 1
          const pageSize = success?.meta?.current?.limit || 10
          totalCount = currentPage * pageSize + 1
        } else if (success?.meta?.previous && success?.meta?.previous?.affix !== undefined) {
          // No next page but has previous - we're on the last page
          // Calculate total based on current page and actual data
          const currentPage = payload.pageNo || 1
          const pageSize = success?.meta?.current?.limit || 10
          totalCount = (currentPage - 1) * pageSize + success.data.length
        } else {
          // We're on the first page with no next - total is just current data
          totalCount = success.data.length
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          aiToolsBuilderList: success.data,
          aiToolsBuilderListTotal: totalCount,
          aiToolsBuilderListPagination: newPaginationMeta,
          loading: false,
          areAiToolsBuildersLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolsBuilderList: [],
          aiToolsBuilderListTotal: 0,
          aiToolsBuilderListPagination: {},
          loading: false,
          areAiToolsBuildersLoading: false,
        },
      })
    }
  } catch (error) {
    console.error('AI_TOOLS_BUILDER_LIST error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolsBuilderList: [],
        aiToolsBuilderListTotal: 0,
        aiToolsBuilderListPagination: {},
        loading: false,
        areAiToolsBuildersLoading: false,
      },
    })
  }
}

export function* GET_AI_TOOL_BUILDER_EDIT_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiToolBuilderEditFormLoading: true,
      aiToolBuilderEditForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      aiToolBuilderGetEditForm,
      payload.data,
      payload.appSettings,
      payload.toolName,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiToolBuilderEditForm: success,
        isAiToolBuilderEditFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolBuilderEditForm: null,
        isAiToolBuilderEditFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_TOOL_ACTIONS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolActionsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const { aiToolActionsPagination } = reduxStore.getState().apps

    const { paginationType } = payload
    let paginationPayload = ''
    if (
      paginationType === 'next' &&
      aiToolActionsPagination &&
      aiToolActionsPagination.next !== undefined
    ) {
      paginationPayload = objectToParams(aiToolActionsPagination.next)
    } else if (
      paginationType === 'previous' &&
      aiToolActionsPagination &&
      aiToolActionsPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(aiToolActionsPagination.previous)
    }

    const success = yield call(
      aiToolsBuilderGetActions,
      payload.data,
      payload.appSettings,
      payload.toolName,
      payload.agentId,
      paginationPayload,
    )

    if (success && success.actions) {
      let totalCount = success.actions ? Object.keys(success.actions).length : 0
      let newPaginationMeta = {}

      if (success.meta) {
        newPaginationMeta = success.meta

        if (success.meta.next && success.meta.next.affix !== undefined) {
          // Has next page - show next button by setting total > current items
          totalCount = success.meta.current.limit + 1
        } else if (success.meta.previous && success.meta.previous.affix !== undefined) {
          // No next page but has previous - we're on a middle/last page
          // Ensure total allows previous navigation
          totalCount = success.meta.current.limit + totalCount
        } else {
          // We're on the first page with no next - total is just current data
          // totalCount is already set correctly above
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolActionsList: success.actions,
          aiToolActionsTotal: totalCount,
          aiToolActionsPagination: newPaginationMeta,
          currentAiToolActions: success,
          aiToolActionsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolActionsList: [],
          aiToolActionsTotal: 0,
          aiToolActionsPagination: {},
          currentAiToolActions: null,
          aiToolActionsLoading: false,
        },
      })
    }
  } catch (error) {
    console.error('GET_AI_TOOL_ACTIONS error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolActionsList: [],
        aiToolActionsTotal: 0,
        aiToolActionsPagination: {},
        currentAiToolActions: null,
        aiToolActionsLoading: false,
      },
    })
  }
}

export function* CREATE_CUSTOM_API_TOOL({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolCreating: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      aiToolsBuilderCreateCustomApiTool,
      payload.data,
      payload.appSettings,
      payload.customApiToolData,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          customApiToolCreating: false,
        },
      })

      // Refresh the custom API tools list after creation
      yield put({
        type: 'apps/GET_CUSTOM_API_TOOLS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
        },
      })

      message.success('Custom API Tool created successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('CREATE_CUSTOM_API_TOOL error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolCreating: false,
      },
    })
    message.error('Failed to create Custom API Tool')
  }
}

export function* UPDATE_CUSTOM_API_TOOL({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolUpdating: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      aiToolsBuilderUpdateCustomApiTool,
      payload.data,
      payload.appSettings,
      payload.customApiToolData,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          customApiToolUpdating: false,
        },
      })

      // Refresh the custom API tools list after update
      yield put({
        type: 'apps/GET_CUSTOM_API_TOOLS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
        },
      })

      message.success('Custom API Tool updated successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('UPDATE_CUSTOM_API_TOOL error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolUpdating: false,
      },
    })
    message.error('Failed to update Custom API Tool')
  }
}

export function* DELETE_CUSTOM_API_TOOL({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolDeleting: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      aiToolsBuilderDeleteCustomApiTool,
      payload.data,
      payload.appSettings,
      payload.slug,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          customApiToolDeleting: false,
        },
      })

      yield put({
        type: 'apps/GET_CUSTOM_API_TOOLS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
        },
      })
      message.success('Custom API Tool deleted successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('DELETE_CUSTOM_API_TOOL error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolDeleting: false,
      },
    })
    message.error('Failed to delete Custom API Tool')
  }
}

export function* ADD_API_TOOL_TO_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      aiToolsBuilderAddApiTool,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { apiTools: [payload.apiToolSlug] },
    )

    if (success) {
      // Update activeBuilderAgent in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedApiTools = [...(currentAgent.apiTools || []), payload.apiToolSlug]

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            apiTools: updatedApiTools,
          },
        },
      })

      message.success('API Tool added to agent successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('ADD_API_TOOL_TO_AGENT error:', error)
    message.error('Failed to add API Tool to agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* REMOVE_API_TOOL_FROM_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      aiToolsBuilderRemoveApiTool,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { apiTools: [payload.apiToolSlug] },
    )

    if (success) {
      // Update activeBuilderAgent in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedApiTools = (currentAgent.apiTools || []).filter(
        apiTool => apiTool !== payload.apiToolSlug,
      )

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            apiTools: updatedApiTools,
          },
        },
      })

      message.success('API Tool removed from agent successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('REMOVE_API_TOOL_FROM_AGENT error:', error)
    message.error('Failed to remove API Tool from agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* ADD_TOOL_TO_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      aiToolsBuilderAdd,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { tools: [payload.toolSlug] },
    )

    if (success) {
      // Update activeBuilderAgent in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedTools = [...(currentAgent.tools || []), payload.toolSlug]

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            tools: updatedTools,
          },
        },
      })

      message.success('Tool added to agent successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('ADD_TOOL_TO_AGENT error:', error)
    const apiError = error?.error || error?.response?.data?.error || {}
    if (apiError.code === 'ERR_TOOL_AUTH_MISSING') {
      message.loading('Tool Authentication Initiated')
    } else {
      message.error('Failed to add tool to agent')
    }

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* REMOVE_TOOL_FROM_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      aiToolBuilderRemove,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { tools: [payload.toolSlug] },
    )

    if (success) {
      // Update activeBuilderAgent in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedTools = (currentAgent.tools || []).filter(tool => tool !== payload.toolSlug)

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            tools: updatedTools,
          },
        },
      })

      message.success('Tool removed from agent successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('REMOVE_TOOL_FROM_AGENT error:', error)
    message.error('Failed to remove tool from agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* SYSTEM_TOOLS_LIST({ payload = {} }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        areSystemToolsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(aiSystemToolsList, payload.data, payload.appSettings)

    // Catalog may be returned as a bare array or wrapped in { data: [...] }
    const catalog = Array.isArray(success) ? success : success?.data || []

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        systemToolsList: catalog,
        areSystemToolsLoading: false,
      },
    })
  } catch (error) {
    console.error('SYSTEM_TOOLS_LIST error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        systemToolsList: [],
        areSystemToolsLoading: false,
      },
    })
  }
}

export function* ADD_SYSTEM_TOOL_TO_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      aiSystemToolsAdd,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { systemTools: [payload.toolSlug] },
    )

    if (success) {
      // Update activeBuilderAgent.systemTools in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const existing = currentAgent.systemTools || []
      const updatedSystemTools = existing.includes(payload.toolSlug)
        ? existing
        : [...existing, payload.toolSlug]

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            systemTools: updatedSystemTools,
          },
        },
      })

      message.success(`${payload.toolName || 'Tool'} added to agent successfully!`)

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('ADD_SYSTEM_TOOL_TO_AGENT error:', error)
    message.error('Failed to add tool to agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* REMOVE_SYSTEM_TOOL_FROM_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      aiSystemToolsRemove,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { systemTools: [payload.toolSlug] },
    )

    if (success) {
      // Update activeBuilderAgent.systemTools in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedSystemTools = (currentAgent.systemTools || []).filter(
        slug => slug !== payload.toolSlug,
      )

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            systemTools: updatedSystemTools,
          },
        },
      })

      message.success(`${payload.toolName || 'Tool'} removed from agent successfully!`)

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('REMOVE_SYSTEM_TOOL_FROM_AGENT error:', error)
    message.error('Failed to remove tool from agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* GET_CUSTOM_API_TOOLS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const { customApiToolsPagination } = reduxStore.getState().apps

    const { paginationType, pageNo } = payload
    let paginationPayload = ''
    if (
      paginationType === 'next' &&
      customApiToolsPagination &&
      customApiToolsPagination.next !== undefined
    ) {
      paginationPayload = objectToParams(customApiToolsPagination.next)
    } else if (
      paginationType === 'previous' &&
      customApiToolsPagination &&
      customApiToolsPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(customApiToolsPagination.previous)
    }

    const success = yield call(
      aiToolsBuilderListCustomApiTools,
      payload.data,
      payload.appSettings,
      pageNo,
      payload.searchText || '',
      paginationPayload,
    )

    if (success && success.data) {
      let totalCount = success.data.length
      let newPaginationMeta = {}

      if (success.meta) {
        newPaginationMeta = success.meta
        totalCount = success.meta.current.limit + 1

        if (pageNo !== undefined && paginationType === undefined) {
          totalCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta?.next?.affix !== undefined
        ) {
          totalCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta?.previous?.affix !== undefined
        ) {
          totalCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalCount = pageNo * success.meta.current.limit
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          customApiToolsList: success.data,
          customApiToolsTotal: totalCount,
          customApiToolsPagination: newPaginationMeta,
          customApiToolsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          customApiToolsList: [],
          customApiToolsTotal: 0,
          customApiToolsPagination: {},
          customApiToolsLoading: false,
        },
      })
    }
  } catch (error) {
    console.error('GET_CUSTOM_API_TOOLS_LIST error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customApiToolsList: [],
        customApiToolsTotal: 0,
        customApiToolsPagination: {},
        customApiToolsLoading: false,
      },
    })
  }
}

// MCP SERVER SAGAS
export function* CREATE_MCP_SERVER({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      createMcpServer,
      payload.data,
      payload.appSettings,
      payload.mcpServerData,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          mcpServersLoading: false,
        },
      })

      // Refresh the MCP servers list after creation
      yield put({
        type: 'apps/GET_MCP_SERVERS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
        },
      })

      message.success('MCP Server created successfully!')
      if (success && success.slug) {
        yield put({
          type: 'apps/ADD_MCP_SERVER_TO_AGENT',
          payload: {
            data: payload.data,
            appSettings: payload.appSettings,
            mcpServerSlug: success.slug,
          },
        })
      }

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('CREATE_MCP_SERVER error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: false,
      },
    })
    message.error('Failed to create MCP Server')
  }
}

export function* UPDATE_MCP_SERVER({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      updateMcpServer,
      payload.data,
      payload.appSettings,
      payload.mcpServerData,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          mcpServersLoading: false,
        },
      })

      // Refresh the MCP servers list after update
      yield put({
        type: 'apps/GET_MCP_SERVERS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
        },
      })

      message.success('MCP Server updated successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('UPDATE_MCP_SERVER error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: false,
      },
    })
    message.error('Failed to update MCP Server')
  }
}

export function* DELETE_MCP_SERVER({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(deleteMcpServer, payload.data, payload.appSettings, payload.slug)

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          mcpServersLoading: false,
        },
      })

      yield put({
        type: 'apps/GET_MCP_SERVERS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
        },
      })
      message.success('MCP Server deleted successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('DELETE_MCP_SERVER error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: false,
      },
    })
    message.error('Failed to delete MCP Server')
  }
}

export function* GET_MCP_SERVERS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const { mcpServersPagination } = reduxStore.getState().apps

    const { paginationType } = payload
    let paginationPayload = ''
    if (
      paginationType === 'next' &&
      mcpServersPagination &&
      mcpServersPagination.next !== undefined
    ) {
      paginationPayload = objectToParams(mcpServersPagination.next)
    } else if (
      paginationType === 'previous' &&
      mcpServersPagination &&
      mcpServersPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(mcpServersPagination.previous)
    }

    const success = yield call(listMcpServers, payload.data, payload.appSettings, paginationPayload)

    if (success && success.data) {
      let totalCount = success.data.length
      let newPaginationMeta = {}

      if (success.meta) {
        newPaginationMeta = success.meta

        if (success.meta.next && success.meta.next.affix !== undefined) {
          // Has next page - show next button by setting total > current items
          totalCount = success.meta.current.limit + 1
        } else if (success.meta.previous && success.meta.previous.affix !== undefined) {
          // No next page but has previous - we're on a middle/last page
          // Ensure total allows previous navigation
          totalCount = success.meta.current.limit + success.data.length
        } else {
          // We're on the first page with no next - total is just current data
          totalCount = success.data.length
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          mcpServersList: success.data,
          mcpServersTotal: totalCount,
          mcpServersPagination: newPaginationMeta,
          mcpServersLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          mcpServersList: [],
          mcpServersTotal: 0,
          mcpServersPagination: {},
          mcpServersLoading: false,
        },
      })
    }
  } catch (error) {
    console.error('GET_MCP_SERVERS_LIST error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        mcpServersList: [],
        mcpServersTotal: 0,
        mcpServersPagination: {},
        mcpServersLoading: false,
      },
    })
  }
}

export function* GET_AVAILABLE_MODELS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        availableModelsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(getAvailableModels, payload.data, payload.appSettings)

    if (success) {
      const modelsData = Array.isArray(success) ? success : success.data || []

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          availableModels: modelsData,
          availableModelsLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          availableModels: [],
          availableModelsLoading: false,
        },
      })
    }
  } catch (error) {
    console.error('GET_AVAILABLE_MODELS error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        availableModels: [],
        availableModelsLoading: false,
      },
    })
  }
}

export function* AI_SEARCH_TOOLS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolsListLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const response = yield call(
      searchTools,
      payload.data,
      payload.appSettings,
      payload.agentUid,
      payload.query,
    )

    if (response?.results) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolsList: response.results,
          aiToolsListLoading: false,
        },
      })
    } else if (response?.data?.results) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolsList: response.data.results,
          aiToolsListLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          aiToolsList: [],
          aiToolsListLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolsList: [],
        aiToolsListLoading: false,
      },
    })
    message.error(error?.response?.data?.message || 'Failed to search tools')
  }
}

export function* GET_ENABLED_ITEMS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        enabledItemsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const response = yield call(
      getEnabledItems,
      payload.data,
      payload.appSettings,
      payload.agentUid,
      {
        tools: payload.tools !== false,
        frontendActions: payload.frontendActions !== false,
        key: payload.query || '',
      },
    )

    const enabledTools = response?.data?.tools || response?.tools || []
    const enabledFrontendActions =
      response?.data?.frontendActions || response?.frontendActions || []
    const enabledApiTools = response?.data?.apiTools || response?.apiTools || []
    const enabledMcpServers = response?.data?.mcpServers || response?.mcpServers || []

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        enabledItems: {
          tools: enabledTools,
          frontendActions: enabledFrontendActions,
          apiTools: enabledApiTools,
          mcpServers: enabledMcpServers,
        },
        enabledItemsLoading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        enabledItems: {
          tools: [],
          frontendActions: [],
          apiTools: [],
          mcpServers: [],
        },
        enabledItemsLoading: false,
      },
    })
    message.error(error?.response?.data?.message || 'Failed to fetch enabled items')
  }
}

export function* ADD_MCP_SERVER_TO_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      addMcpServer,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { mcps: [payload.mcpServerSlug] },
    )

    if (success) {
      // Update activeBuilderAgent in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedMcpServers = [...(currentAgent.mcpServers || []), payload.mcpServerSlug]

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            mcpServers: updatedMcpServers,
          },
        },
      })

      message.success('MCP Server added to agent successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('ADD_MCP_SERVER_TO_AGENT error:', error)
    message.error('Failed to add MCP Server to agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* REMOVE_MCP_SERVER_FROM_AGENT({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    if (!payload.activeBuilderAgent)
      payload.activeBuilderAgent = reduxStore.getState().apps.activeBuilderAgent

    const success = yield call(
      removeMcpServer,
      payload.data,
      payload.appSettings,
      payload.activeBuilderAgent.uid,
      { mcps: [payload.mcpServerSlug] },
    )

    if (success) {
      // Update activeBuilderAgent in Redux state
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      const updatedMcpServers = (currentAgent.mcpServers || []).filter(
        mcpServer => mcpServer !== payload.mcpServerSlug,
      )

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            mcpServers: updatedMcpServers,
          },
        },
      })

      message.success('MCP Server removed from agent successfully!')

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('REMOVE_MCP_SERVER_FROM_AGENT error:', error)
    message.error('Failed to remove MCP Server from agent')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

/* FRONTEND ACTIONS */

export function* FRONTEND_ACTIONS_LIST({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionsLoading: true,
        frontendActionsError: null,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const { frontendActionsPagination } = reduxStore.getState().apps

    let pageNo = payload.currentPage
    if (pageNo === undefined && frontendActionsPagination.current_page !== undefined)
      pageNo = frontendActionsPagination.current_page + 1

    const success = yield call(
      frontendActionsList,
      payload.data,
      payload.appSettings,
      pageNo,
      payload.searchText,
    )

    if (success && success.data) {
      let totalCount = success.data.length
      let newPaginationMeta = {}

      if (success.meta) {
        newPaginationMeta = success.meta
        // Check for totalCount directly in meta (new API format)
        if (success.meta.totalCount !== undefined) {
          ;({ totalCount } = success.meta)
        } else if (success.meta.current && success.meta.current.count !== undefined) {
          // Fallback to current.count if totalCount not available
          totalCount = success.meta.current.count
        } else if (success.meta.pagination && success.meta.pagination.total) {
          // Legacy pagination format
          totalCount = success.meta.pagination.total
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          frontendActionsList: success.data,
          frontendActionsTotal: totalCount,
          frontendActionsPagination: newPaginationMeta,
          frontendActionsLoading: false,
          frontendActionsError: null,
        },
      })

      if (payload.callback) {
        payload.callback(success)
      }
    } else if (success && Array.isArray(success)) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          frontendActionsList: success,
          frontendActionsTotal: success.length,
          frontendActionsPagination: {},
          frontendActionsLoading: false,
          frontendActionsError: null,
        },
      })

      if (payload.callback) {
        payload.callback({ data: success })
      }
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          frontendActionsList: [],
          frontendActionsTotal: 0,
          frontendActionsPagination: {},
          frontendActionsLoading: false,
          frontendActionsError: null,
        },
      })
    }
  } catch (error) {
    console.error('FRONTEND_ACTIONS_LIST error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionsList: [],
        frontendActionsTotal: 0,
        frontendActionsPagination: {},
        frontendActionsLoading: false,
        frontendActionsError: error?.response?.data?.message || 'Failed to load frontend actions',
      },
    })

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* CREATE_FRONTEND_ACTION({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionFormLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      frontendActionsCreate,
      payload.data,
      payload.appSettings,
      payload.formData,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          frontendActionFormLoading: false,
        },
      })

      message.success('Frontend action created successfully!')

      // Refresh the list
      yield put({
        type: 'apps/FRONTEND_ACTIONS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
          agentUid: payload.agentUid,
          currentPage: 1,
        },
      })

      // Call onSuccess callback if provided
      if (payload.onSuccess) {
        payload.onSuccess()
      }

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('CREATE_FRONTEND_ACTION error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionFormLoading: false,
      },
    })
    message.error(error?.response?.data?.message || 'Failed to create frontend action')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* UPDATE_FRONTEND_ACTION({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionFormLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      frontendActionsUpdate,
      payload.data,
      payload.appSettings,
      payload.actionId,
      payload.formData,
    )

    if (success) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          frontendActionFormLoading: false,
        },
      })

      message.success('Frontend action updated successfully!')

      // Refresh the list
      yield put({
        type: 'apps/FRONTEND_ACTIONS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
          agentUid: payload.agentUid,
          currentPage: 1,
        },
      })

      // Call onSuccess callback if provided
      if (payload.onSuccess) {
        payload.onSuccess()
      }

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('UPDATE_FRONTEND_ACTION error:', error)
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionFormLoading: false,
      },
    })
    message.error(error?.response?.data?.message || 'Failed to update frontend action')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* DELETE_FRONTEND_ACTION({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    // Set loading state
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionDeleteLoading: true,
      },
    })

    const success = yield call(
      frontendActionsRemove,
      payload.data,
      payload.appSettings,
      payload.actionId,
    )

    if (success) {
      message.success('Frontend action deleted successfully!')

      // Refresh the list
      yield put({
        type: 'apps/FRONTEND_ACTIONS_LIST',
        payload: {
          data: payload.data,
          appSettings: payload.appSettings,
          agentUid: payload.agentUid,
          currentPage: 1,
        },
      })

      // Call onSuccess callback if provided
      if (payload.onSuccess) {
        payload.onSuccess()
      }

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('DELETE_FRONTEND_ACTION error:', error)
    message.error(error?.response?.data?.message || 'Failed to delete frontend action')

    if (payload.onError) {
      payload.onError(error)
    }
  } finally {
    // Clear loading state
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        frontendActionDeleteLoading: false,
      },
    })
  }
}

export function* TOGGLE_FRONTEND_ACTION({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(
      frontendActionsToggle,
      payload.data,
      payload.appSettings,
      payload.agentUid,
      payload.triggerFunction,
      payload.enabled,
    )

    if (success && success.data) {
      // Only update the frontendActions array within activeBuilderAgent to prevent full re-render
      const currentAgent = reduxStore.getState().apps.activeBuilderAgent
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          activeBuilderAgent: {
            ...currentAgent,
            frontendActions: success.data.frontendActions || [],
          },
        },
      })

      // Show success toast message
      if (payload.enabled) {
        message.success('Frontend action added to agent successfully!')
      } else {
        message.success('Frontend action removed from agent successfully!')
      }

      if (payload.callback) {
        payload.callback(success)
      }
    }
  } catch (error) {
    console.error('TOGGLE_FRONTEND_ACTION error:', error)
    message.error(error?.response?.data?.message || 'Failed to toggle frontend action')

    if (payload.onError) {
      payload.onError(error)
    }
  }
}

export function* GET_AI_ACTION_BUILDER_EDIT_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiActionBuilderEditFormLoading: true,
      aiActionBuilderEditForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      `ai-tools-builder/forms/action-edit/${encodeURIComponent(payload.actionId)}`,
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiActionBuilderEditForm: success,
        isAiActionBuilderEditFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiActionBuilderEditForm: null,
        isAiActionBuilderEditFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_TOOL_BUILDER_CREATE_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiToolBuilderCreateFormLoading: true,
      aiToolBuilderCreateForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      'ai-tools-builder/forms/tool-create',
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiToolBuilderCreateForm: success,
        isAiToolBuilderCreateFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiToolBuilderCreateForm: null,
        isAiToolBuilderCreateFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* GET_AI_ACTION_BUILDER_CREATE_FORM({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      isAiActionBuilderCreateFormLoading: true,
      aiActionBuilderCreateForm: null,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      fetchDynamicData,
      payload.data,
      payload.appSettings,
      'ai-tools-builder/forms/action-create',
    )

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        active: payload.data,
        aiActionBuilderCreateForm: success,
        isAiActionBuilderCreateFormLoading: false,
        loading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiActionBuilderCreateForm: null,
        isAiActionBuilderCreateFormLoading: false,
        loading: false,
      },
    })
  }
}

export function* DELETE_AI_TOOL_BUILDER({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    yield call(aiToolBuilderRemove, payload.data, payload.appSettings, payload.toolName)

    // Get current state
    const currentState = reduxStore.getState().apps
    const updatedToolsBuilderList = (currentState.aiToolsBuilderList || []).filter(
      tool => tool.name !== payload.toolName,
    )
    const updatedTotal = Math.max(0, (currentState.aiToolsBuilderListTotal || 0) - 1)

    // Update state directly instead of refetching
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        aiToolsBuilderList: updatedToolsBuilderList,
        aiToolsBuilderListTotal: updatedTotal,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'AI Tool Builder deleted successfully' },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Failed to delete AI Tool Builder' },
    })
  }
}

export function* ADD_CUSTOM_CATEGORY({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const filtered = {}
    _.filter(payload, function fn(n, k) {
      if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      }
    })

    const success = yield call(addCustomCategory, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: 'apps/FETCH_CUSTOM_CATEGORIES',
        payload: {
          data: activeApp,
          appSettings,
        },
      })
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Custom category added' },
      })
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Some error occurred' },
        })
      }
    }
    return success
  } catch (e) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* FETCH_CUSTOM_CATEGORIES({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        isCustomCategoriesLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(getCustomCategories, payload.data, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          customCategoriesList: success.data,
          loading: false,
          isCustomCategoriesLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          customCategoriesList: [],
          loading: false,
          isCustomCategoriesLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        customCategoriesList: [],
        loading: false,
        isCustomCategoriesLoading: false,
      },
    })
  }
}

export function* DELETE_CUSTOM_CATEGORY({ payload }) {
  try {
    const { id } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
      },
    })

    const success = yield call(deleteCustomCategory, id, activeApp, getAppHost(appSettings))

    if (success.success) {
      yield put({
        type: 'apps/FETCH_CUSTOM_CATEGORIES',
        payload: {
          data: activeApp,
          appSettings,
        },
      })
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: success.message },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (success.error?.code === 'ERR_BAD_REQUEST') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error?.details?.name },
        })
      }
    }
  } catch (e) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* UPDATE_CUSTOM_CATEGORY({ id, payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const filtered = {}
    const unset = []

    _.filter(payload, function fn(n, k) {
      if (k === 'description') {
        filtered[k] = n || ''
      } else if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      } else if (k === 'tags') {
        filtered.tags = []
      } else unset.push(k)
    })

    filtered.unset = unset

    const success = yield call(
      updateCustomCategory,
      id,
      filtered,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data) {
      yield put({
        type: 'apps/FETCH_CUSTOM_CATEGORIES',
        payload: { data: activeApp, appSettings },
      })
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'Custom category updated' },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Some error occurred' },
        })
      }
    }
  } catch (e) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* GET_FLAGGEDBY_USERS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: true,
        isFlaggedByUsersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const { paginationType, pageNo, messageID } = payload

    const logsPagination = reduxStore.getState().apps.flaggedByUsersPagination

    let paginationPayload = ''
    if (paginationType === 'next' && logsPagination && logsPagination.next !== undefined) {
      paginationPayload = objectToParams(logsPagination.next)
    } else if (
      paginationType === 'previous' &&
      logsPagination &&
      logsPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(logsPagination.previous)
    }

    const success = yield call(getFlaggedUsersOfMessage, payload.data, messageID, paginationPayload)

    if (success && success.data) {
      let totalLogCount = success.data.length
      let flaggedByUsersPagination = {}

      if (success.meta) {
        flaggedByUsersPagination = success.meta
        totalLogCount = success.meta.current.limit + 1

        if (pageNo !== undefined && paginationType === undefined && !success.meta?.next?.affix) {
          totalLogCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === undefined &&
          success.meta?.next?.affix === 'append'
        ) {
          totalLogCount = success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta?.next?.affix !== undefined
        ) {
          totalLogCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta?.previous?.affix !== undefined
        ) {
          totalLogCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalLogCount = pageNo * success.meta.current.limit
        }
      }

      yield put({
        type: 'apps/SET_STATE',
        payload: {
          active: payload.data,
          flaggedByUsers: success.data,
          flaggedByUsersTotal: totalLogCount,
          flaggedByUsersPagination,
          loading: false,
          isFlaggedByUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          flaggedByUsers: [],
          flaggedByUsersTotal: 0,
          flaggedByUsersPagination: {},
          loading: false,
          isFlaggedByUsersLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        flaggedByUsers: [],
        flaggedByUsersTotal: 0,
        flaggedByUsersPagination: {},
        loading: false,
        isFlaggedByUsersLoading: false,
      },
    })
  }
}

export function* KNOWLEDGE_BASE_SCRAPE_WEBSITE({ payload }) {
  const { data, appSettings, url } = payload
  const success = yield call(knowledgeBaseScrapeWebsite, data, appSettings, { url })
  if (success) {
    return success.data
  }
}

export function* KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS({ payload }) {
  const { data, appSettings, exclude, parentUniqueId } = payload
  const success = yield call(
    knowledgeBaseProcessDiscoveredUrls,
    data,
    appSettings,
    parentUniqueId,
    { exclude },
  )
  if (success) {
    return success
  }
}

/* AI AGENT CREDITS */

export function* GET_AI_AGENT_CREDITS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentCreditsLoading: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    const response = yield call(aiAgentGetCredits, app)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentCredits: response.data || response,
        areAiAgentCreditsLoading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentCreditsLoading: false },
    })
  }
}

export function* GET_AI_AGENT_CREDITS_SETTINGS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentCreditsSettingsLoading: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    const response = yield call(aiAgentGetCreditsSettings, app)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentCreditsSettings: response.data || response,
        areAiAgentCreditsSettingsLoading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentCreditsSettingsLoading: false },
    })
  }
}

export function* SAVE_AI_AGENT_CREDITS_SETTINGS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentCreditsSettingsSaving: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    const { appId, app: _app, ...settings } = payload
    yield call(aiAgentSaveCreditsSettings, app, settings)

    window.triggerNotification('Credit settings saved successfully', 'success')

    // Refresh settings after save
    yield put({ type: 'apps/GET_AI_AGENT_CREDITS_SETTINGS', payload: { app } })

    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentCreditsSettingsSaving: false },
    })
  } catch (error) {
    window.triggerNotification('Failed to save credit settings', 'error')
    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentCreditsSettingsSaving: false },
    })
  }
}

export function* BUY_AI_AGENT_CREDITS({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentCreditsPurchasing: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    yield call(aiAgentBuyCredits, app, payload.amountUsd)

    window.triggerNotification('Credits purchased successfully', 'success')

    // Refresh credits after purchase
    yield put({ type: 'apps/GET_AI_AGENT_CREDITS', payload: { app } })

    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentCreditsPurchasing: false },
    })
  } catch (error) {
    const errorData = error?.response?.data
    // Failure details may be nested under `error` or sit at the top level.
    const err = errorData?.error || errorData
    const invoiceId = err?.details?.invoiceId || err?.invoiceId

    let errorMessage = err?.message || 'Failed to purchase credits'
    if (!err?.message && invoiceId) {
      errorMessage = 'A previous payment is unresolved. Top-ups are blocked.'
    }
    window.triggerNotification(errorMessage, 'error')

    // Any failure may leave an unpaid invoice, so let the pending-invoice banner re-check.
    const app = payload.app || reduxStore.getState().apps.active
    yield put({ type: 'apps/GET_AI_AGENT_PENDING_INVOICES', payload: { app } })

    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentCreditsPurchasing: false },
    })
  }
}

export function* GET_AI_AGENT_CREDITS_PRICING({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentCreditsPricingLoading: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    const response = yield call(aiAgentGetPricing, app)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentCreditsPricing: response.data || response,
        areAiAgentCreditsPricingLoading: false,
      },
    })
  } catch (error) {
    // Use false (not null) as a sentinel to distinguish "fetch failed" from "never fetched".
    // The component uses null to mean "still loading" and false to mean "loaded but errored".
    yield put({
      type: 'apps/SET_STATE',
      payload: { aiAgentCreditsPricing: false, areAiAgentCreditsPricingLoading: false },
    })
  }
}

export function* GET_AI_AGENT_PENDING_INVOICES({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentPendingInvoicesLoading: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    const response = yield call(aiAgentGetPendingInvoices, app)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentPendingInvoices: response.data || response || [],
        areAiAgentPendingInvoicesLoading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentPendingInvoicesLoading: false },
    })
  }
}

export function* RETRY_AI_AGENT_PAYMENT({ payload }) {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentRetryingPayment: true },
    })

    const app = payload.app || reduxStore.getState().apps.active
    const response = yield call(aiAgentRetryPayment, app, payload.invoiceId)

    if (response.success && response.status === 'paid') {
      window.triggerNotification('Payment collected! Credits have been added.', 'success')
      // Refresh credits and pending invoices
      yield put({ type: 'apps/GET_AI_AGENT_CREDITS', payload: { app } })
      yield put({ type: 'apps/GET_AI_AGENT_PENDING_INVOICES', payload: { app } })
    } else if (response.status === 'payment_due') {
      window.triggerNotification('Payment is still processing. Please try again later.', 'info')
    } else if (response.status === 'payment_failed') {
      window.triggerNotification('Payment failed. The payment provider may still retry.', 'error')
    } else if (response.status === 'not_found') {
      // Invoice not found — refresh pending invoices to clear stale state
      yield put({ type: 'apps/GET_AI_AGENT_PENDING_INVOICES', payload: { app } })
    } else {
      window.triggerNotification('Something went wrong. Please try again.', 'error')
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentRetryingPayment: false },
    })
  } catch (error) {
    window.triggerNotification('Failed to retry payment. Please try again.', 'error')
    yield put({
      type: 'apps/SET_STATE',
      payload: { isAiAgentRetryingPayment: false },
    })
  }
}

export function* GET_AI_AGENT_PLANS() {
  try {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentPlansLoading: true },
    })

    const response = yield call(aiAgentGetPlans)

    yield put({
      type: 'apps/SET_STATE',
      payload: {
        aiAgentPlans: response,
        areAiAgentPlansLoading: false,
      },
    })
  } catch (error) {
    yield put({
      type: 'apps/SET_STATE',
      payload: { areAiAgentPlansLoading: false },
    })
  }
}

/* SUBSCRIBE_AI_AGENT_PLAN — subscribe to an AI agent plan.
 * Mirrors SUBSCRIBE_TO_PLAN (same POST /apps/{id}/subscriptions + app/account refresh) but
 * does NOT open the shared chat `subscriptionSuccess` modal — the AI Plans tab shows its own
 * success modal (with the AI plan name) via the action callback, so the chat-only getPlanName
 * is never used for AI plans. */
export function* SUBSCRIBE_AI_AGENT_PLAN({ payload }) {
  yield put({ type: 'apps/SET_STATE', payload: { loading: true } })

  const activeApp = reduxStore.getState().apps.active
  const success = yield call(subscribe, payload, activeApp)

  if (success && success.data && success.data.link === undefined) {
    // Card on file → subscription completed. Refresh app + account so the UI reflects it.
    const appData = yield call(get, activeApp.id)
    const allApps = reduxStore.getState().apps.data
    const loggedInUser = reduxStore.getState().user
    if (!_.isEmpty(allApps)) {
      const appIndex = _.findIndex(allApps, a => a.id === activeApp.id)
      if (appIndex >= 0) allApps[appIndex] = appData.data
    }

    const currentAccountResponse = yield call(currentAccount, loggedInUser.id)
    if (currentAccountResponse && currentAccountResponse.data) {
      currentAccountResponse.data.authorized = true
      currentAccountResponse.data.loading = false
      currentAccountResponse.data.showOnboarding = false
      yield put({ type: 'user/SET_STATE', payload: currentAccountResponse.data })
    }

    yield put({
      type: 'apps/SET_STATE',
      payload: { active: appData.data, data: allApps, loading: false },
    })

    // Refresh AI credits so the Credits/Plans tabs reflect the new plan.
    yield put({ type: 'apps/GET_AI_AGENT_CREDITS', payload: { app: appData.data } })

    // If the API scheduled an EOT downgrade, show the same "Plan Downgrade request registered"
    // modal used by Chat — reuses the existing modal and language strings.
    if (
      appData.data?.metadata?.planDowngradedTo !== undefined &&
      appData.data?.metadata?.planDowngradedTo
    ) {
      yield put({ type: 'settings/SET_STATE', payload: { visibleModalID: 'subscriptionDowngradedEndOfTerm' } })
    }
  } else if (success && success.data && success.data.link) {
    // No card / ChargeBee hosted flow → expose the link for redirect.
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
        subscribePlanOngoingData: payload,
        subscribePlanOngoingLink: success.data.link,
      },
    })
  } else {
    yield put({ type: 'apps/SET_STATE', payload: { loading: false } })
    const errorMessage = success?.error?.message || 'Subscription failed. Please check your payment method.'
    yield put({ type: 'apps/INITIATE_NOTIFICATION', payload: { type: 'error', message: errorMessage } })
  }

  return success
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LIST, LIST),
    takeEvery(actions.ADD, withCallback(ADD)),
    takeEvery(actions.DELETE, DELETE),
    takeEvery(actions.EDIT, withCallback(EDIT)),
    takeEvery(actions.API_KEYS_LIST, API_KEYS_LIST),
    takeEvery(actions.USERS_LIST, USERS_LIST),
    takeLatest(actions.USERS_COUNT, USERS_COUNT),
    takeEvery(actions.INACTIVE_USERS_LIST, INACTIVE_USERS_LIST),
    takeEvery(actions.ADD_USER, withCallback(ADD_USER)),
    takeEvery(actions.ENTER_USER_TEXT, ENTER_USER_TEXT),
    takeEvery(actions.ENTER_INACTIVE_USER_TEXT, ENTER_INACTIVE_USER_TEXT),
    takeEvery(actions.SEARCH_INACTIVE_USER, SEARCH_INACTIVE_USER),
    takeEvery(actions.SEARCH_USER, SEARCH_USER),
    takeEvery(actions.GET_USER, GET_USER),
    takeEvery(actions.UPDATE_USER, UPDATE_USER),
    takeEvery(actions.DELETE_USER, DELETE_USER),
    takeEvery(actions.DEACTIVATE_USER, DEACTIVATE_USER),
    takeEvery(actions.ACTIVATE_USER, ACTIVATE_USER),
    takeEvery(actions.ROLES_LIST, ROLES_LIST),
    takeEvery(actions.ADD_ROLE, ADD_ROLE),
    takeEvery(actions.ENTER_ROLE_TEXT, ENTER_ROLE_TEXT),
    takeEvery(actions.SEARCH_ROLE, SEARCH_ROLE),
    takeEvery(actions.GET_ROLE, GET_ROLE),
    takeEvery(actions.UPDATE_ROLE, UPDATE_ROLE),
    takeEvery(actions.DELETE_ROLE, DELETE_ROLE),
    takeEvery(actions.GROUPS_LIST, GROUPS_LIST),
    takeEvery(actions.WEBHOOKS_LIST, WEBHOOKS_LIST),
    takeEvery(actions.WEBHOOKS_LIST_NEW, WEBHOOKS_LIST_NEW),
    takeEvery(actions.EXTENSIONS_LIST, EXTENSIONS_LIST),
    takeEvery(actions.UPDATE_ACTIVE_APP, withCallback(UPDATE_ACTIVE_APP)),
    takeEvery(actions.ADD_GROUP, ADD_GROUP),
    takeEvery(actions.GET_GROUP, GET_GROUP),
    takeEvery(actions.UPDATE_GROUP, UPDATE_GROUP),
    takeEvery(actions.DELETE_GROUP, DELETE_GROUP),
    takeEvery(actions.ENTER_GROUP_TEXT, ENTER_GROUP_TEXT),
    takeEvery(actions.SEARCH_GROUP, SEARCH_GROUP),
    takeEvery(actions.GET_GROUP_MEMBERS, GET_GROUP_MEMBERS),
    takeEvery(actions.GET_BANNED_GROUP_MEMBERS, GET_BANNED_GROUP_MEMBERS),
    takeLatest(actions.ENTER_GROUP_MEMBER_TEXT, ENTER_GROUP_MEMBER_TEXT),
    takeEvery(actions.SEARCH_GROUP_MEMBER, SEARCH_GROUP_MEMBER),
    takeEvery(actions.ENTER_BANNED_GROUP_MEMBER_TEXT, ENTER_BANNED_GROUP_MEMBER_TEXT),
    takeEvery(actions.SEARCH_BANNED_GROUP_MEMBER, SEARCH_BANNED_GROUP_MEMBER),
    takeEvery(actions.BAN_GROUP_MEMBER, BAN_GROUP_MEMBER),
    takeEvery(actions.UNBAN_GROUP_MEMBER, UNBAN_GROUP_MEMBER),
    takeEvery(actions.KICK_GROUP_MEMBER, KICK_GROUP_MEMBER),
    takeEvery(actions.ADD_APIKEY, ADD_APIKEY),
    takeEvery(actions.ENTER_APIKEY_TEXT, ENTER_APIKEY_TEXT),
    takeEvery(actions.SEARCH_APIKEY, SEARCH_APIKEY),
    takeEvery(actions.GET_APIKEY, GET_APIKEY),
    takeEvery(actions.UPDATE_APIKEY, UPDATE_APIKEY),
    takeEvery(actions.DELETE_APIKEY, DELETE_APIKEY),
    takeEvery(actions.USER_AUTH_TOKENS_LIST, USER_AUTH_TOKENS_LIST),
    takeEvery(actions.DELETE_USER_AUTH_TOKEN, DELETE_USER_AUTH_TOKEN),
    takeEvery(actions.ADD_USER_AUTH_TOKEN, ADD_USER_AUTH_TOKEN),
    takeEvery(actions.ENTER_UAUTHTOKEN_TEXT, ENTER_UAUTHTOKEN_TEXT),
    takeEvery(actions.SEARCH_UAUTHTOKEN, SEARCH_UAUTHTOKEN),
    takeEvery(actions.UPDATE_USER_FRIENDS, UPDATE_USER_FRIENDS),
    takeEvery(actions.KICK_USER_FROM_GROUP, withCallback(KICK_USER_FROM_GROUP)),
    takeEvery(actions.BAN_USER_FROM_GROUP, withCallback(BAN_USER_FROM_GROUP)),
    takeEvery(actions.ADD_USER_TO_GROUP, withCallback(ADD_USER_TO_GROUP)),
    takeEvery(actions.ENTER_EXTENSION_TEXT, ENTER_EXTENSION_TEXT),
    takeEvery(actions.CHANGE_EXTENSION_STATUS, CHANGE_EXTENSION_STATUS),
    takeEvery(actions.ENABLE_DISABLE_EXTENSION, ENABLE_DISABLE_EXTENSION),
    takeEvery(actions.ADD_WEBHOOK, ADD_WEBHOOK),
    takeEvery(actions.UPDATE_WEBHOOK, withCallback(UPDATE_WEBHOOK)),
    takeEvery(actions.GET_WEBHOOK, GET_WEBHOOK),
    takeEvery(actions.DELETE_WEBHOOK, DELETE_WEBHOOK),
    takeEvery(actions.CHANGE_WEBHOOK_STATUS, CHANGE_WEBHOOK_STATUS),
    takeEvery(actions.ADD_WEBHOOK_NEW, ADD_WEBHOOK_NEW),
    takeEvery(actions.UPDATE_WEBHOOK_NEW, withCallback(UPDATE_WEBHOOK_NEW)),
    takeEvery(actions.GET_WEBHOOK_NEW, GET_WEBHOOK_NEW),
    takeEvery(actions.DELETE_WEBHOOK_NEW, DELETE_WEBHOOK_NEW),
    takeEvery(actions.CHANGE_WEBHOOK_STATUS_NEW, CHANGE_WEBHOOK_STATUS_NEW),
    takeEvery(actions.TRIGGERS_LIST, TRIGGERS_LIST),
    takeEvery(actions.TRIGGERS_LIST_NEW, TRIGGERS_LIST_NEW),
    takeEvery(actions.SUBSCRIBE_TO_PLAN, withCallback(SUBSCRIBE_TO_PLAN)),
    takeEvery(actions.UNSUBSCRIBE_TO_PLAN, withCallback(UNSUBSCRIBE_TO_PLAN)),
    takeEvery(actions.UNSUBSCRIBE_TO_PLAN_ENDPOINT, withCallback(UNSUBSCRIBE_TO_PLAN_ENDPOINT)),
    takeEvery(actions.SUBSCRIBE_MODAL_PROCEED, withCallback(SUBSCRIBE_MODAL_PROCEED)),
    takeEvery(actions.SAVE_APP_SETTINGS, SAVE_APP_SETTINGS),
    takeEvery(actions.SAVE_APP_MESSAGE_SETTINGS, SAVE_APP_MESSAGE_SETTINGS),
    takeEvery(actions.GET_APP_SETTINGS, GET_APP_SETTINGS),
    takeEvery(actions.GET_APP_MESSAGE_SETTINGS, GET_APP_MESSAGE_SETTINGS),
    takeEvery(actions.STRIPE_CHECKOUT_1, withCallback(STRIPE_CHECKOUT_1)),
    takeEvery(actions.STRIPE_CHECKOUT_2, withCallback(STRIPE_CHECKOUT_2)),
    takeEvery(actions.STRIPE_GOTO_CHECKOUT, withCallback(STRIPE_GOTO_CHECKOUT)),
    takeEvery(actions.RESUBSCRIBE, withCallback(RESUBSCRIBE)),
    takeEvery(actions.CANCEL_DOWNGRADE_EOT, withCallback(CANCEL_DOWNGRADE_EOT)),
    takeEvery(actions.REMOVE_ACTIVE_APP, REMOVE_ACTIVE_APP),
    takeEvery(
      actions.MODERATION_APPROVE_FLAGGED_MESSAGE,
      withCallback(MODERATION_APPROVE_FLAGGED_MESSAGE),
    ),
    takeEvery(
      actions.CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT,
      withCallback(CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT),
    ),
    takeEvery(
      actions.CALL_SLACK_SUPPORT_MANUAL_INTENT,
      withCallback(CALL_SLACK_SUPPORT_MANUAL_INTENT),
    ),
    takeEvery(
      actions.CALL_AGENTIC_PRICING_CONTACT_US,
      withCallback(CALL_AGENTIC_PRICING_CONTACT_US),
    ),
    takeEvery(
      actions.IMPORT_USERS_REQUEST_MANUAL_INTENT,
      withCallback(IMPORT_USERS_REQUEST_MANUAL_INTENT),
    ),
    takeEvery(
      actions.UNREAD_BADGE_COUNT_TOGGLE_REQUEST_MANUAL_INTENT,
      withCallback(UNREAD_BADGE_COUNT_TOGGLE_REQUEST_MANUAL_INTENT),
    ),
    takeEvery(
      actions.SUBSCRIBE_CUSTOM_PLAN_REQUEST_MANUAL_INTENT,
      withCallback(SUBSCRIBE_CUSTOM_PLAN_REQUEST_MANUAL_INTENT),
    ),
    takeEvery(actions.CHECK_IF_CUSTOM_PLAN, withCallback(CHECK_IF_CUSTOM_PLAN)),
    takeEvery(actions.GET_MESSAGE_LOGS, withCallback(GET_MESSAGE_LOGS)),
    takeEvery(actions.GET_MESSAGE_CATEGORIES, withCallback(GET_MESSAGE_CATEGORIES)),
    takeEvery(actions.GET_CALL_LOGS, withCallback(GET_CALL_LOGS)),
    takeEvery(actions.GET_CALL_LOGS_LEGACY, withCallback(GET_CALL_LOGS_LEGACY)),
    takeEvery(
      actions.GET_CALL_SESSION_PARTICIPANT_DETAILS,
      withCallback(GET_CALL_SESSION_PARTICIPANT_DETAILS),
    ),
    // Moderation
    takeEvery(actions.GET_MOD_MESSAGE_LOGS, withCallback(GET_MOD_MESSAGE_LOGS)),
    takeEvery(actions.APPROVE_MOD_MESSAGE, APPROVE_MOD_MESSAGE),
    takeEvery(actions.REJECT_MOD_MESSAGE, REJECT_MOD_MESSAGE),
    takeEvery(actions.USER_GROUPS_LIST, USER_GROUPS_LIST),
    takeEvery(actions.SEARCH_USER_GROUP, SEARCH_USER_GROUP),
    takeEvery(actions.ENTER_USER_GROUP_TEXT, ENTER_USER_GROUP_TEXT),
    takeEvery(actions.CHANGE_MEMBER_SCOPE, withCallback(CHANGE_MEMBER_SCOPE)),
    takeEvery(actions.DELETE_MESSAGE_LOG, DELETE_MESSAGE_LOG),
    takeEvery(actions.CHAT_WIDGETS_LIST, withCallback(CHAT_WIDGETS_LIST)),
    takeEvery(actions.ADD_CHAT_WIDGET, withCallback(ADD_CHAT_WIDGET)),
    takeEvery(actions.GET_CHAT_WIDGET, GET_CHAT_WIDGET),
    takeEvery(actions.UPDATE_CHAT_WIDGET, withCallback(UPDATE_CHAT_WIDGET)),
    takeEvery(actions.DELETE_GROUP_MESSAGE_LOG, DELETE_GROUP_MESSAGE_LOG),
    takeEvery(actions.GROUPS_LIST_FOR_MODERATION, GROUPS_LIST_FOR_MODERATION),
    takeEvery(actions.ENTER_GROUP_TEXT_FOR_MODERATION, ENTER_GROUP_TEXT_FOR_MODERATION),
    takeEvery(actions.SEARCH_GROUP_FOR_MODERATION, SEARCH_GROUP_FOR_MODERATION),
    takeEvery(actions.GET_GROUP_FOR_MODERATION, GET_GROUP_FOR_MODERATION),
    takeEvery(actions.GET_GROUP_MESSAGE_LOGS, withCallback(GET_GROUP_MESSAGE_LOGS)),
    takeEvery(actions.TEAM_COLLABORATOR_LIST, TEAM_COLLABORATOR_LIST),
    takeEvery(actions.TEAM_COLLABORATOR_INVITE, withCallback(TEAM_COLLABORATOR_INVITE)),
    takeEvery(actions.TEAM_COLLABORATOR_REMOVE, TEAM_COLLABORATOR_REMOVE),
    takeEvery(actions.TEAM_TRANSFER_OWNERSHIP, TEAM_TRANSFER_OWNERSHIP),
    takeEvery(actions.TEAM_COLLABORATOR_CHANGE_ROLE, withCallback(TEAM_COLLABORATOR_CHANGE_ROLE)),
    takeEvery(actions.TEAM_COLLABORATOR_LEAVE, withCallback(TEAM_COLLABORATOR_LEAVE)),
    takeEvery(actions.ENTER_TEAM_COLLABORATOR_TEXT, ENTER_TEAM_COLLABORATOR_TEXT),
    takeEvery(actions.SEARCH_TEAM_COLLABORATOR, SEARCH_TEAM_COLLABORATOR),
    takeEvery(actions.USER_FRIENDS_LIST, USER_FRIENDS_LIST),
    takeEvery(actions.SEARCH_USER_FRIEND, SEARCH_USER_FRIEND),
    takeEvery(actions.ENTER_USER_FRIEND_TEXT, ENTER_USER_FRIEND_TEXT),
    takeEvery(actions.ADD_FRIEND_TO_USER, withCallback(ADD_FRIEND_TO_USER)),
    takeEvery(actions.UNFRIEND_USER, withCallback(UNFRIEND_USER)),
    takeEvery(actions.GET_METRICS, withCallback(GET_METRICS)),
    takeEvery(actions.SEARCH_APP, SEARCH_APP),
    takeEvery(actions.CLEAR_APP_SEARCH, CLEAR_APP_SEARCH),
    takeEvery(actions.ENTER_APP_TEXT, ENTER_APP_TEXT),
    takeEvery(actions.GET_MESSAGE_SEARCH_LOGS, withCallback(GET_MESSAGE_SEARCH_LOGS)),
    takeEvery(actions.ROLES_PERMISSIONS_LIST, ROLES_PERMISSIONS_LIST),
    takeEvery(actions.GET_ROLE_RESTRICTIONS, GET_ROLE_RESTRICTIONS),
    takeEvery(actions.DELETE_ROLE_RESTRICTION, DELETE_ROLE_RESTRICTION),
    takeEvery(actions.ADD_ROLE_RESTRICTION, ADD_ROLE_RESTRICTION),
    takeEvery(actions.ROLES_PERMISSIONS_V2_LIST, ROLES_PERMISSIONS_V2_LIST),
    takeEvery(actions.ROLES_PERMISSIONS_V2_VALUES_GET, ROLES_PERMISSIONS_V2_VALUES_GET),
    takeEvery(actions.ROLES_PERMISSIONS_V2_UPDATE, ROLES_PERMISSIONS_V2_UPDATE),
    takeEvery(actions.ROLES_PERMISSIONS_V2_RESET, ROLES_PERMISSIONS_V2_RESET),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_LIST, GROUP_SCOPE_PERMISSIONS_LIST),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_VALUES_GET, GROUP_SCOPE_PERMISSIONS_VALUES_GET),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_UPDATE, GROUP_SCOPE_PERMISSIONS_UPDATE),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_RESET, GROUP_SCOPE_PERMISSIONS_RESET),
    takeEvery(actions.UPDATE_SUBSCRIBE_DOWNGRADE_EOT, UPDATE_SUBSCRIBE_DOWNGRADE_EOT),
    takeEvery(actions.UPDATE_APP_STATE, UPDATE_APP_STATE),
    takeEvery(
      actions.APP_MIGRATION_REQUEST_MANUAL_INTENT,
      withCallback(APP_MIGRATION_REQUEST_MANUAL_INTENT),
    ),
    takeEvery(actions.RESTORE_DELETED_APP_REQUEST, withCallback(RESTORE_DELETED_APP_REQUEST)),
    takeEvery(
      actions.UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT,
      withCallback(UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT),
    ),
    takeEvery(
      actions.UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT,
      withCallback(UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT),
    ),
    takeEvery(actions.GET_MESSAGE_EXPORT_LOGS, withCallback(GET_MESSAGE_EXPORT_LOGS)),
    takeEvery(actions.GET_USAGE_AND_OVERAGES, withCallback(GET_USAGE_AND_OVERAGES)),
    takeEvery(actions.GET_INSIGHTS_DATA, withCallback(GET_INSIGHTS_DATA)),
    takeEvery(actions.DOWNLOAD_CALL_RECORDING, DOWNLOAD_CALL_RECORDING),
    takeEvery(actions.DOWNLOAD_CALL_RECORDING_LEGACY, DOWNLOAD_CALL_RECORDING_LEGACY),
    takeEvery(actions.GET_METRICS_BY_FILTER, withCallback(GET_METRICS_BY_FILTER)),
    takeEvery(actions.GET_MESSAGE_BY_ID, withCallback(GET_MESSAGE_BY_ID)),
    takeEvery(actions.GET_CALL_BY_ID, GET_CALL_BY_ID),
    takeEvery(actions.GET_CALL_BY_ID_LEGACY, GET_CALL_BY_ID_LEGACY),
    takeEvery(actions.ADD_MEMBERS_TO_GROUP, withCallback(ADD_MEMBERS_TO_GROUP)),
    takeEvery(actions.INITIATE_NOTIFICATION, INITIATE_NOTIFICATION),
    takeEvery(actions.RESET_NOTIFICATION, RESET_NOTIFICATION),
    takeEvery(actions.SHOW_INTENT_REQUEST, SHOW_INTENT_REQUEST),
    takeEvery(actions.HIDE_INTENT_REQUEST, HIDE_INTENT_REQUEST),
    takeEvery(actions.NON_PARTICIPANTS_LIST, NON_PARTICIPANTS_LIST),
    takeEvery(actions.SEARCH_NON_PARTICIPANT, SEARCH_NON_PARTICIPANT),
    takeEvery(actions.ENTER_NON_PARTICIPANT_TEXT, ENTER_NON_PARTICIPANT_TEXT),
    takeEvery(actions.ENTER_USER_FRIEND_LIST_TEXT, ENTER_USER_FRIEND_LIST_TEXT),
    takeEvery(actions.SEARCH_USER_FRIEND_LIST, SEARCH_USER_FRIEND_LIST),
    takeEvery(actions.ENTER_USER_GROUP_LIST_TEXT, ENTER_USER_GROUP_LIST_TEXT),
    takeEvery(actions.SEARCH_GROUP_FRIEND_LIST, SEARCH_GROUP_FRIEND_LIST),
    takeEvery(actions.NON_USER_FRIEND_LIST_MODAL, NON_USER_FRIEND_LIST_MODAL),
    takeEvery(actions.ENTER_NON_FRIEND_LIST_TEXT, ENTER_NON_FRIEND_LIST_TEXT),
    takeEvery(actions.SEARCH_NON_FRIEND_LIST_MODAL, SEARCH_NON_FRIEND_LIST_MODAL),
    takeEvery(actions.NON_USER_GROUP_LIST_MODAL, NON_USER_GROUP_LIST_MODAL),
    takeEvery(actions.ENTER_NON_GROUP_LIST_TEXT, ENTER_NON_GROUP_LIST_TEXT),
    takeEvery(actions.SEARCH_NON_GROUP_LIST_MODAL, SEARCH_NON_GROUP_LIST_MODAL),
    takeEvery(actions.SHOW_IMPORT_USER_REQUEST, SHOW_IMPORT_USER_REQUEST),
    takeEvery(actions.ADD_APP_ON_ONBOARDING, withCallback(ADD_APP_ON_ONBOARDING)),
    takeEvery(actions.MODERATION_LIST_RULES, withCallback(MODERATION_LIST_RULES)),
    takeEvery(
      actions.MODERATION_LIST_DROPPED_MESSAGES,
      withCallback(MODERATION_LIST_DROPPED_MESSAGES),
    ),
    takeEvery(
      actions.MODERATION_LIST_FLAGGED_MESSAGES,
      withCallback(MODERATION_LIST_FLAGGED_MESSAGES),
    ),
    takeEvery(
      actions.MODERATION_LIST_REVIEWED_MESSAGES,
      withCallback(MODERATION_LIST_REVIEWED_MESSAGES),
    ),
    takeEvery(actions.MODERATION_GET_RULE, MODERATION_GET_RULE),
    takeEvery(
      actions.MODERATION_GET_RULE_AND_RULE_REVISIONS,
      withCallback(MODERATION_GET_RULE_AND_RULE_REVISIONS),
    ),
    takeEvery(actions.MODERATION_DELETE_RULE, MODERATION_DELETE_RULE),
    takeEvery(actions.MODERATION_DELETE_KEYWORD, MODERATION_DELETE_KEYWORD),
    takeEvery(actions.CHANGE_MODERATION_RULE_STATUS, CHANGE_MODERATION_RULE_STATUS),
    takeEvery(actions.MODERATION_LIST_KEYWORDS, withCallback(MODERATION_LIST_KEYWORDS)),
    takeEvery(actions.MODERATION_ADD_KEYWORD, withCallback(MODERATION_ADD_KEYWORD)),
    takeEvery(actions.MODERATION_GET_KEYWORD, withCallback(MODERATION_GET_KEYWORD)),
    takeEvery(actions.MODERATION_UPDATE_KEYWORD, withCallback(MODERATION_UPDATE_KEYWORD)),
    takeEvery(actions.MODERATION_LIST_CONFIGURATION, withCallback(MODERATION_LIST_CONFIGURATION)),
    takeEvery(actions.MODERATION_ADD_RULE, withCallback(MODERATION_ADD_RULE)),
    takeEvery(actions.MODERATION_UPDATE_RULE, withCallback(MODERATION_UPDATE_RULE)),
    takeEvery(
      actions.MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS,
      withCallback(MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS),
    ),
    takeEvery(
      actions.MODERATION_ACCEPT_FLAGGED_MESSAGE,
      withCallback(MODERATION_ACCEPT_FLAGGED_MESSAGE),
    ),
    takeEvery(
      actions.MODERATION_BLOCK_FLAGGED_MESSAGE,
      withCallback(MODERATION_BLOCK_FLAGGED_MESSAGE),
    ),
    takeEvery(
      actions.MODERATION_BAN_FLAGGED_MESSAGE_SENDER,
      withCallback(MODERATION_BAN_FLAGGED_MESSAGE_SENDER),
    ),
    takeEvery(actions.UPDATE_APP_SETTINGS, UPDATE_APP_SETTINGS),
    takeEvery(actions.GTM_TRIGGERED_MANUAL_INTENT, withCallback(GTM_TRIGGERED_MANUAL_INTENT)),
    takeEvery(actions.UPDATE_MODERATION_GLOBAL_SETTINGS, UPDATE_MODERATION_GLOBAL_SETTINGS),
    takeEvery(actions.GET_MODERATION_GLOBAL_SETTINGS, GET_MODERATION_GLOBAL_SETTINGS),
    // AI Agents watchers
    takeEvery(actions.AI_AGENTS_LIST, AI_AGENTS_LIST),
    takeEvery(actions.DELETE_AI_AGENT, DELETE_AI_AGENT),
    takeEvery(actions.EDIT_AI_AGENT, EDIT_AI_AGENT),
    takeEvery(actions.GET_AI_AGENT_CREATE_FORM, GET_AI_AGENT_CREATE_FORM),
    takeEvery(actions.GET_AI_AGENT_EDIT_FORM, GET_AI_AGENT_EDIT_FORM),
    takeEvery(actions.GET_AI_AGENT_INTEGRATIONS, GET_AI_AGENT_INTEGRATIONS),
    // AI Tools watchers
    takeEvery(actions.AI_TOOLS_LIST, AI_TOOLS_LIST),
    takeEvery(actions.GET_AI_TOOL_EDIT_FORM, GET_AI_TOOL_EDIT_FORM),
    takeEvery(actions.GET_AI_ACTION_EDIT_FORM, GET_AI_ACTION_EDIT_FORM),
    takeEvery(actions.GET_AI_TOOL_CREATE_FORM, GET_AI_TOOL_CREATE_FORM),
    takeEvery(actions.GET_AI_ACTION_CREATE_FORM, GET_AI_ACTION_CREATE_FORM),
    takeEvery(actions.DELETE_AI_TOOL, DELETE_AI_TOOL),
    // AI Actions watchers (separate from tools)
    takeEvery(actions.AI_ACTIONS_LIST, AI_ACTIONS_LIST),
    takeEvery(actions.DELETE_AI_ACTION, DELETE_AI_ACTION),

    // AI Agents Builder sagas
    takeEvery(actions.AI_AGENTS_BUILDER_LIST, AI_AGENTS_BUILDER_LIST),
    takeEvery(actions.GET_AI_AGENT_BUILDER, GET_AI_AGENT_BUILDER),
    takeEvery(actions.ADD_AI_AGENT_BUILDER, ADD_AI_AGENT_BUILDER),
    takeEvery(actions.DELETE_AI_AGENT_BUILDER, DELETE_AI_AGENT_BUILDER),
    takeEvery(actions.EDIT_AI_AGENT_BUILDER, EDIT_AI_AGENT_BUILDER),
    // takeEvery(actions.GET_AI_AGENT_BUILDER_CREATE_FORM, GET_AI_AGENT_BUILDER_CREATE_FORM),
    // takeEvery(actions.GET_AI_AGENT_BUILDER_EDIT_FORM, GET_AI_AGENT_BUILDER_EDIT_FORM),
    // takeEvery(actions.GET_AI_AGENT_BUILDER_INTEGRATIONS, GET_AI_AGENT_BUILDER_INTEGRATIONS),

    // AI Tools Builder sagas
    takeEvery(actions.AI_TOOLS_BUILDER_LIST, AI_TOOLS_BUILDER_LIST),
    takeEvery(actions.GET_AI_TOOL_BUILDER_EDIT_FORM, GET_AI_TOOL_BUILDER_EDIT_FORM),
    takeEvery(actions.GET_AI_ACTION_BUILDER_EDIT_FORM, GET_AI_ACTION_BUILDER_EDIT_FORM),
    takeEvery(actions.GET_AI_TOOL_BUILDER_CREATE_FORM, GET_AI_TOOL_BUILDER_CREATE_FORM),
    takeEvery(actions.GET_AI_ACTION_BUILDER_CREATE_FORM, GET_AI_ACTION_BUILDER_CREATE_FORM),
    takeEvery(actions.DELETE_AI_TOOL_BUILDER, DELETE_AI_TOOL_BUILDER),
    takeEvery(actions.GET_AI_TOOL_ACTIONS, GET_AI_TOOL_ACTIONS),
    takeEvery(actions.CREATE_CUSTOM_API_TOOL, CREATE_CUSTOM_API_TOOL),
    takeEvery(actions.UPDATE_CUSTOM_API_TOOL, UPDATE_CUSTOM_API_TOOL),
    takeEvery(actions.DELETE_CUSTOM_API_TOOL, DELETE_CUSTOM_API_TOOL),
    takeEvery(actions.GET_CUSTOM_API_TOOLS_LIST, GET_CUSTOM_API_TOOLS_LIST),
    takeEvery(actions.ADD_API_TOOL_TO_AGENT, ADD_API_TOOL_TO_AGENT),
    takeEvery(actions.REMOVE_API_TOOL_FROM_AGENT, REMOVE_API_TOOL_FROM_AGENT),
    // MCP Server sagas
    takeEvery(actions.CREATE_MCP_SERVER, CREATE_MCP_SERVER),
    takeEvery(actions.UPDATE_MCP_SERVER, UPDATE_MCP_SERVER),
    takeEvery(actions.DELETE_MCP_SERVER, DELETE_MCP_SERVER),
    takeEvery(actions.GET_MCP_SERVERS_LIST, GET_MCP_SERVERS_LIST),
    takeEvery(actions.GET_AVAILABLE_MODELS, GET_AVAILABLE_MODELS),
    takeLatest(actions.AI_SEARCH_TOOLS_LIST, AI_SEARCH_TOOLS_LIST),
    takeLatest(actions.GET_ENABLED_ITEMS, GET_ENABLED_ITEMS),
    takeEvery(actions.ADD_MCP_SERVER_TO_AGENT, ADD_MCP_SERVER_TO_AGENT),
    takeEvery(actions.REMOVE_MCP_SERVER_FROM_AGENT, REMOVE_MCP_SERVER_FROM_AGENT),
    takeEvery(actions.ADD_TOOL_TO_AGENT, ADD_TOOL_TO_AGENT),
    takeEvery(actions.REMOVE_TOOL_FROM_AGENT, REMOVE_TOOL_FROM_AGENT),
    takeEvery(actions.SYSTEM_TOOLS_LIST, SYSTEM_TOOLS_LIST),
    takeEvery(actions.ADD_SYSTEM_TOOL_TO_AGENT, ADD_SYSTEM_TOOL_TO_AGENT),
    takeEvery(actions.REMOVE_SYSTEM_TOOL_FROM_AGENT, REMOVE_SYSTEM_TOOL_FROM_AGENT),
    // AI Agent Credits sagas
    takeLatest(actions.GET_AI_AGENT_CREDITS, GET_AI_AGENT_CREDITS),
    takeLatest(actions.GET_AI_AGENT_CREDITS_SETTINGS, GET_AI_AGENT_CREDITS_SETTINGS),
    takeEvery(actions.SAVE_AI_AGENT_CREDITS_SETTINGS, SAVE_AI_AGENT_CREDITS_SETTINGS),
    takeEvery(actions.BUY_AI_AGENT_CREDITS, BUY_AI_AGENT_CREDITS),
    takeLatest(actions.GET_AI_AGENT_CREDITS_PRICING, GET_AI_AGENT_CREDITS_PRICING),
    takeLatest(actions.GET_AI_AGENT_PENDING_INVOICES, GET_AI_AGENT_PENDING_INVOICES),
    takeEvery(actions.RETRY_AI_AGENT_PAYMENT, RETRY_AI_AGENT_PAYMENT),
    takeLatest(actions.GET_AI_AGENT_PLANS, GET_AI_AGENT_PLANS),
    takeEvery(actions.SUBSCRIBE_AI_AGENT_PLAN, withCallback(SUBSCRIBE_AI_AGENT_PLAN)),
    // Frontend Actions sagas
    takeEvery(actions.FRONTEND_ACTIONS_LIST, withCallback(FRONTEND_ACTIONS_LIST)),
    takeEvery(actions.CREATE_FRONTEND_ACTION, withCallback(CREATE_FRONTEND_ACTION)),
    takeEvery(actions.UPDATE_FRONTEND_ACTION, withCallback(UPDATE_FRONTEND_ACTION)),
    takeEvery(actions.DELETE_FRONTEND_ACTION, withCallback(DELETE_FRONTEND_ACTION)),
    takeEvery(actions.TOGGLE_FRONTEND_ACTION, withCallback(TOGGLE_FRONTEND_ACTION)),

    takeLatest(actions.BUILDER_GET, withCallback(BUILDER_GET)),
    takeEvery(actions.BUILDER_UPDATE, withCallback(BUILDER_UPDATE)),
    takeLatest(actions.BUILDER_ADD, withCallback(BUILDER_ADD)),
    takeLatest(actions.BUILDER_LIST, withCallback(BUILDER_LIST)),
    takeLatest(actions.AGENT_BUILDER_LIST, withCallback(AGENT_BUILDER_LIST)),
    takeLatest(actions.BUILDER_RESET, withCallback(BUILDER_RESET)),
    takeEvery(actions.NOTIFICATION_LOGS, withCallback(NOTIFICATION_LOGS)),
    takeEvery(actions.MULTITENANT_GET_USAGE, withCallback(MULTITENANT_GET_USAGE)),
    takeEvery(
      actions.UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR,
      UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR,
    ),
    takeEvery(actions.AI_AGENT_USER_LIST, AI_AGENT_USER_LIST),
    takeLatest(actions.GET_KNOWLEDGE_BASE_LIST, GET_KNOWLEDGE_BASE_LIST),
    takeLatest(actions.GET_KNOWLEDGE_BASE_DETAILS, GET_KNOWLEDGE_BASE_DETAILS),
    takeLatest(actions.DELETE_KNOWLEDGE_BASE_ITEM, withCallback(DELETE_KNOWLEDGE_BASE_ITEM)),
    takeLatest(actions.SYNC_KNOWLEDGE_BASE_ITEM, SYNC_KNOWLEDGE_BASE_ITEM),
    takeEvery(
      actions.GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD,
      withCallback(GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD),
    ),
    takeEvery(
      actions.KNOWLEDGE_BASE_CREATE_TEXT_ITEM,
      withCallback(KNOWLEDGE_BASE_CREATE_TEXT_ITEM),
    ),
    takeEvery(
      actions.KNOWLEDGE_BASE_UPDATE_TEXT_ITEM,
      withCallback(KNOWLEDGE_BASE_UPDATE_TEXT_ITEM),
    ),
    takeEvery(
      actions.KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK,
      withCallback(KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK),
    ),
    takeEvery(actions.KNOWLEDGE_BASE_SCRAPE_WEBSITE, withCallback(KNOWLEDGE_BASE_SCRAPE_WEBSITE)),
    takeLatest(
      actions.KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS,
      withCallback(KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS),
    ),
    takeLatest(actions.SYNC_DISCOVERED_URLS, withCallback(SYNC_DISCOVERED_URLS)),
    takeEvery(actions.KNOWLEDGE_BASE_GET_ITEM, KNOWLEDGE_BASE_GET_ITEM),
    takeEvery(
      actions.ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT,
      withCallback(ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT),
    ),
    takeEvery(
      actions.REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT,
      withCallback(REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT),
    ),
    takeEvery(actions.ADD_CUSTOM_CATEGORY, withCallback(ADD_CUSTOM_CATEGORY)),
    takeEvery(actions.FETCH_CUSTOM_CATEGORIES, FETCH_CUSTOM_CATEGORIES),
    takeEvery(actions.DELETE_CUSTOM_CATEGORY, withCallback(DELETE_CUSTOM_CATEGORY)),
    takeEvery(actions.UPDATE_CUSTOM_CATEGORY, withCallback(UPDATE_CUSTOM_CATEGORY)),
    takeEvery(actions.GET_FLAGGEDBY_USERS, withCallback(GET_FLAGGEDBY_USERS)),
    APPS_LIST(), // run once on app load to check user auth
  ])
}
